import { FETCH_LANG_SUCCESS } from "../constants/ActionTypes";

const initialState = {
  translate: {
    "ISA_%orBath": "% หรือบาท",
    ISA_ARPurchase: "รับชำระ",
    ISA_ARReport: "รายงานลูกหนี้การค้า",
    ISA_AR_FailMessageNotSameCustomer: "กรุณาเลือกลูกค้าหรือพนักงานขายเดียวกัน",
    ISA_AR_PleaseSelectItemsToPay:
      "กรุณาเลือกรายการที่ต้องชำระเงิน หรือยอดการชำระเงินไม่ถูกต้อง",
    ISA_ASP: "ราคาขายเฉลี่ย",
    ISA_Active: "ใช้งาน",
    ISA_ActualCountDate: "วันที่นับจริง",
    ISA_Actual: "ยอดขายจริง",
    ISA_ActualSales: "เดือนนี้",
    ISA_AutoGenerate: "(ระบบสร้างให้อัตโนมัติ)",
    ISA_AddContact: "เพิ่มผู้ติดต่อ",
    ISA_AddCustomers: "เพิ่มลูกค้า",
    ISA_AddNNEW: "เพิ่มใหม่",
    ISA_AddProduct: "เพิ่มรายการสินค้า",
    ISA_AddSequence: "เพิ่มส่วนลด",
    ISA_Address: "ที่อยู่*",
    ISA_AddressShipTo: "สถานที่ส่ง",
    ISA_AdjustStockRequestReport: "ปรับปรุงสต็อก",
    ISA_AdminReg_Salesman: "Salesman",
    ISA_Alert_OrderNumber: "เลขที่ใบสั่งซื้อ",
    ISA_All: "ทั้งหมด",
    ISA_AllMKTEvents: "กิจกรรมการตลาด",
    ISA_AllProductSet: "สินค้าร่วมรายการ",
    ISA_AUTO_ISMART_AI_TITLE: "ISmart AI",
    ISA_AUTO_ISMART_AI_ASK_PLANTRIP:
      "คุณต้องการให้ iSmart AI คัดเลือกลูกค้าสำหรับสร้าง Plantrip หรือไม่?",
    ISA_CrossSellingAmountCurrentMonth: "Cross Selling Amount (Current Month)",
    ISA_TotalSales_2: "% Total Sales",
    ISA_CrossSellingAmountPreviousMonth:
      "Cross Selling Amount (Previous Month)",
    ISA_GrowthPreviousMonth: "% Growth (Previous Month)",
    ISA_AUTO_3294931F: "Exc.VAT",
    ISA_AUTO_409B0D79: "Inc.VAT",
    ISA_AUTO_516CB52D: "Inc.Vat",
    ISA_AUTO_8DDF7753: "Exc.Vat",
    ISA_AUTO_MAILBOX_FOLDERS: "mailbox folders",
    ISA_AUTO_LATITUDE: "ละติจูด:",
    ISA_AUTO_LONGITUDE: "ลองจิจูด:",
    ISA_AUTO_PLEASE_ENTER_SUP_INV_NUMBER: "กรุณาระบุเลขที่ Sup_Invoice",
    ISA_AUTO_PLEASE_ENTER_SUP_INV_DATE: "กรุณาระบุวันที่ Sup_Invoice",
    ISA_AUTO_PLEASE_ENTER_PRODUCT_QTY: "กรุณาระบุจำนวนสินค้า",
    ISA_AUTO_PLEASE_SELECT_SHIP_DATE: "กรุณาเลือกวันที่จัดส่ง",
    ISA_AUTO_PLEASE_ENTER_LOT: "กรุณาระบุ Lot",
    ISA_AUTO_PLEASE_ENTER_MFG_DATE: "กรุณาระบุวันที่ผลิต",
    ISA_AUTO_PLEASE_ENTER_EXP_DATE: "กรุณาระบุวันหมดอายุ",
    ISA_AUTO_PLEASE_ENTER_PRICE: "กรุณาระบุราคาสินค้าให้ถูกต้อง",
    ISA_AUTO_GALLERY_PHOTOS: "แกลเลอรี่รูปภาพ",
    ISA_AUTO_GALLERY: "แกลเลอรี่",
    ISA_LeadInbox: "กล่องข้อความลูกค้า",
    ISA_LeadInbox_Amount: "มูลค่าโดยประมาณ",
    ISA_LeadInbox_AnotherOwnerWarning:
      "ส่งข้อความแล้ว — แต่ lead นี้มีเซลส์คนอื่นรับผิดชอบอยู่ ระวังตอบซ้ำกัน",
    ISA_LeadInbox_Cancel: "ยกเลิก",
    ISA_LeadInbox_BlockedWarning:
      "ลูกค้ารายนี้บล็อก LINE OA หรือเลิกเป็นเพื่อนแล้ว — ข้อความที่ส่งจะไม่ถึงปลายทาง และ LINE จะไม่แจ้งว่าล้มเหลว (ระบบจะยังขึ้นว่าส่งแล้ว)",
    ISA_LeadInbox_Channel: "ช่องทาง",
    ISA_LeadInbox_ChatName: "ชื่อในแชท",
    ISA_LeadInbox_CloseDate: "คาดว่าจะปิดได้",
    ISA_LeadInbox_ComposerPlaceholder: "พิมพ์ข้อความ… (Enter = ส่ง, Shift+Enter = ขึ้นบรรทัดใหม่)",
    ISA_LeadInbox_ContactInfo: "ข้อมูลผู้ติดต่อ",
    ISA_LeadInbox_ContactName: "ชื่อผู้ติดต่อ",
    ISA_LeadInbox_ContactSaved: "บันทึกข้อมูลติดต่อแล้ว",
    ISA_LeadInbox_ConvertAction: "แปลงเป็นงานใน Sales Pipeline",
    ISA_LeadInbox_ConvertAgain: "สร้างงานใหม่จากแชทนี้",
    ISA_LeadInbox_ConvertAgainTitle: "สร้างงานใหม่จากแชทนี้",
    ISA_LeadInbox_ConvertResult: "ผลการแปลง",
    ISA_LeadInbox_ConvertStep1: "1. เคยเป็นลูกค้าอยู่แล้วหรือไม่",
    ISA_LeadInbox_ConvertStep2: "2. รายละเอียดงาน",
    ISA_LeadInbox_ConvertTitle: "แปลง lead เป็นงานใน Sales Pipeline",
    ISA_LeadInbox_ConvertedLocked: "lead ที่แปลงแล้วเปลี่ยนสถานะกลับไม่ได้ เพราะงานใน pipeline ผูกอยู่",
    ISA_LeadInbox_ConvertedNote: "แปลงเป็นงานใน Sales Pipeline แล้ว",
    ISA_LeadInbox_CreateProspect: "สร้างเป็นว่าที่ลูกค้าใหม่",
    ISA_LeadInbox_CreateProspectHint:
      "ระบบจะสร้างรายชื่อในทะเบียนว่าที่ลูกค้าให้ พร้อมผูกกับงานที่สร้าง",
    ISA_LeadInbox_CreateProject: "สร้างงาน",
    ISA_LeadInbox_Creating: "กำลังสร้าง...",
    ISA_LeadInbox_Customer: "ลูกค้า",
    ISA_LeadInbox_DefaultFromChannel: "ไม่กรอก = ใช้ค่าตั้งต้นของ channel",
    ISA_LeadInbox_DetailTip: "ข้อมูลติดต่อและการแปลงเป็นงาน",
    ISA_LeadInbox_Email: "อีเมล",
    ISA_LeadInbox_Empty: "ยังไม่มีลูกค้าทักเข้ามา",
    ISA_LeadInbox_FirstContact: "ทักครั้งแรก",
    ISA_LeadInbox_FromChannel: "จากช่องทางแชท",
    ISA_LeadInbox_GoToProject: "ไปที่งาน",
    ISA_LeadInbox_Ignore: "พักไว้ก่อน",
    ISA_LeadInbox_InternalNote: "บันทึกภายใน",
    ISA_LeadInbox_InvalidEmail: "รูปแบบอีเมลไม่ถูกต้อง",
    ISA_LeadInbox_InvalidTaxNumber: "เลขประจำตัวผู้เสียภาษีต้องมี 13 ตัวพอดี",
    ISA_LeadInbox_LastRepliedBy: "ตอบล่าสุดโดย",
    ISA_LeadInbox_LoadMore: "โหลดเพิ่ม",
    ISA_LeadInbox_LoadOlder: "ดูข้อความก่อนหน้า",
    ISA_LeadInbox_Loading: "กำลังโหลด...",
    ISA_LeadInbox_MatchFields: "ข้อมูลที่ใช้จับคู่ลูกค้า",
    ISA_LeadInbox_MatchedName: "ชื่อคล้าย",
    ISA_LeadInbox_MatchedPhone: "เบอร์ตรง",
    ISA_LeadInbox_MatchedTax: "เลขภาษีตรง",
    ISA_LeadInbox_Name: "ชื่อ",
    ISA_LeadInbox_NoChannelWarning: "บริษัทนี้ยังไม่ได้ลงทะเบียนช่องทาง LINE/Facebook — จะไม่มีข้อความเข้ามาและตอบกลับไม่ได้จนกว่าจะตั้งค่าช่องทาง",
    ISA_LeadInbox_NotSpecified: "ไม่ระบุ",
    ISA_LeadInbox_NoCustomer: "ยังไม่ระบุลูกค้า",
    ISA_LeadInbox_NoCustomerHint: "สร้างงานไว้ก่อน ค่อยผูกลูกค้าทีหลังในหน้า pipeline",
    ISA_LeadInbox_NoMatchHint: "ไม่พบลูกค้าที่ตรงกับเกณฑ์ — ถ้าเป็นลูกค้าใหม่จริง ให้สร้างที่หน้าลูกค้าก่อนแล้วกลับมาแปลง หรือเลือก \"ยังไม่ระบุลูกค้า\" ไปก่อน",
    ISA_LeadInbox_NoMatchHint2:
      "ไม่พบลูกค้าที่ตรงกับเกณฑ์ — ถ้าเป็นลูกค้าใหม่จริง ใช้ \"สร้างเป็นว่าที่ลูกค้าใหม่\" ได้เลย ไม่ต้องไปสร้างที่หน้าลูกค้าก่อน",
    ISA_LeadInbox_NoMessages: "ยังไม่มีข้อความในบทสนทนานี้",
    ISA_LeadInbox_NoName: "(ไม่ทราบชื่อ)",
    ISA_LeadInbox_ImageFromCustomer: "รูปจากลูกค้า",
    ISA_LeadInbox_NoResult: "ไม่พบ lead ตามเงื่อนไขที่กรอง",
    ISA_LeadInbox_PendingTip: "ยังไม่ยืนยันว่าถึงลูกค้าแล้ว — ระบบกำลังส่งหรือส่งค้างอยู่",
    ISA_LeadInbox_Phone: "เบอร์โทร",
    ISA_LeadInbox_ProfileUpdated: "อัปเดตโปรไฟล์แล้ว",
    ISA_LeadInbox_ProjectCreated: "สร้างงานแล้ว",
    ISA_LeadInbox_ProjectName: "ชื่องาน",
    ISA_LeadInbox_ProjectNumber: "เลขที่งาน",
    ISA_LeadInbox_OpenChat: "เปิดห้องแชทต้นทาง",
    ISA_LeadInbox_OpenLineConsole: "เปิด LINE Developers Console",
    ISA_LeadInbox_OpenMetaConsole: "เปิด Meta for Developers",
    ISA_LeadInbox_PreviewYou: "คุณ",
    ISA_LeadInbox_ProjectStatus: "สถานะงาน",
    ISA_LeadInbox_ProspectName: "ชื่อว่าที่ลูกค้า",
    ISA_LeadInbox_RefreshProfileTip: "ดึงชื่อ/รูปล่าสุดจาก LINE",
    ISA_LeadInbox_Remarks: "หมายเหตุ",
    ISA_LeadInbox_RemarksHint: "ไม่กรอก = ระบบใส่ที่มาจากแชทให้",
    ISA_LeadInbox_Retryable: "ลองใหม่อีกครั้งได้",
    ISA_LeadInbox_Salesman: "ผู้รับผิดชอบ (รหัสเซลส์)",
    ISA_LeadInbox_SaveContact: "บันทึกข้อมูลติดต่อ",
    ISA_LeadInbox_Saving: "กำลังบันทึก...",
    ISA_LeadInbox_SearchAgain: "ค้นหาอีกครั้ง",
    ISA_LeadInbox_SearchPlaceholder: "ค้นชื่อ / เบอร์โทร",
    ISA_LeadInbox_SelectLead: "เลือกลูกค้าทางซ้ายเพื่อดูบทสนทนา",
    ISA_LeadInbox_Send: "ส่ง",
    ISA_LeadInbox_SendFailed: "ส่งไม่สำเร็จ",
    ISA_LeadInbox_Stage: "ขั้นตอนการขาย (stage)",
    ISA_LeadInbox_StatusAll: "ทั้งหมด",
    ISA_LeadInbox_StatusConverted: "แปลงแล้ว",
    ISA_LeadInbox_StatusFollowsStage: "ไม่เลือก = ตามขั้นตอนการขายที่เลือก",
    ISA_LeadInbox_StatusIgnored: "พักไว้",
    ISA_LeadInbox_StatusNew: "ใหม่",
    ISA_LeadInbox_TaxNumber: "เลขประจำตัวผู้เสียภาษี",
    ISA_LeadInbox_TaxShort: "เลขภาษี",
    ISA_LeadInbox_Unignore: "นำกลับมาที่รายการใหม่",
    ISA_LeadInbox_UnknownType: "ไม่ทราบชนิด",
    // ── แผงตั้งค่าช่องทาง (LINE/Facebook) ──
    ISA_LeadInbox_AccessToken: "Access Token",
    ISA_LeadInbox_Back: "ย้อนกลับ",
    ISA_LeadInbox_ChannelActive: "เปิดใช้งาน",
    ISA_LeadInbox_ChannelAdd: "เพิ่มช่องทาง",
    ISA_LeadInbox_ChannelDialogTitle: "จัดการช่องทาง",
    ISA_LeadInbox_ChannelId: "Channel ID",
    ISA_LeadInbox_ChannelInactive: "ปิดใช้งาน",
    ISA_LeadInbox_ChannelNotSet: "ยังไม่ได้ตั้งค่า",
    ISA_LeadInbox_ChannelSaved: "บันทึกช่องทางแล้ว",
    ISA_LeadInbox_ChannelSecret: "Channel Secret",
    ISA_LeadInbox_ChannelType: "ประเภทช่องทาง",
    ISA_LeadInbox_Copied: "คัดลอกแล้ว",
    ISA_LeadInbox_Copy: "คัดลอก",
    ISA_LeadInbox_CurrentValueMasked: "ค่าปัจจุบัน",
    ISA_LeadInbox_DefaultSalesmanHint: "lead ใหม่จากช่องทางนี้จะได้ผู้รับผิดชอบคนนี้เป็นค่าตั้งต้น",
    ISA_LeadInbox_DefaultStageHint: "lead ใหม่จากช่องทางนี้จะได้ขั้นตอนการขายนี้เป็นค่าตั้งต้น",
    ISA_LeadInbox_DestinationId: "Destination ID",
    ISA_LeadInbox_DestinationIdHint: "ระบุถ้าผู้ให้บริการกำหนดมาให้ ไม่บังคับ",
    ISA_LeadInbox_KeepExistingSecret: "เว้นว่างไว้ = ใช้ค่าเดิม",
    ISA_LeadInbox_ManageChannel: "ตั้งค่าช่องทาง",
    ISA_LeadInbox_SecretRequired: "จำเป็นต้องกรอกตอนสร้างใหม่",
    ISA_LeadInbox_WebhookAfterSave: "จะได้ webhook URL ให้คัดลอกหลังบันทึกครั้งแรก",
    ISA_LeadInbox_WebhookHint: "นำ URL นี้ไปตั้งค่าใน LINE Developers Console หรือ Meta for Developers",
    ISA_LeadInbox_WebhookUrl: "Webhook URL",
    ISA_LoadingChart: "กำลังโหลดกราฟ",
    ISA_AUTO_CURRENT: "ปัจจุบัน",
    // ISA_AUTO_LAST: "ก่อนหน้า", // REMOVED: Use ISA_Previous instead
    ISA_AUTO_PERCENT_TARGET: "%เป้าหมาย",
    ISA_Amount: "จำนวนเงิน (Amount)",
    "ISA_Amount(Baht)": "จำนวนเงิน (บาท)",
    ISA_AmountBaht: "จำนวนเงิน (บาท)",
    ISA_AmoutBeforeVAT: "จำนวนเงิน (ก่อน VAT)",
    ISA_Pareto_Title: "การวิเคราะห์ปาเรโต",
    ISA_Pareto_Explanation:
      "กฎ 80/20 ของ Pareto\n\nที่มา: กฎ 80/20 ถูกคิดค้นโดย วิลเฟรโด ปาเรโต นักเศรษฐศาสตร์ชาวอิตาลี ที่สังเกตว่า ประมาณ 80% ของทรัพย์สินในอิตาลีเป็นของคนเพียง 20% ตั้งแต่นั้นแนวคิดนี้ก็ถูกนำไปใช้ในหลายด้าน ทั้งธุรกิจ การจัดการเวลา และการพัฒนาประสิทธิภาพ\n\nแนวคิด: ผลลัพธ์ส่วนใหญ่ (ประมาณ 80%) มักมาจากสาเหตุเพียงเล็กน้อย (ประมาณ 20%) ในบริบทของธุรกิจ หมายความว่า ลูกค้าเพียง 20% ของคุณ มักสร้างรายได้ถึง 80% ของบริษัท\n\nจุดประสงค์ / ประโยชน์:\n\nช่วยให้ธุรกิจ โฟกัสกับลูกค้าหลัก ที่สร้างรายได้สูงสุด\nใช้ เวลาและทรัพยากรอย่างคุ้มค่า\nช่วยตัดสินใจได้ดีขึ้นทั้งเรื่องการตลาด การขาย และการบริหารลูกค้า",
    "ISA_AnalysisbyCustomer/Product": "วิเคราะห์ขาย ลูกค้า",
    "ISA_AnalysisbyProduct/Customer": "วิเคราะห์ขาย สินค้า",
    ISA_Approval: "การอนุมัติ",
    ISA_Approved: "อนุมัติ",
    ISA_AuditLog: "Audit Log",
    ISA_ViewEditHistory: "ดูประวัติการแก้ไข",
    ISA_ApproveDate: "วันที่อนุมัติ",
    ISA_ApproveDoc: "อนุมัติเอกสาร",
    ISA_April: "เมษายน",
    ISA_Agreement: "อ้างอิงข้อตกลงการขาย",
    ISA_August: "สิงหาคม",
    ISA_AvailableQuantity: "จำนวนคงเหลือ",
    ISA_Baht: "บาท",
    ISA_Because: "เพราะว่า",
    ISA_ConfirmDelete: "ยืนยันการลบ?",
    ISA_PleaseWaitProcessing: "กรุณารอสักครู่ ระบบกำลังประมวลผลข้อมูล...",
    ISA_OriginalAmount: "ยอดเดิม",
    ISA_Paid: "ชำระ",
    ISA_PaidAmount: "Paid",
    ISA_PayAmount: "จำนวนชำระ",
    ISA_AP_NoSupplierCode: "ไม่พบ SupplierCode กรุณากลับไปเลือกเอกสารใหม่",
    ISA_BeforePaidAmount: "ค้างชำระ",
    ISA_BillDate: "วันที่บิล (BillDate)",
    ISA_BillNo: "เลขที่บิล (BillNo)",
    ISA_ApproveBy: "อนุมัติโดย",
    ISA_ApproveByName: "ผู้อนุมัติ",
    ISA_ApproveDateTime: "อนุมัติวัน/เวลา",
    ISA_ApprovalDateTime: "วันเวลาอนุมัติ",
    ISA_ByKeyword: "โดยคำค้นหา",
    ISA_CSHBill: "ใบเสร็จรับเงิน",
    ISA_CanNotRollbackIfDelete: "การลบไม่สามารถย้อนคืนได้!",
    ISA_OperationSuccess: "ดำเนินการสำเร็จ",
    ISA_AUTO_DELETE_FILE: "ลบไฟล์",
    ISA_AUTO_CHECK_FILE_FORMAT: "กรุณาตรวจสอบรูปแบบไฟล์ก่อนนำเข้า",
    ISA_AUTO_UPLOAD_PARTIAL: "บางไฟล์อัปโหลดไม่สำเร็จ: ",
    ISA_AUTO_UPLOAD_FAILED: "การอัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง",
    ISA_AUTO_DELETE_ITEM: "ลบรายการ",
    ISA_AUTO_CANNOT_DELETE_DUE_HEADER: "ไม่สามารถลบได้เนื่องจากมีเลขที่ชุด",
    ISA_AUTO_VIEW_ONLY: "ดูรายการ (View Only)",
    ISA_DataSavedSuccess: "บันทึกข้อมูลเรียบร้อยแล้ว",
    ISA_Cancel: "ยกเลิก",
    ISA_Cancel1: "ยกเลิก",
    ISA_CancelRejectDoc: "ยกเลิกการไม่อนุมัติเอกสาร",
    ISA_SystemWillChangeRejectToPending:
      'ระบบจะเปลี่ยนสถานะจาก "ไม่อนุมัติ" เป็น "รอดำเนินการ"',
    ISA_CanProcessDocAgain: "สามารถดำเนินการกับเอกสารนี้ได้อีกครั้ง",
    ISA_CancelRejectSuccess: "ยกเลิกสถานะไม่อนุมัติสำเร็จ!",
    ISA_DocChangedToPending: 'เอกสารได้ถูกเปลี่ยนเป็นสถานะ "รอดำเนินการ" แล้ว',
    ISA_ClickToCancelReject: "กดเพื่อยกเลิกการไม่อนุมัติ",
    ISA_ClickToProcessStatus: "กดเพื่อดำเนินการตามสถานะ",
    ISA_CannotCancelReject: "ไม่สามารถยกเลิกสถานะไม่อนุมัติได้",
    ISA_CannotDelete: "ไม่สามารถลบได้",
    ISA_CannotDeleteDocWithStatus: "ไม่สามารถลบเอกสารที่มีสถานะดังต่อไปนี้",
    ISA_CannotEdit: "ไม่สามารถแก้ไขได้",
    ISA_CannotEditDocWithStatus:
      "เอกสารนี้อยู่ในสถานะที่ไม่สามารถแก้ไขได้ สามารถแก้ไขได้เฉพาะเอกสารที่อยู่ในสถานะ 'รออนุมัติ' เท่านั้น",
    ISA_CannotGetDynamicFields: "ไม่สามารถดึงข้อมูลไดนามิคฟิลด์จากเอกสารต้นฉบับได้",
    ISA_CashDiscount: "ส่วนลดเงินสด",
    ISA_WebUserGroup: "กลุ่มผู้ใช้เว็บ",
    ISA_Channel: "ช่องทาง",
    ISA_ChangeStatus: "การเปลี่ยนสถานะ",
    ISA_Changes: "ขาด/เกิน",
    ISA_ChangesWillBeLostEdit: "คำเตือน",
    ISA_ChequeDate: "วันที่เช็ค (ChequeDate)",
    ISA_ChequeNo: "เลขที่เช็ค (ChequeNo)",
    ISA_Choose: "เลือก",
    ISA_ChooseProduct: "กรุณาเลือกสินค้า",
    ISA_ProductNameRequired: "กรุณาเลือกชื่อสินค้า",
    ISA_SearchProduct: "ค้นหาสินค้า",
    ISA_AllProducts: "สินค้าทั้งหมด",
    ISA_ProductsInStock: "สินค้าที่มีในคลัง",
    ISA_SelectFromWarehouse: "เลือกคลังจ่าย",
    ISA_SelectToWarehouse: "เลือกคลังรับ",
    ISA_SelectType: "เลือกประเภท",
    ISA_SearchProductCodeOrName: "ค้นหารหัสสินค้าหรือชื่อสินค้า...",
    ISA_LoadingProducts: "กำลังโหลดสินค้า...",
    ISA_NoProductsFound: "ไม่พบสินค้า",
    ISA_No: "No",
    ISA_NumberCustomerOrder: "เลขที่ใบสั่งซื้อลูกค้า",
    ISA_NumberReturn: "เลขที่ใบคืนลูกค้า",
    ISA_PleaseSelectFromWarehouse: "กรุณาเลือกคลังจ่ายก่อน",
    ISA_TryChangeSearchCondition: "ลองเปลี่ยนเงื่อนไขการค้นหา",
    ISA_Company: "บริษัท",
    ISA_Complete: "เรียบร้อยแล้ว",
    ISA_Error_NoPermissionAccess:
      "ไม่มีสิทธิ์เข้าถึงหน้าที่ต้องการ กรุณาแจ้ง Admin เพื่อเพิ่มสิทธิ์!",
    ISA_ReportOrderTransaction_ErrorExport: "เกิดข้อผิดพลาดในการ Export",
    ISA_ReturnCancel_Success: "ยกเลิกใบคืนเรียบร้อย",
    ISA_CannotDeleteData: "ไม่สามารถลบข้อมูลได้",
    ISA_CannotCopyData: "ไม่สามารถคัดลอกข้อมูลได้",
    ISA_CannotImport: "ไม่สามารถ Import ได้",
    ISA_CannotImportColumnOver: "ไม่สามารถ Import ได้ เนื่องจาก Column เกิน",
    ISA_CannotImportColumnMissing:
      "ไม่สามารถ Import ได้ เนื่องจาก Column ไม่ครบ",
    ISA_Delete: "ลบ",
    ISA_RegisterTrial_Fail: "การลงทะเบียนล้มเหลว",
    ISA_RegisterTrial_ConnectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อ: ",
    ISA_NoPermission_Title: "ไม่มีสิทธิ์",
    ISA_NoPermission_ApproveAP: "คุณไม่มีสิทธิ์อนุมัติเอกสาร (AP)",
    ISA_NoPermission_CreateAP: "คุณไม่มีสิทธิ์สร้างเอกสาร (AP)",
    ISA_CreateDocSuccess: "สร้างเอกสารสำเร็จ",
    ISA_Completed: "เรียบร้อย",
    ISA_ConfirmCompleteDoc: "ยืนยันทำให้เอกสารเสร็จสมบูรณ์",
    ISA_MakeDocComplete: "ทำให้เอกสาร",
    ISA_ToCompleteStatus: "เป็นสถานะเสร็จสมบูรณ์ใช่หรือไม่?",
    ISA_SystemWillCompleteDoc: "ระบบจะทำให้เอกสารนี้เป็นสถานะ Completed",
    ISA_CannotEditAfterComplete:
      "จะไม่สามารถแก้ไขเอกสารนี้ได้อีกหลังจากดำเนินการ",
    ISA_CompletedStatus: "เป็นสถานะเสร็จสมบูรณ์แล้ว",
    ISA_ConSection1: "ข้อมูลเพิ่มเติม",
    ISA_Condition: "เงื่อนไข",
    ISA_ConfirmCancelTitle: "ยืนยันการยกเลิก",
    ISA_ConfirmChangeStatusTo: "ต้องการเปลี่ยนสถานะเป็น",
    ISA_ConfirmCreateInvoiceQuestion: "คุณต้องการสร้างใบแจ้งหนี้นี้หรือไม่?",
    ISA_ConfirmDeleteProductQuestion: "คุณต้องการลบสินค้านี้ออกจากรายการหรือไม่?",
    ISA_ConfirmSubmitDocQuestion: "คุณต้องการยืนยันและส่งเอกสารหรือไม่?",
    ISA_ContactNo: "เบอร์โทร",
    ISA_ContactPerson: "ผู้ติดต่อ",
    ISA_Copy: "สำเนา",
    ISA_CopyQuotationDocHeader: "ต้องการสร้างเป็นเอกสารใหม่ ใช่หรือไม่ ?",
    ISA_CreditLimit: "วงเงินทั้งหมด",
    ISA_CreditNoteReport: "ใบลดหนี้",
    ISA_CreditType: "ประเภทเครดิต",
    ISA_Currency: "สกุลเงิน",
    ISA_CurrencyRate: "อัตราแลกเปลี่ยน",
    ISA_Customer: "ลูกค้า",
    ISA_CustomerCode: "รหัสลูกค้า",
    ISA_CustomerIndividual: "รายลูกค้า",
    ISA_CustomerName: "ชื่อลูกค้า",
    ISA_CustomerOrder: "ซื้อสินค้า",
    ISA_CustomerType: "ประเภทลูกค้า",
    ISA_Customer_List: "รายชื่อลูกค้า",
    ISA_Customers: "ราย",
    ISA_CustTelNo: "โทรศัพท์",
    ISA_NoOfCustomer: "จำนวนลูกค้า",
    ISA_Date: "วันที่",
    ISA_DateBetween: "ระหว่างวันที่",
    ISA_DateCustomerOrder: "วันที่ใบสั่งซื้อลูกค้า",
    ISA_DateMonthYear: "วัน เดือน ปี",
    ISA_DateReturn: "วันที่ใบคืนลูกค้า",
    ISA_BuyerName: "ชื่อผู้ซื้อสินค้า",
    ISA_Data: "Data:",
    ISA_Days: "วัน",
    ISA_December: "ธันวาคม",
    ISA_DeleteDoc: "ลบเอกสาร",
    ISA_ConfirmDeleteDocText:
      "คุณต้องการลบเอกสารนี้ใช่หรือไม่? การลบจะไม่สามารถกู้คืนได้",
    ISA_DeletingDoc: "กำลังลบเอกสาร...",
    ISA_DeleteDocSuccess: "ลบเอกสารสำเร็จ!",
    ISA_DeleteDocError: "เกิดข้อผิดพลาดในการลบเอกสาร",
    ISA_CannotDeleteDoc: "ไม่สามารถลบเอกสารได้",
    ISA_InvalidDocNumberToDelete: "ไม่พบเลขที่เอกสารที่ถูกต้องให้ลบ",
    ISA_NoDocToDelete: "ไม่พบเอกสารที่สามารถลบได้",
    ISA_PleaseSelectDocAgain: "กรุณาเลือกเอกสารใหม่อีกครั้ง",
    ISA_PleaseSelectYesNo: "กรุณาเลือกใช่หรือไม่",
    ISA_ConfirmDeleteDocs: "ยืนยันลบเอกสาร",
    ISA_DeleteDocFailed: "ลบเอกสารล้มเหลว",
    ISA_StockCountDeleteTitle: "ลบข้อมูลใบนับสต็อก",
    ISA_DeleteDocConfirmPrefix: "ต้องการลบข้อมูลเอกสารจำนวน",
    ISA_DeleteWarningTitle: "คำเตือน : หากคุณยืนยันลบเอกสารแล้ว",
    ISA_DeleteWarningText: "ข้อมูลทั้งหมดจะไม่สามารถกู้คืนได้อีก",
    ISA_CannotDeleteSomeDocs: "ไม่สามารถลบเอกสารบางรายการได้",
    ISA_DeletedDocsCount: "ลบเอกสารจำนวน",
    ISA_ItemsCompleted: "รายการเรียบร้อยแล้ว",
    ISA_ItemSavedSuccessfully: "บันทึกรายการเรียบร้อยแล้ว",
    ISA_ItemUpdatedSuccessfully: "อัพเดทรายการเรียบร้อยแล้ว",
    ISA_DocSubmittedSuccessfully: "ยืนยันและส่งเอกสารเรียบร้อยแล้ว",
    ISA_CannotChangeSupplierHasProducts:
      "ไม่สามารถเปลี่ยนซัพพลายเออร์ได้เนื่องจากมีสินค้าในรายการ กรุณาลบสินค้าออกก่อน",
    ISA_CannotDeleteDocTryAgain: "ไม่สามารถลบเอกสารได้ กรุณาลองใหม่อีกครั้ง",
    ISA_DeleteSelected: "ลบที่เลือก",
    ISA_ViewAuditLog: "ดู Audit Log",
    ISA_CannotDeleteHasHeaderID:
      "ไม่สามารถลบได้ เนื่องจากรายการนี้มีเลขที่ชุดแล้ว",
    ISA_CannotDeleteHasHeaderIDMultiple:
      "ไม่สามารถลบได้ เนื่องจากมีรายการที่มีเลขที่ชุดแล้ว",
    ISA_PleaseSelectItemsToDelete: "กรุณาเลือกรายการที่ต้องการลบ",
    ISA_PleaseSelectItemsToExport: "กรุณาเลือกรายการที่ต้องการส่งออก",
    ISA_ExcelExportSuccess: "ส่งออกไฟล์ Excel สำเร็จ",
    ISA_ExcelExportSuccessAll: "ส่งออกไฟล์ Excel ทั้งหมดสำเร็จ",
    ISA_ExcelExportError: "เกิดข้อผิดพลาดในการส่งออกไฟล์ Excel",
    ISA_DeleteData: "ต้องการลบข้อมูล?",
    ISA_DeliveryDate: "กำหนดส่งของ",
    ISA_Group_Name: "ชื่อกลุ่ม",
    ISA_Group_Status: "สถานะกลุ่ม",
    "ISA_DeliveryDate(LT": "วันที่ส่ง (ปกติ",
    ISA_Department: "แผนก",
    ISA_Message: "ข้อความ",
    ISA_DiffAmount: "ส่วนต่าง",
    ISA_Discount: "ส่วนลด",
    ISA_DiscountAmountLabel: "จำนวนส่วนลด",
    ISA_DiscountCannotExceedTotal: "จำนวนส่วนลด",
    ISA_DiscountDeletedSuccess: "ลบส่วนลดเรียบร้อยแล้ว",
    ISA_DiscountFooter: "ส่วนลดท้ายบิล",
    ISA_DiscountHeader: "รายการส่วนลด",
    ISA_DiscountTypeLabel: "ประเภทส่วนลด",
    ISA_DiscountTypeName: "ชื่อประเภทส่วนลด",
    ISA_Distance: "ระยะห่าง",
    ISA_DocAmountBeforeVat: "ยอดก่อน VAT",
    ISA_DocCustomer: "ผู้จัดจำหน่าย",
    ISA_DocDate: "ข้อมูลวันที่",
    ISA_DocManagement: "การจัดการ",
    ISA_DocNumber: "เลขที่เอกสาร",
    ISA_DocNumberReceive: "เลขที่Receive",
    ISA_DocOrderDate: "วันที่ใบสั่งซื้อ",
    ISA_DocOrderNumber: "เลขที่ใบสั่งซื้อ",
    ISA_DocRefNumber: "อ้างอิง SupplierPR",
    ISA_DocStatus: "สถานะเอกสาร",
    ISA_DocReasonReject: "เหตุผลการยกเลิก",
    ISA_DocReceiptInvoice: "Invoice",
    ISA_DocReceiptPayment: "วิธีการชำระเงิน",
    ISA_DocTotalReceipt: "จำนวนเงินรวม",
    ISA_DocTransactionDate: "วันที่โอนข้อมูล",
    ISA_DocStatusMessage01_2: "ไม่สามารถ คัดลอก(Copy) !!",
    ISA_DocumentAttechFileTitle: "แนบไฟล์",
    ISA_DocumentDate: "เอกสารวันที่",
    ISA_DocumentList: "รายการเอกสาร",
    ISA_DocumentStatus: "สถานะเอกสาร",
    ISA_Documents: "เอกสาร",
    ISA_Draft: "ร่าง",
    ISA_DraftSavedSuccess: "บันทึกฉบับร่างเรียบร้อยแล้ว",
    ISA_CreateDocFromDraft: "สร้างเอกสารจากฉบับร่าง",
    ISA_DocWillChangeStatusDraftToBlock:
      "เอกสารจะถูกเปลี่ยนสถานะจาก Draft เป็น Block",
    ISA_DocReadyForApproval: "เอกสารจะพร้อมสำหรับการอนุมัติ",
    ISA_StatusChangedDraftToBlock: "เปลี่ยนสถานะจาก Draft เป็น Block แล้ว",
    ISA_DueDate: "วันกำหนดชำระ (DueDate)",
    ISA_Edit: "แก้ไข",
    ISA_EditData: "ต้องปรับปรุง",
    ISA_EditDocumentSuccess: "ทำการแก้ไขเอกสารเรียบร้อย",
    ISA_Email: "อีเมล์",
    ISA_Code: "รหัส",
    ISA_DocInfo: "ข้อมูลเอกสาร",
    ISA_ProductList: "รายการสินค้า",
    ISA_AddItem: "เพิ่มรายการ",
    ISA_SelectLocation: "เลือกตำแหน่ง",
    ISA_PleaseSelectLocation: "กรุณาเลือกตำแหน่ง",
    ISA_EndDate: "วันที่สิ้นสุด",
    ISA_EnterRemarkIfAny: "กรอกหมายเหตุ (ถ้ามี)",
    ISA_ERPCustomers: "ลูกค้า ERP",
    ISA_ErrorOccurred: "เกิดข้อผิดพลาด",
    ISA_ErrorGeneratePDF: "เกิดข้อผิดพลาดในการสร้าง PDF",
    ISA_ExpDate: "วันที่หมดอายุ",
    ISA_ExpEntryMessage1: "ไม่สามารถบันทึกข้อมูล :",
    ISA_ExpEntryMessage2: "บันทึกข้อมูล เรียบร้อย",
    ISA_ExportData: "นำออกข้อมูล",
    ISA_ExportExcel: "Export Excel",
    "ISA_ExportOrder,Returned,Stock": "ส่งออก รายการ ซื้อ คืน สต็อค อื่นๆ",
    ISA_February: "กุมภาพันธ์",
    "ISA_FirstName-FamilyName": "ชื่อ-นามสกุล",
    ISA_FormNetTotal: "ยอดเงินสุทธิ",
    ISA_FormReturn: "ใบแจ้งรับคืนสินค้า",
    ISA_FormSto: "ใบนับสต๊อก",
    ISA_FormVAT: "ภาษีมูลค่าเพิ่ม",
    ISA_FilterSearch: "ค้นหาข้อมูล",
    ISA_FreeItem: "สินค้าแถม",
    ISA_FromDate: "จากวันที่",
    ISA_FromPlant: "คลังจ่าย",
    ISA_GoodProduct: "สินค้าดี",
    ISA_DamagedProduct: "สินค้าเสีย",
    ISA_GrandTotal: "รวมทั้งสิ้น",
    ISA_HistoricalVisiting: "ประวัติการเข้าเยี่ยม",
    ISA_Action: "การดำเนินการ",
    ISA_AUTO_UPDATE_DOC: "อัปเดตเอกสาร",
    ISA_AUTO_EDIT_DOC: "แก้ไขเอกสาร",
    ISA_AUTO_ACTION: "ดำเนินการ",
    ISA_Add: "เพิ่ม",
    ISA_Address1: "ประเทศ*",
    ISA_Address3: "เขต/อำเภอ",
    ISA_Address4: "แขวง/ตำบล",
    ISA_Address5: "บ้านเลขที่ ถนน",
    ISA_Alert_ApprovedSuccess: "อนุมัติแผนการเข้าเยี่ยมสำเร็จ !",
    ISA_Alert_BillNumber: "เลขที่ Bill",
    ISA_Alert_DONumber: "เลขที่ DO",
    ISA_Alert_DeletePlan: "แน่ใจน่ะ ว่าคุณต้องการลบ",
    ISA_Alert_ExportPlanToCalendarSuccess:
      "ทำการบันทึกแผนเข้าสู่ Google Calendar สำเร็จ",
    ISA_Alert_ImportPlanSuccess: "ทำการ Import แผนการเข้าเยี่ยมสำเร็จ",
    ISA_Alert_NotApprovedSuccess: "ไม่อนุมัติแผนการเข้าเยี่ยมสำเร็จ !",
    ISA_Alert_ReturnEditSuccess: "แจ้งแก้ไขแผนสำเร็จ",
    ISA_RowsPerPage: "แถวต่อหน้า:",
    ISA_Of: "จาก",
    ISA_OrderShipTo: "ชื่อสถานที่จัดส่ง",
    ISA_OrderShipToAddr: "สถานที่จัดส่ง",
    ISA_OrderShipToDate: "วันกำหนดส่งสินค้า",
    ISA_OrderReceipt: "ชื่อสถานที่รับสินค้า",
    ISA_OrderReceiptAddr: "สถานที่รับสินค้า",
    ISA_OrderReceiptContact: "ผู้ติดต่อรับสินค้า",
    ISA_OrderReceiptDate: "วันกำหนดรับสินค้า",
    ISA_GoToPage: "ไปหน้า",
    ISA_show_more: "แสดง",
    ISA_MoreThan: "มากกว่า",
    ISA_Alert_SONumber: "เลขที่ SO",
    ISA_Alert_SearchPlaceholder: "ค้นหาเลขที่เอกสาร, ลูกค้า, พนักงานขาย",
    ISA_Alert_SelectCustomerforbillto: "เลือกลูกค้าตามสถานที่จัดส่ง",
    ISA_Alert_SelectPlanImport: "กรุณาเลือกไฟล์สำหรับ Import แผนการเข้าเยี่ยม",
    ISA_Alert_SendApproveSuccess: "ส่งอนุมัติแผนสำเร็จ",
    ISA_Alert_DeleteCustomer: "ลบลูกค้า",
    ISA_EmailNotMatchRegistered:
      "อีเมล์ไม่ตรงกับที่ได้ลงทะเบียนไว้ อีเมล์ของคุณคือ ",
    ISA_PleaseSelectEmail: "กรุณาเลือกอีเมล์",
    ISA_NoCalendarForSave:
      "ไม่พบปฏิทินสำหรับการบันทึกข้อมูล กรุณาตรวจสอบอีเมล์หรือแจ้งเซลล์อัพเดทปฏิทิน",
    ISA_ReversePlan_CancelApprovedTitle: "ยกเลิกอนุมัติแผน",
    ISA_ReversePlan_CancelNotApprovedTitle: "ยกเลิกไม่อนุมัติแผน",
    ISA_RevisionNo: "เลข Revision",
    ISA_ApprovedCalendarLabel: "ปฏิทินที่อนุมัติ",
    ISA_ReversePlan_Success: "ยกเลิกแผนสำเร็จ",
    ISA_ReversePlan_Fail: "ไม่สามารถยกเลิกแผนได้ กรุณาติดต่อเจ้าหน้าที่",
    ISA_Status_Open: "เปิด",
    ISA_Status_Closed: "ปิด",
    ISA_SendApproveProject: "ส่งอนุมัติโครงการ",
    ISA_ApproveProjectTitle: "อนุมัติโครงการ",
    ISA_NoGpsData: "ไม่พบข้อมูลพิกัด",
    ISA_SearchProjectNearBy: "ค้นหาโครงการใกล้เคียง",
    ISA_NoProject: "ไม่มีโครงการ",
    ISA_ProjectNotSelected: "ยังไม่ได้เลือกโครงการ",
    ISA_NoProjectLocation: "ไม่พบพิกัดของโครงการ",
    ISA_ConfirmSaveProject: "ยืนยันการบันทึกข้อมูลโครงการ",
    ISA_ConfirmCancelEditProject: "ต้องการยกเลิกการแก้ไขโครงการ",
    ISA_ChangesNotSaved: "ข้อมูลที่แก้ไขจะไม่ถูกบันทึก",
    ISA_ProjectInfo: "ข้อมูลโครงการ",
    ISA_AddressInfo: "ข้อมูลที่อยู่",
    ISA_SalesAmount: "ยอดขาย",
    ISA_ApprovePlan: "อนุมัติแผน",
    ISA_Approver: "ผู้อนุมัติ",
    ISA_AsOfDate: "ประจำวันที่",
    ISA_AttechFile: "ไฟล์แนบ",
    ISA_Button_AddSalesman: "เพิ่มพนักงานขาย",
    ISA_Button_Back: "กลับ",
    ISA_Button_CancelApprove: "ยกเลิกอนุมัติ",
    ISA_Button_ChangeGmailAccount: "เปลี่ยน Gmail Account",
    ISA_Button_CloseLost: "ปิดการขาย-ไม่ได้งาน",
    ISA_Button_CloseWin: "ปิดการขาย-ได้งาน",
    ISA_Button_ConnectGoogleCalendar: "เชื่อมต่อ Google Calenader",
    ISA_Button_Continue: "ดำเนินการต่อ",
    ISA_Button_ConvertErpCustomer: "สร้างลูกค้าหน้าบัญชี",
    ISA_Button_CreateReceipt: "ชำระเงิน",
    ISA_Button_CreateVistitPlan: "สร้างแผน",
    ISA_Button_DeletePlan: "ลบแผน",
    ISA_Button_DownloadTemplate: "Download Template",
    ISA_Button_EditPlan: "วางแผนเข้าเยี่ยม",
    ISA_Button_Edit_Plan: "แก้ไขแผน",
    ISA_Button_AddDiscount: "บันทึกส่วนลด",
    ISA_Button_AddPurchase: "เพิ่มรายการ",
    ISA_Button_ConfirmCreateINV: "ยืนยัน สร้างใบแจ้งหนี้",
    ISA_Button_DeleteConfirm: "ใช่, ลบเลย!",
    ISA_ButtonExportExcelDetail: "Export Excel Detail",
    ISA_ButtonExportPdf: "Export PDF",
    ISA_ButtonSelectCustomer: "เลือกลูกค้า",
    ISA_Expense_CreatePdf: "สร้างไฟล์ PDF",
    ISA_Expense_Summary_ViewTitle: "ดูรายการ สรุปค่าใช้จ่าย (View Only)",
    ISA_Expense_Summary_EditTitle: "แก้ไขรายการ สรุปค่าใช้จ่าย",
    ISA_Expense_DocDate: "วันที่เอกสาร",
    ISA_Expense_Type: "ประเภทค่าใช้จ่าย",
    ISA_Expense_Amount: "จำนวนเงิน",
    ISA_Expense_ActivityDetail: "รายละเอียด กิจกรรม",
    ISA_Expense_CheckinLocation: "ตำแหน่ง เช็คอิน",
    ISA_Expense_DateTime: "วัน เวลา",
    ISA_Expense_Report: "รายงาน",
    ISA_Expense_LinkedItem: "รายการนี้ถูกเชื่อมโยงแล้ว",
    ISA_Expense_UnlinkedItem: "รายการนี้ยังไม่ได้เชื่อมโยง",
    ISA_Expense_OpenReport: "เปิดรายงาน",
    ISA_Expense_NoActivityInRange: "ไม่พบกิจกรรมในช่วงวันที่ที่เลือก",
    ISA_Expense_ExpenseDetail: "รายละเอียด บันทึกค่าใช้จ่าย",
    ISA_Expense_NoExpenseInRange: "ไม่พบข้อมูลค่าใช้จ่ายในช่วงวันที่ที่เลือก",
    ISA_Expense_TotalExpense: "ค่าใช้จ่ายทั้งหมด",
    ISA_Expense_SaveChanges: "บันทึกการเปลี่ยนแปลง",
    ISA_Expense_UpdateSuccess: "อัปเดตข้อมูลสำเร็จ",
    ISA_Expense_UpdateFailed: "อัปเดตไม่สำเร็จ",
    ISA_ExpenseType_Allowance: "ค่าเบี้ยเลี้ยง",
    ISA_ExpenseType_Hospitality: "ค่ารับรอง",
    ISA_ExpenseType_Fuel: "ค่าน้ำมัน",
    ISA_ExpenseType_Travel: "ค่าเดินทาง",
    ISA_ExpenseType_Accommodation: "ค่าที่พัก",
    ISA_ExpenseType_Other: "ค่าใช้จ่ายอื่นๆ",
    ISA_StartMileage: "เลขไมล์เริ่มต้น",
    ISA_EndMileage: "เลขไมล์สิ้นสุด",
    ISA_Kilometer: "กิโลเมตร",
    ISA_ReturnQty: "จำนวนคืน",
    ISA_HotelName: "ชื่อโรงแรม",
    ISA_Location: "สถานที่",
    ISA_NumberOfParticipants: "จำนวนผู้เข้าร่วม",
    ISA_TollFee: "ค่าทางด่วน",
    ISA_TimePayment: "ระยะเวลาการชำระเงิน",
    ISA_ParkingFee: "ค่าที่จอดรถ",
    ISA_OtherTravelCost: "ค่าเดินทางอื่นๆ",
    ISA_FoodAndBeverage: "ค่าอาหารและเครื่องดื่ม",
    ISA_Miscellaneous: "ค่าเบล็ดเตล็ด",
    ISA_ExpenseAmount: "ค่าใช้จ่าย",
    ISA_EditExpenseItem: "แก้ไขรายการค่าใช้จ่าย",
    ISA_VisitDetails: "รายละเอียดเข้าเยี่ยม",
    ISA_LoadingActivities: "กำลังโหลดข้อมูลกิจกรรม...",
    ISA_Sequence: "ลำดับ",
    ISA_NotSpecified: "ไม่ระบุ",
    ISA_NoActivitiesOnDate: "ไม่พบกิจกรรมในวันที่เลือก",
    ISA_SelectDateToShowActivities: "กรุณาเลือกวันที่เพื่อแสดงกิจกรรม",
    ISA_VisitMemoNotLinkedToCheckin:
      "รายละเอียด รายงานบันทึกเข้าเยี่ยมที่ไม่เชื่อมต่อกับเข้าเยี่ยม",
    ISA_Details: "รายละเอียด",
    ISA_NoDataOnDate: "ไม่พบข้อมูลในวันที่เลือก",
    ISA_UpdateFailed: "อัปเดตไม่สำเร็จ กรุณาตรวจสอบ",
    ISA_InvalidDateFormat: "รูปแบบวันที่เอกสารไม่ถูกต้อง (ต้องเป็น YYYY-MM-DD)",
    ISA_PleaseEnterValidStartDateForGas:
      "กรุณากรอกวันที่เริ่มต้น (จากวันที่) ที่ถูกต้องสำหรับค่าน้ำมัน",
    ISA_PleaseEnterValidEndDateForGas:
      "กรุณากรอกวันที่สิ้นสุด (ถึงวันที่) ที่ถูกต้องสำหรับค่าน้ำมัน",
    ISA_StartDateMustNotGreaterThanEndDate:
      "วันที่เริ่มต้น (จากวันที่) ต้องไม่มากกว่าวันที่สิ้นสุด (ถึงวันที่)",
    ISA_GasDateAlreadySaved:
      "วันที่ที่เลือกสำหรับค่าน้ำมันมีการบันทึกข้อมูลไปแล้ว กรุณาเลือกวันที่อื่น",
    ISA_CannotFetchActivities: "ไม่สามารถดึงข้อมูลกิจกรรมได้ กรุณาลองอีกครั้ง",
    ISA_CannotGenerateDocNumber:
      "ไม่สามารถสร้างเลขที่เอกสารได้ กรุณาลองอีกครั้ง",
    ISA_APIResponseNoData: "การตอบกลับจาก API ไม่มีข้อมูลที่คาดหวัง",
    ISA_SaveDataError: "เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้ง",
    ISA_PleaseEnter: "กรุณากรอก",
    ISA_PleaseAddProduct: "กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ",
    ISA_PleaseCheckData: "กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้:",
    ISA_PleaseEnterCompleteData: "กรุณากรอกข้อมูลให้ครบถ้วนก่อนบันทึก",
    ISA_PleaseSelectPdfType: "กรุณาเลือกประเภท PDF ที่ต้องการเปิด",
    ISA_PleaseSelectPrintShipTo: "กรุณาเลือกพิมพ์สถานที่ส่งในบิล",
    ISA_AddExpenseItem: "เพิ่มรายการค่าใช้จ่าย",
    ISA_PleaseSelectExpenseType: "กรุณาเลือกประเภทค่าใช้จ่าย",
    ISA_AmountAutoCalculated:
      "จำนวนเงินคำนวณอัตโนมัติจากรายการค่าใช้จ่ายด้านบน",
    ISA_PleaseEnterAmount: "กรุณากรอกจำนวนเงิน",
    // --- ExpenseHeader Additional Keys ---
    ISA_Update: "อัปเดต",
    ISA_SelectDateToShowData: "กรุณาเลือกวันที่เพื่อแสดงข้อมูล",
    ISA_DataModifiedByOthers: "พบการแก้ไขข้อมูลโดยผู้อื่น",
    ISA_OtherUserModifiedDoc:
      "มีผู้ใช้งานคนอื่นได้แก้ไขเอกสารนี้ก่อนหน้านี้แล้ว กรุณาเลือกข้อมูลที่ต้องการใช้",
    ISA_ChangesDetected: "ตรวจพบการเปลี่ยนแปลง",
    ISA_ReviewAndSelectData: "กรุณาตรวจสอบและเลือกข้อมูลที่ต้องการบันทึก",
    ISA_Changed: "มีการเปลี่ยนแปลง",
    ISA_YourData: "ข้อมูลของคุณ",
    ISA_LatestData: "ข้อมูลล่าสุด",
    ISA_NoRemark: "ไม่มีหมายเหตุ",
    ISA_Edited: "แก้ไขแล้ว",
    ISA_MustSelectDataToContinue: "ต้องเลือกข้อมูลเพื่อดำเนินการต่อ",
    ISA_CompareAndSelectData: "เปรียบเทียบและเลือกข้อมูลที่ต้องการบันทึกในระบบ",
    ISA_UseLatestDataB: "ใช้ข้อมูลล่าสุด (B)",
    ISA_UseMyDataA: "ใช้ข้อมูลของฉัน (A)",
    ISA_PleaseEnterDocDate: "กรุณากรอกวันที่เอกสาร",
    ISA_Activities: "กิจกรรม",
    ISA_LoadingVisitMemo: "กำลังโหลดข้อมูล รายงานบันทึกเข้าเยี่ยม...",
    ISA_ExpenseSavedSuccess: "รายการค่าใช้จ่ายถูกบันทึกเรียบร้อยแล้ว",
    ISA_NoDataForExport: "ไม่มีข้อมูลสำหรับส่งออกไปยัง Excel",
    ISA_CopyDocumentError: "เกิดข้อผิดพลาดในการคัดลอกเอกสาร",
    ISA_API_NoData: "ไม่พบข้อมูลการใช้งาน API",
    ISA_API_Overview: "ภาพรวมการใช้งาน API",
    ISA_API_Trend: "แนวโน้มปริมาณการใช้งาน API",
    ISA_Roa_BlockReason: "เหตุผลการ Block",

    // ===== PackageServices Keys =====
    ISA_ManagementSuggestion: "คำแนะนำการจัดการ",
    ISA_API_UsageExceed: "การใช้งาน API ของคุณเกิน",
    ISA_API_OfLimit: "ของสิทธิ์ที่กำหนดไว้",
    ISA_API_ConsiderUpgrade:
      "โปรดพิจารณาปรับลดการเรียก หรืออัปเกรดแผนการใช้งาน",
    ISA_UsageAmount: "ปริมาณการใช้",
    ISA_UsageAmountLastYear: "ปริมาณการใช้ปีก่อน",
    ISA_UsageLimit: "ปริมาณจำกัดการใช้",
    ISA_Quarter: "ไตรมาส",
    ISA_CompareToPrevious: "เทียบข้อมูลก่อนหน้า",
    ISA_CARD_PACKAGE: "ไม่พบข้อมูลสำหรับ Card Package",
    ISA_SelectData: "เลือกข้อมูล",
    ISA_Chart: "กราฟ",
    ISA_Last12Months: "ย้อนหลัง 12 เดือน",
    ISA_LastYear: "ปีก่อน",
    ISA_Quotation: "ใบเสนอราคา",
    ISA_SalesOrder: "ใบสั่งขาย",
    ISA_NewCustomer: "ลูกค้าใหม่",
    ISA_NewCustomers: "ลูกค้าใหม่",
    ISA_RefQuotation: "อ้างอิงใบเสนอราคา",
    ISA_Return: "แจ้งคืน",
    ISA_Project: "โครงการ",
    ISA_Checkin: "เช็คอิน",
    ISA_ReturnNote: "ใบแจ้งคืนสินค้า",
    ISA_LoadingDailyData: "กำลังดึงข้อมูลรายวัน...",
    ISA_ProcessingDailyData: "ประมวลผลข้อมูลรายวัน...",
    ISA_CurrentUserDataAndAccumulated: "ข้อมูลผู้ใช้งานปัจจุบัน และยอดสะสม",
    ISA_DailyReport: "รายงานรายวัน",
    ISA_PeriodReport: "รายงานช่วงเวลา",
    ISA_DailyUsageData: "ข้อมูลการใช้งานประจำวันนี้",
    ISA_AccumulatedUsageData: "ข้อมูลการใช้สะสมตามช่วงที่เลือก",
    ISA_AllSalesData: "ข้อมูลยอดขายทั้งหมด",
    ISA_NoSalesData: "ไม่พบข้อมูลยอดขาย",
    ISA_SalesGrowthOverview: "ภาพรวมการเติบโตของยอดขาย",
    ISA_GrowthComparedLastYear: "เติบโตเทียบปีที่ผ่านมา",
    ISA_SalesGrowthTrend: "แนวโน้มการเติบโตยอดขาย",
    ISA_CompareYear: "เทียบปี",
    ISA_With: "กับ",
    ISA_Million: "ล้าน",
    ISA_SalesFocus_SalesOrder: "ยอดสั่งขาย (SO)",
    ISA_SalesFocus_SalesInvoice: "ยอดขาย (INV-CN+DN)",
    ISA_SalesFocus_SalesWeek: "ยอดขายสัปดาห์",
    ISA_SalesFocus_Checkin: "จำนวนการเช็คอิน",
    ISA_SalesFocus_ActiveCustomer: "ลูกค้าเดิมซื้อ",
    ISA_SalesFocus_NewCustomer: "ลูกค้าใหม่ซื้อ",
    ISA_SalesFocus_CheckInBuy: "จำนวนลูกค้าที่เช็คอินซื้อ",
    ISA_SalesFocus_BestSeller: "ขายดี",
    ISA_SalesFocus_WorstSeller: "ขายแย่",
    ISA_MillionBaht: "ล้านบาท",
    ISA_TotalSalesOrders: "จำนวนใบสั่งขายทั้งหมด",
    ISA_ApprovedByROA: "อนุมัติโดย ROA",
    ISA_ApprovedByUser: "อนุมัติโดย ผู้ใช้งาน",
    ISA_PendingApproval: "รอตรวจสอบ/รออนุมัติ",
    ISA_Rejected: "ปฏิเสธ",
    ISA_Button_ImportVisitPlan: "Import ข้อมูลแผน",
    ISA_Button_Next: "ถัดไป",
    ISA_Button_Ok: "ตกลง",
    ISA_Button_ReqDetail: "เพิ่ม/แก้ไข สินค้า",
    ISA_Button_Searching: "กำลังค้นหา...",
    ISA_Button_SelectCustomerByProvince: "เลือกลูกค้าตามจังหวัด",
    ISA_Button_SendApprove: "ส่งอนุมัติแผน",
    ISA_Button_UploadFile: "อัพโหลดไฟล์",
    ISA_Button_UploadPlan: "อัพโหลดแผนการเข้าเยี่ยม",
    ISA_Button_ViewClientVisit: "ดูการเข้าเยี่ยม",
    ISA_Button_ViewPlan: "ดูแผน",
    ISA_By: "ผู้อนุมัติ",
    ISA_CashSummary: "สรุปส่งเงิน",
    ISA_CheckInDistanceM: "ระยะห่างการ Check In (เมตร)",
    ISA_CheckInType: "วิธีการนับ Checkin",
    ISA_ClientVisitDate: "วันที่ Check In",
    ISA_ClientVisitDuration: "ระยะเวลา",
    ISA_ClientVisitEndTime: "วันที่ Check Out",
    ISA_CloseSystem: "ปิดระบบ",
    ISA_CopyDocument: "คัดลอกเอกสาร",
    ISA_CreateDate: "วันที่สร้างโครงการ",
    ISA_CreateProspect: "เพิ่มข้อมูลลูกค้าผู้มุ่งหวัง",
    ISA_CreateVisitPlan: "สร้างแผนการเข้าเยี่ยม",
    ISA_CreditNoteDocNumber: "เลขที่ใบลดหนี้",
    ISA_CumulativePercent: "% ยอดขายสะสม",
    ISA_CumulativeTotal: "ยอดขายรวมสะสม",
    ISA_CurrentSOQty: "ยอดสั่งซื้อ(SO) ปัจจุบัน",
    ISA_CustomPercent: "% ยอดขายปัจจุบัน",
    ISA_CustomerAccountEditName: "แก้ไขลูกค้า",
    ISA_CustomerAccountName: "เพิ่มข้อมูลลูกค้าหน้าบัญชี",
    ISA_CustomerDistanceKm: "ระยะห่างระหว่างลูกค้า (กิโลเมตร)",
    ISA_CustomerDocumentStatus: "สถานะเอกสารลูกค้า",
    ISA_CustomerFocus_BillNo: "เลขที่บิล",
    ISA_CustomerFocus_InvNo: "เลขที่ใบกำกับ",
    ISA_Product: "สินค้า",
    ISA_ProductOrder: "รอบการสั่งสินค้า",
    ISA_ProductStock: "ยอดระบาย",
    ISA_AUTO_CONFIRM_CREATE_INVOICE: "ยืนยันการสร้างใบแจ้งหนี้",
    ISA_AUTO_CONFIRM_CREATE_INVOICE_BTN: "ยืนยัน สร้างใบแจ้งหนี้",
    ISA_AUTO_DO_YOU_WANT_CREATE_INVOICE: "คุณต้องการสร้างใบแจ้งหนี้นี้หรือไม่?",
    ISA_AUTO_CREATING_INVOICE: "กำลังสร้างใบแจ้งหนี้...",
    ISA_AUTO_CREATE_INVOICE_SUCCESS: "สร้างใบแจ้งหนี้สำเร็จ!",
    ISA_AUTO_DAILY: "รายวัน",
    ISA_Display_Compare: "เปรียบเทียบ",
    ISA_Display_ByMonth: "รายเดือน",
    ISA_CustomerInPlan: "ลูกค้าที่เข้าเยี่ยมในแผน",
    ISA_Customer_ActiveCustomer: "Active Customer",
    ISA_Customer_All: "ลูกค้าทั้งหมด",
    ISA_Customer_CustomerActive: "ลูกค้าเก่าซื้อ",
    ISA_Customer_Due: "Due",
    ISA_Customer_Inactive: "Inactive",
    ISA_Can_Edit_Permission: "สามารถแก้ไขสิทธิ์ได้",
    ISA_Customer_Info: "ข้อมูลลูกค้า",
    ISA_Customer_Nearby: "ลูกค้าใกล้เคียง",
    ISA_Customer_NotBuyProduct: "ไม่ซื้อสินค้า",
    ISA_Customer_NotDue: "ยังไม่ถึงกำหนด",
    ISA_Customer_OverDue: "เกินกำหนด",
    ISA_Customer_ReceivableAging: "อายุลูกหนี้",
    ISA_Customer_ReceivableAgingNotOver: "ไม่เกิน",
    ISA_Customer_ReceivableAgingOver: "เกิน",
    ISA_Customer_Target: "เป้า",
    ISA_Dashboard_KPI: "KPI (ข้อมูลปัจจุบัน)",
    ISA_Dashboard_Remaining: "ต้องทำเพิ่ม",
    ISA_Dashboard_SalesTeam: "ทีมขาย",
    ISA_DateCreate: "วันที่สร้าง",
    ISA_DateSlashTime: "วันที่/เวลา",
    ISA_DocApproveReason: "เหตุผลอนุมัติ",
    ISA_DocCancelReturn: "ยกเลิกใบแจ้งคืน",
    ISA_DocCreateCredit: "สร้างใบลดหนี้",
    ISA_DocCreateInvoice: "สร้างใบขาย",
    ISA_CreateDocumentSuccess: "ทำการสร้างเอกสารเรียบร้อย",
    ISA_CancelDocumentSuccess: "ทำการยกเลิกเอกสารเรียบร้อย",
    ISA_CancelStatus: "ยกเลิกสถานะ",
    ISA_ReturnAmount: "ยอดคืนสินค้า",
    ISA_ReturnReportDetail: "รายละเอียดใบแจ้งคืนสินค้า",
    ISA_DocHeader: "ประเภทหัวเอกสาร",
    ISA_DocNumberInv: "เลขที่ INV",
    ISA_DocReason: "สาเหตุ Block",
    ISA_DocReasonCancel: "เหตุผลยกเลิก",
    ISA_DocRefSalesAgreement: "อ้างอิงข้อตกลงการขาย",
    ISA_DocReturnDate: "วันที่แจ้งคืนสินค้า",
    ISA_DocReturnNumber: "เลขที่ใบแจ้งคืน",
    ISA_EditReturn: "แก้ไขใบแจ้งคืน",
    ISA_EditProspect: "แก้ไขข้อมูลลูกค้าผู้มุ่งหวัง",
    ISA_EditSalesman: "แก้ไขพนักงานขาย",
    ISA_ErrorContactSupport: "ไม่สามารถทำรายการได้ กรุณาติดต่อ Support",
    ISA_PleaseSelectDocStatus: "กรุณาเลือกสถานะเอกสาร",
    ISA_ExportPlanToCalendar_Title: "บันทึกแผนเข้าสู่ Google Calendar",
    ISA_ExternalProjectNumber: "D365 Project No.",
    ISA_FilterCustomerNotBuy: "เดือนที่ไม่มีการซื้อขาย",
    ISA_FilterCustomerVisit: "เดือนที่มีการเข้าเยี่ยม",
    ISA_FilterParentSalesman: "หัวหน้าทีมขาย",
    ISA_FilterSalesArea: "เขตการขาย",
    ISA_FilterStartDate: "วันที่เริ่มแผน",
    ISA_Filter_ProejctEndDate: "วันสิ้นสุดโครงการ",
    ISA_Filter_ShowNewProjectFromDate: "แสดงโครงการใหม่ตั้งแต่วันที่",
    ISA_GPSLat: "GPSLat",
    ISA_GPSLatLong: "Lat/Long",
    ISA_GPSLong: "GPSLong",
    ISA_HistoryChart: "กราฟประวัติการขาย",
    ISA_HistoryMonthChart: "กราฟประวัติการขายรายเดือน",
    ISA_ImportFile: "นำเข้าไฟล์",
    ISA_ImportingData: "กำลังนำเข้าข้อมูล",
    ISA_ImportToAccounting: "นำเข้าระบบบัญชี",
    ISA_ImportVisitPlan_Title: "Import แผนการเข้าเยี่ยม",
    ISA_January: "มกราคม",
    ISA_July: "กรกฎาคม",
    ISA_June: "มิถุนายน",
    ISA_Km: "กม.",
    ISA_Label_CustomerMap: "แสดงเฉพาะลูกค้ามียอดขาย",
    ISA_LastBillDate: "วันที่ขายล่าสุด",
    ISA_LastSalesAmount: "ยอดขายล่าสุด",
    ISA_LastVisitDate: "วันที่เข้าเยี่ยมล่าสุด",
    ISA_Loading: "กำลังโหลดข้อมูล",
    ISA_SystemRefreshingData: "ระบบกำลังรีเฟรชข้อมูล",
    ISA_PleaseWait: "กรุณารอสักครู่...",
    ISA_LoadingData: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
    ISA_LoadingDot: "กำลังโหลดข้อมูล…",
    ISA_Loading_PleaseWait: "โปรดรอสักครู่...",
    ISA_CustomerGroup_Placeholder_Format: "รูปแบบการแสดงผล",
    ISA_CustomerGroup_Placeholder_Display: "การแสดงผล",
    ISA_LocationType: "ประเภทเช็คอิน",
    ISA_MainStatus: "สถานะหลัก",
    ISA_ManageDoc: "จัดการเอกสาร",
    ISA_March: "มีนาคม",
    ISA_MarketingActivity: "กิจกรรมการตลาด",
    ISA_Marker_CheckInStart: "จุดเริ่มต้น",
    ISA_Marker_VisitInPlan: "Checkin ตามแผน",
    ISA_Marker_VisitOutPlan: "Checkin นอกแผน",
    ISA_Master_CurrentQuarter: "ไตรมาสปัจจุบัน",
    ISA_Master_CurrentQuarterLastYear: "ไตรมาสนี้ปีก่อน",
    ISA_Master_CurrentSales: "ยอดขายปัจจุบัน",
    ISA_Master_CurrentYear: "ปีปัจจุบัน",
    ISA_Master_Map: "แผนที่",
    ISA_Master_Percentage: "เปอร์เซ็น",
    ISA_Master_PreviousQuarter: "ไตรมาสก่อน",
    ISA_Master_PreviousSales: "ยอดขายก่อนหน้า",
    ISA_Master_Ranking: "อันดับ",
    ISA_Master_SelectDisplay: "เลือกการแสดงผล",
    ISA_Master_SelectMonth: "เลือกเดือน",
    ISA_Master_SelectQuarter: "เลือกไตรมาส",
    ISA_Master_SelectYear: "เลือกปี",
    ISA_May: "พฤษภาคม",
    ISA_Menu_Customer: "วิเคราะห์ลูกค้า",
    ISA_Menu_CustomerOverall: "ภาพรวมลูกค้าทั้งหมด",
    ISA_Menu_Customer_Focus: "ลูกค้าเฉพาะราย",
    ISA_Menu_ERPCustomer: "ลูกค้าหน้าบัญชี",
    ISA_Menu_ImportARReportMaster: "ข้อมูลรายงานอายุลูกหนี้",
    ISA_Menu_ImportAvailableStockTransactionMaster: "ข้อมูลสต๊อกสินค้า",
    ISA_Menu_ImportCRM: "ข้อมูลCRM",
    ISA_Menu_ImportClientVisitMemoRemarkMaster:
      "หัวข้อการทำบันทึกเข้าเยี่ยมลูกค้า",
    ISA_Menu_ImportCustomerChequeReturn: "ข้อมูลคืนเช็คลูกค้า",
    ISA_Menu_ImportMaster: "นำเข้าข้อมูล",
    ISA_Menu_ImportCustomerMaster: "ข้อมูลลูกค้าหน้าบัญชี",
    ISA_Menu_ImportCustomerMasterSaleman: "ข้อมูลพนักงานขายผูกลูกค้า",
    ISA_Menu_ImportCustomerPricingMaster: "ข้อมูลราคาขายตามลูกค้าเฉพาะราย",
    ISA_Menu_ImportGroupPricingMaster: "ข้อมูลราคาขายตามกลุ่มลูกค้า",
    ISA_Menu_ImportKPIMaster: "ข้อมูลตัวชี้วัด",
    ISA_Menu_ImportLookupMaster: "ข้อมูลLookup",
    ISA_Menu_ImportMarketPlaceMaster: "ข้อมูลพื้นที่ขายลูกค้า",
    ISA_Menu_ImportOrderRemarkMaster: "ข้อมูลหมายเหตุท้ายบิล",
    ISA_Menu_ImportOrderStatusReportMaster: "ข้อมูลสถานะเอกสาร",
    ISA_Menu_ImportProductPricingMaster: "ข้อมูลราคาขายมาตราฐาน",
    ISA_Menu_ImportProductTargetMaster: "ข้อมูลเป้าการขายสินค้า",
    ISA_Menu_ImportProvinceMaster: "ข้อมูลจังหวัด",
    ISA_Menu_ImportQuestionAir: "ข้อมูลแบบสอบถาม",
    ISA_Menu_ImportReportDailySalesSummariesMaster: "ข้อมูลรายงานยอดขาย",
    ISA_Menu_ImportReturnReasonMaster: "ข้อมูลเหตุผลในการคืน",
    ISA_Menu_ImportSalesTargetMaster: "ข้อมูลเป้าการขายเซลส์",
    ISA_ImportSalesmanSuccess: "Import Salesman สำเร็จ",
    ISA_Menu_PerformanceOverall: "ประสิทธิภาพโดยรวม",
    ISA_Menu_ProductInsight: "วิเคราะห์สินค้า",
    ISA_Menu_Prospect: "ลูกค้าผู้มุ่งหวัง",
    ISA_Menu_ReportOutputTax: "รายงานภาษีขาย",
    ISA_Menu_Requisition: "โอนระหว่างคลัง",
    ISA_Menu_SalesPipeline: "ติดตามงานโครงการ",
    ISA_Menu_Salesman: "แผนการเยี่ยม",
    ISA_Menu_SalesmanInsight: "วิเคราะห์พนักงาน",
    ISA_Menu_WebUserGroup: "กลุ่มผู้ใช้งาน",
    ISA_Menu_WebUserGroupManagement: "ระบบจัดการกลุ่มผู้ใช้งาน",
    ISA_Message_ConfirmCreateINV: "คุณต้องการสร้างใบแจ้งหนี้นี้หรือไม่?",
    ISA_Message_EmptyPlanName: "กรุณากรอกชื่อแผนการเข้าเยี่ยม",
    ISA_Message_FieldRequired: "กรุณากรอกข้อมูล",
    ISA_Message_InvalidEndDate: "วันที่สิ้นสุดการเข้าเยี่ยมไม่ถูกต้อง",
    ISA_Message_InvalidStartDate: "วันที่เริ่มเข้าเยี่ยมไม่ถูกต้อง",
    ISA_Message_SelectApprover: "กรุณาเลือกผู้อนุมัติแผน",
    ISA_Message_SelectCalendar: "กรุณาเลือกปฏิทิน",
    ISA_SettingEmail: "ตั้งค่าอีเมล์และปฏิทิน",
    ISA_CannotData: "ไม่สามารถอัพเดทข้อมูลได้",
    ISA_SettingEmail0Pending1:
      "* คุณได้ตั้งค่าอีเมล์ {0} ไว้แล้ว ต้องการอัพเดทเป็น {1} หรือไม่?",
    ISA_Likes: "ถูกใจ",
    ISA_Comments: "ความคิดเห็น",
    ISA_Message_SelectCustomer: "กรุณาเลือกลูกค้าที่เข้าเยี่ยม",
    ISA_Message_SelectSalesman: "กรุณาเลือกพนักงานขาย",
    ISA_MessageApprove: "ต้องการอนุมัติรายการสำหรับ",
    ISA_MessageCancelApprove: "กรุณายืนยันการยกเลิกอนุมัติรายการสำหรับ",
    ISA_MessageCancelNotApprove: "ต้องการยกเลิกไม่อนุมัติ",
    ISA_MessageCancelPendingDelivery: '"คุณต้องการยกเลิกสถานะค้างส่ง" ใช่หรือไม่',
    ISA_TitleApprove: "การอนุมัติ",
    ISA_TitleCancelApprove: "การยกเลิกอนุมัติ",
    ISA_TitleCancelNotApprove: "การยกเลิกไม่อนุมัติ",
    ISA_MonthSlashYear: "เดือน/ปี",
    ISA_HeaderType: "รูปแบบ",
    ISA_PDFPageSize: "ขนาดกระดาษ",
    ISA_PdfWithDate: "PDF ระบุวันที่",
    ISA_PdfWithDateDescription: "แสดงวันที่ในเอกสาร (แบบปกติ)",
    ISA_PdfWithoutDate: "PDF ไม่ระบุวันที่",
    ISA_PdfWithoutDateDescription: "ไม่แสดงวันที่ในเอกสาร",
    ISA_Title_PDFSetting: "ตั้งค่าเอกสาร",
    ISA_BillAddress_Title: "ที่อยู่หัวเอกสาร",
    ISA_BillAddress_Current: "ที่อยู่ในเอกสาร",
    ISA_BillAddress_Latest: "ที่อยู่ลูกค้าล่าสุด",
    ISA_BillAddress_Update: "อัพเดทเป็นที่อยู่ล่าสุด",
    ISA_BillAddress_ConfirmTitle: "ยืนยันอัพเดทที่อยู่หัวเอกสาร",
    ISA_BillAddress_ConfirmText: "ที่อยู่ในเอกสารจะถูกเปลี่ยนเป็นที่อยู่ลูกค้าล่าสุด",
    ISA_BillAddress_UpdateSuccess: "อัพเดทที่อยู่หัวเอกสารเรียบร้อย",
    ISA_NoCustomerInPlan: "ไม่มีลูกค้าที่เข้าเยี่ยมในแผน",
    ISA_NoSelectCustomerInPlan: "ยังไม่ได้เลือกลูกค้าในแผน",
    ISA_NotApprovePlan: "ไม่อนุมัติแผนการเข้าเยี่ยม",
    ISA_NotApproveReason: "เหตุผลที่ไม่อนุมัติ",
    ISA_NotApproved: "ไม่อนุมัติแผน",
    ISA_November: "พฤศจิกายน",
    ISA_NumOfCheckIn: "เข้าจริง",
    ISA_NumOfPlan: "แผนเข้าเยี่ยม",
    ISA_NumOfVisit: "จำนวนการเข้าเยี่ยม",
    ISA_October: "ตุลาคม",
    ISA_OpenSystem: "เปิดระบบ",
    ISA_OpenSystemOld: "เปิดระบบ เดิม",
    ISA_PercentCurrSOQty: "% เทียบยอดสั่งซื้อกับยอดขาย(ปัจจุบัน)",
    ISA_PercentPrevQty: "% ยอดขายก่อนหน้า",
    ISA_PercentPrevSOQty: "% เทียบยอดสั่งซื้อกับยอดขาย(ก่อนหน้า)",
    ISA_Photo: "รูป",
    ISA_PlanName: "ชื่อแผน",
    ISA_PleaseSelectSalesOrgAndChannel: "โปรดเลือก SalesOrg และ Channel",
    ISA_PrevSOQty: "ยอดสั่งซื้อ(SO) ก่อนหน้า",
    ISA_PrintDate: "วันที่พิมพ์:",
    ISA_Priority: "ความสำคัญ",
    ISA_ProblemFound: "ปัญหาที่พบ",
    ISA_ProductPrice_1: "ราคา 1",
    ISA_ProductPrice_2: "ราคา 2",
    ISA_ProductPrice_3: "ราคา 3",
    ISA_ProductPrice_4: "ราคา 4",
    ISA_ProductInsight_CompareTargetNewProduct: "เป้าการขายเทียบสินค้าใหม่",
    ISA_ProductInsight_CompareTargetOriginalProduct:
      "เป้าการขายเทียบสินค้าเดิม",
    ISA_ProductInsight_CurrentMonthLastYear: "เดือนนี้ปีก่อน",
    ISA_ProductInsight_MonthlySales: "ยอดขายรายเดือน",
    ISA_ProductInsight_NewProduct: "สินค้าใหม่",
    ISA_ProductInsight_OriginalProduct: "สินค้าเดิม",
    ISA_Product_NewProduct: "ข้อมูลสินค้าใหม่",
    ISA_ProjectAddProduct: "ประมาณการขายสินค้า",
    ISA_ProjectAmountMaxLimit: "ไม่สามารถใส่มูลค่าเกิน 2,147,483,647 ได้",
    ISA_ProjectCloseDate: "วันที่จะปิดโครงการ",
    ISA_ProjectCreateDate: "วันที่เริ่มโครงการ",
    ISA_PROJECT: "ต้องการรวมกับ Project อื่น ใช่หรือไม่ ?",
    ISA_ActivityYN: "ใช่หรือไม่",
    ISA_ProjectDimension1: "กลุ่มโครงการ",
    ISA_ProjectDimension2: "รูปแบบโครงการ",
    ISA_ProjectDimension3: "ประเภทโครงการ",
    ISA_ProjectDimension4: "มิติโครงการ 4",
    ISA_ProjectName: "ชื่อโครงการ",
    ISA_ProjectNumber: "เลขที่โครงการ",
    ISA_ProjectPriority: "ระดับความสำคัญของโครงการ",
    ISA_ProjectPriorityHigh: "ความสำคัญระดับสูง",
    ISA_ProjectPriorityLow: "ความสำคัญระดับต่ำ",
    ISA_ProjectPriorityMedium: "ความสำคัญระดับกลาง",
    ISA_ProjectRanking: "โครงการที่มียอดขายสูงสุด",
    ISA_ProjectTotalCount: "จำนวนโครงการทั้งหมด",
    ISA_SALESAGREEMENTDETAIL: "SalesAgreementDetail",
    ISA_ProjectOpenCount: "จำนวนโครงการที่เปิด",
    ISA_ProjectOpenSalesCount: "จำนวนโครงการที่เปิดแล้วมียอดซื้อขาย",
    ISA_ProjectSpecSalesYear: "ยอดขายโครงการที่วาง Spec ปี",
    ISA_ProductRanking: "สินค้าที่มียอดขายสูงสุด",
    ISA_Project_SpecCount: "จำนวนโครงการที่วาง Spec",
    ISA_YearShort: "ปี",
    ISA_ProjectSalesTotalOpen: "เปิดมาทั้งหมด",
    ISA_ProjectSalesTradeCount: "มีการซื้อขาย",
    ISA_ProjectSelectPriority: "เลือกระดับความสำคัญ",
    ISA_ProjectStatus: "สถานะโครงการ",
    ISA_Warning_ProjectLocationRequired:
      "ไม่สามารถดำเนินการต่อได้ กรุณาบันทึกตำแหน่งโครงการ",
    ISA_IUnderstand: "ฉันเข้าใจแล้ว",
    ISA_RefreshData: "รีเฟรชข้อมูล",
    ISA_Prospect: "ข้อมูล ลูกค้าผู้มุ่งหวัง",
    ISA_ProspectBranch: "สาขา",
    ISA_ProspectChannel: "ช่องทางการจัดจำหน่าย",
    ISA_ProspectChequeStatus: "สถานะเช็ค",
    ISA_ProspectCreditLimit: "เครดิตที่มี",
    ISA_ProspectCreditLimitOutStanding: "เครดิตคงเหลือ",
    ISA_ProspectCreditLimitUsed: "เครดิตที่ใช้ไป",
    ISA_ProspectDaySales: "ยอดขายรายวัน",
    ISA_ProspectDistrict: "อำเภอ/เขต",
    ISA_ProspectERPCustomerCode: "รหัสลูกค้า (ERP)",
    ISA_ProspectERPDate: "วันที่อัพเดตลูกค้า(ERP)",
    ISA_ProspectGroupCode: "เล่มราคา",
    ISA_ProspectLeadtime: "ระยะเวลาส่งสินค้า",
    ISA_ProspectMarketPlaceCode: "พื้นที่่เขตการขาย",
    ISA_ProspectName: "ชื่อ",
    ISA_ProspectSalesOrg: "แผนกการขาย",
    ISA_ProspectTelNumber: "โทรศัพท์ / มือถือ",
    ISA_ProspectVatRate: "อัตราภาษีมูลค่าเพิ่ม",
    ISA_Province: "จังหวัด",
    ISA_Remark: "หมายเหตุ",
    ISA_ReportOrderTransaction: "ใบสั่งซื้อ",
    ISA_ReportSupplierReceiveTransactionDetail: "ใบรับสินค้าจากผู้จำหน่าย (รายละเอียด)",
    ISA_ReturnReasonCode: "กำหนดส่งของ",
    ISA_ReportBillingAfterDiscount: "มูลค่าสินค้า(หลังหักส่วนลด)",
    ISA_ReportBillingAfterVat: "มูลค่าสินค้า(ก่อนVat)",
    ISA_ReportBillingNetAmount: "ยอดสุทธิ(ตามสกุลเงิน)",
    ISA_ReportBillingTotal: "มูลค่าสินค้า(ก่อนส่วนลด)",
    ISA_ReportBillingCash: "เงินสด",
    ISA_ReportBillingBankTransfer: "โอนธนาคาร",
    ISA_ReportBillingType_Order: "แสดงรายการขาย",
    ISA_ReportCreditNote: "รายงาน ใบลดหนี้",
    ISA_ReportCreditNoteTransactionDetail: "รายละเอียดใบลดหนี้",
    ISA_ReportFilterFromPlant: "จากคลัง",
    ISA_ReportFilterToPlant: "เข้าคลัง",
    ISA_ReportFilterUnit: "หน่วยสินค้า",
    ISA_ReportInvoiceTransaction: "ใบขาย",
    ISA_ReportInvoiceTransactionDetail: "รายละเอียดใบขาย",
    ISA_ReportQuotationTransactionDetail: "รายละเอียดใบเสนอราคา",
    ISA_ReportOutputTaxAmountOfGoods: "มูลค่าสินค้าหรือบริการ",
    ISA_ReportOutputTaxCustomerName: "ผู้ซื้อสินค้า/ผู้บริการ",
    ISA_ReportOutputTaxDate: "วัน/เดือน/ปี",
    ISA_ReportOutputTaxOfficeName: "สถานประกอบการ",
    ISA_ReportOutputTaxTaxInvoice: "ใบกำกับภาษี",
    ISA_ReportOutputTaxTaxTitle: "เลขประจำตัวผู้เสียภาษีอากร",
    ISA_ReportOutputTaxVat: "จำนวนเงินภาษีมูลค่าเพิ่ม",
    ISA_ReportOutputTaxMonthLabel: "เดือนภาษี",
    ISA_ReportOutputTaxCompanyName: "ชื่อผู้ประกอบการ",
    ISA_ModifiedBy: "แก้ไขโดย",
    ISA_Month: "เดือน",
    ISA_Menu_ReportInputTax: "รายงานภาษีซื้อ",
    ISA_UnitCost: "Unit Cost",
    ISA_TotalCost: "Total Cost",
    ISA_ReportStockMovement_AllWarehouses: "รวมทุกคลังสินค้า",
    ISA_ReportStockAgeing: "รายงานอายุสต็อกสินค้า",
    ISA_ReportStockAgeingStartDate: "วันที่เริ่มต้น",
    ISA_ReportStockAgeingToDate: "จำนวนวัน",
    ISA_ReportStockAgeingQuantity: "Quantity",
    ISA_SerialNumber: "Serial Number",
    ISA_QUANTITY: "รวม Quantity:",
    ISA_CannotGenerateNewDocumentNumber:
      "ไม่สามารถสร้างเลขเอกสารใหม่ได้จาก API",
    ISA_CannotLoadOriginalDocument: "ไม่สามารถดึงข้อมูลเอกสารต้นฉบับได้",
    ISA_CopyDocumentSaveFailed: "API ไม่สามารถบันทึกเอกสารที่คัดลอกได้",
    ISA_CopyDocumentSuccess: "คัดลอกเอกสารสำเร็จ",
    ISA_FilesRejected: "ไฟล์บางรายการถูกปฏิเสธ (นามสกุลไม่รองรับ)",
    ISA_DeleteExistingFileNotSupported:
      "การลบไฟล์ที่แนบแล้วยังไม่รองรับในหน้านี้",
    ISA_Showing: "แสดง",
    ISA_ConfirmDeleteFile: "ต้องการลบไฟล์",
    ISA_DeleteFileSuccess: "ลบไฟล์เรียบร้อยแล้ว",
    ISA_CannotDeleteFile: "ไม่สามารถลบไฟล์ได้ โปรดลองอีกครั้ง",
    ISA_ErrorDeleteFile: "เกิดข้อผิดพลาดขณะลบไฟล์",
    ISA_PleaseSelectNewFile: "กรุณาเลือกไฟล์ใหม่ที่ต้องการอัปโหลด",
    ISA_LoadingExistingFiles: "กำลังโหลดไฟล์แนบเดิม...",
    ISA_Attached: "แนบแล้ว",
    ISA_ReadyToUpload: "พร้อมอัปโหลด",
    ISA_CancelFile: "ยกเลิกไฟล์",
    ISA_View: "ดู",
    ISA_SupportedFileTypes:
      "รองรับไฟล์ Excel (.xlsx, .xls), CSV หรือไฟล์รูปภาพ (jpg, png, jpeg, gif, bmp, webp)",
    ISA_Uploading: "กำลังอัปโหลด... กรุณารอสักครู่",
    ISA_UploadingDot: "กำลังอัปโหลด...",
    ISA_Upload: "อัปโหลด",
    ISA_StockCountCopyTitle: "คัดลอกเอกสารนับสต็อก",
    ISA_StockCountCopyConfirm:
      "ต้องการคัดลอกเอกสารนับสต็อก รายการนี้ หรือไม่ ?",
    ISA_Processing: "กำลังดำเนินการ...",
    ISA_CannotChangeDocStatus: "ไม่สามารถเปลี่ยนสถานะเอกสารได้",
    ISA_PleaseCheckDocStatus: "กรุณาตรวจสอบสถานะเอกสารอีกครั้ง",
    ISA_CannotConnectSystem: "ไม่สามารถเชื่อมต่อกับระบบได้",
    ISA_PleaseContactAdmin: "กรุณาติดต่อผู้ดูแลระบบ",
    ISA_CannotProcessPleaseTryAgain:
      "ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง",
    ISA_DocStatusChangedSuccess: "เปลี่ยนสถานะเอกสารเรียบร้อยแล้ว",
    ISA_WarningCannotRevert: "คำเตือน: การเปลี่ยนสถานะนี้ไม่สามารถย้อนกลับได้",
    ISA_ReportStockBalance: "รายงานสต็อคคงเหลือ",
    ISA_ReportStockMovement: "รายงานความเคลื่อนไหวสต็อค",
    ISA_DownloadData: "ดาวน์โหลดข้อมูล",
    ISA_DownloadPDF: "ดาวน์โหลด PDF",
    ISA_CurrentLast: "ปัจจุบัน/ก่อนหน้า",
    ISA_ReportStockMovementIn: "เข้า",
    ISA_ReportStockMovementOut: "ออก",
    ISA_ReportStockMovement_BetweenDates: "ระหว่างวันที่",
    ISA_Requisition: "ใบเบิกสินค้า",
    ISA_RequisitionReason: "เหตุผล",
    ISA_TransferDoc: "ใบโอนระหว่างคลัง",
    ISA_ReturnEditPlan: "แจ้งแก้ไขแผน",
    ISA_SaleStage: "ขั้นตอนการขาย",
    ISA_SalesAmountPerMonth: "ยอดขายทั้งเดือน",
    ISA_SalesPipeLine_LastContact: "วันที่ติดต่อลูกค้าล่าสุด",
    ISA_Pipeline_NoProject: "ไม่มีโครงการในขั้นตอนนี้",
    ISA_Pipeline_NoData_Suggestion: "ลองปรับตัวกรองการค้นหาหรือรีเฟรชข้อมูล",
    ISA_Pipeline_Filters: "Pipeline Filters",
    ISA_Pipeline_AndDateFilters: "Pipeline & Date Filters",
    ISA_Project_NoName: "ไม่มีชื่อโครงการ",
    ISA_Today: "วันนี้",
    ISA_Over_X_Days: "เกิน",
    ISA_NewShort: "ใหม่",
    ISA_SalesStage: "ขั้นตอนการขาย",
    ISA_PipelineStage_0_NoWin: "0-ปิดการขาย-ไม่ได้งาน",
    ISA_PipelineStage_10_Meeting: "10-นัดพบนำเสนองาน",
    ISA_PipelineStage_20_Sample: "20-นำส่งตัวอย่างสินค้า",
    ISA_PipelineStage_30_Other: "30-...",
    ISA_PipelineStage_40_Trial: "40-อยู่ในขั้นตอนการทดลองใช้สินค้า",
    ISA_PipelineStage_50_Quote: "50-เสนอราคา",
    ISA_PipelineStage_70_Negotiation: "70-เจรจาต่อรอง",
    ISA_PipelineStage_90_PriceOK: "90-ลูกค้าแจ้งว่าราคาผ่าน",
    ISA_PipelineStage_95_POProcessing: "95-ลูกค้ากำลังออก PO",
    ISA_PipelineStage_100_Won: "100-ปิดการขาย-ได้งาน",
    ISA_PipelineStage_X_Cancelled: "X-Cancelled",
    ISA_Salesman: "พนักงานขาย",
    ISA_Route: "เส้นทาง",
    ISA_RouteName: "ชื่อเส้นทาง",
    ISA_RouteNo: "เส้นทาง",
    ISA_SalesmanName: "ชื่อพนักงาน",
    ISA_SalesmanPhoneNumber: "เบอร์โทรพนักงานขาย",
    ISA_ParentSalesmanCode: "รหัสพนักงานหลัก",
    ISA_SalesOrganization: "องค์กรขาย",
    ISA_SalesAreaDescription: "รายละเอียดพื้นที่ขาย",
    ISA_LangId: "รหัสภาษา",
    ISA_SalesmanProject: "ผู้ดูแลโครงการ",
    ISA_SearchCustomerNearBy: "ค้นหาลูกค้าใกล้เคียง",
    ISA_SelectApprover: "เลือกผู้อนุมัติแผน",
    ISA_SelectCalendar: "เลือกปฏิทิน",
    ISA_SelectCustomer: "เลือกลูกค้าที่เข้าเยี่ยม",
    ISA_SelectCustomerNearby: "เลือกลูกค้าใกล้เคียง",
    ISA_SelectProvince: "เลือกจังหวัด",
    ISA_SelectSalesman: "เลือกพนักงานขาย",
    ISA_SendApproveMessage: "ข้อความขออนุมัติแผน",
    ISA_SendToApproval: "ส่งแผนเพื่อขออนุมัติ",
    ISA_September: "กันยายน",
    ISA_ShipDate: "วันที่จัดส่ง",
    ISA_Short_April: "เม.ย.",
    ISA_Short_August: "ส.ค.",
    ISA_Short_December: "ธ.ค.",
    ISA_Short_February: "ก.พ.",
    ISA_Short_January: "ม.ค.",
    ISA_Short_July: "ก.ค.",
    ISA_Short_June: "มิ.ย.",
    ISA_Short_March: "มี.ค.",
    ISA_Short_May: "พ.ค.",
    ISA_Short_November: "พ.ย.",
    ISA_Short_October: "ต.ค.",
    ISA_Short_September: "ก.ย.",
    ISA_Status: "สถานะ",
    ISA_StatusBy: "สถานะโดย",
    ISA_StatusComplete: "เรียบร้อย (รอเปิดระบบ)",
    ISA_Status_Pending: "รออนุมัติ",
    ISA_Status_PendingBilling: "รอตั้งหนี้",
    ISA_Status_PendingReview: "รอตรวจสอบ",
    ISA_Status_WaitingPayment: "รอจ่ายเงิน",
    ISA_Status_Unknown: "ไม่ทราบสถานะ",
    ISA_Status_Done: "เสร็จสิ้น",
    ISA_Status_Expired: "หมดอายุ",
    ISA_Status_Process: "กำลังดำเนินการ",
    ISA_Status_ReturnEdit: "แจ้งแก้ไข",
    ISA_StockLocationType: "ตำแหน่งเก็บ",
    ISA_StockIn: "รับเข้า",
    ISA_StockReturn: "รับคืน",
    ISA_StockAdjust: "ปรับปรุงสต็อค",
    ISA_StockAdjustmentHelpTitle: "ปรับได้ทั้งเพิ่มและลดสต็อก",
    ISA_StockAdjustmentShortHint: "ระบุจำนวนที่เปลี่ยนแปลง ไม่ใช่ยอดคงเหลือใหม่",
    ISA_StockAdjustmentSelectHint: "เลือกสินค้า แล้วระบุจำนวนเพิ่มหรือลดในตาราง",
    ISA_StockAdjustmentIncrease: "เพิ่มสต็อก",
    ISA_StockAdjustmentDecrease: "ลดสต็อก",
    ISA_StockAdjustmentPositiveExample: "กรอก 10 → เพิ่มสินค้าในคลัง 10 หน่วย",
    ISA_StockAdjustmentNegativeExample: "กรอก -10 → ลดสินค้าในคลัง 10 หน่วย",
    ISA_StockAdjustmentQuantityHelp: "เลือกสินค้า แล้วกรอกจำนวนในตาราง: ค่าบวก = เพิ่มสต็อก / ค่าติดลบ = ลดสต็อก",
    ISA_StockAdjustmentDeltaHelp: "กรอกจำนวนที่ต้องการเพิ่มหรือลด ไม่ใช่ยอดคงเหลือใหม่ จากนั้นกดบันทึกการปรับสต็อก",
    ISA_StockAdjustmentEnterQuantity: "ระบุจำนวนที่ต้องการปรับ",
    ISA_StockAdjustmentNoChange: "ไม่เปลี่ยนแปลงสต็อก",
    ISA_StockAdjustmentQuantity: "จำนวนปรับ (+/−)",
    ISA_StockAdjustmentSelectProduct: "เลือกรายการสินค้า",
    ISA_StockAdjustmentRemoveLine: "นำรายการออกจากเอกสาร",
    ISA_StockAdjustmentSave: "บันทึกการปรับสต็อก",
    ISA_StockAdjustmentIncreaseOnly: "เอกสารประเภทนี้เพิ่มสต็อกได้อย่างเดียว (จำนวนบวก)",
    ISA_StockAdjustmentDecreaseOnly: "เอกสารประเภทนี้ลดสต็อกได้อย่างเดียว (จำนวนติดลบ)",
    ISA_StockAdjustmentExampleCount: "ตัวอย่าง: ในระบบมี 50 นับได้จริง 45 → กรอก −5",
    ISA_StockAdjustmentExampleIncrease: "ตัวอย่าง: รับสินค้าเข้า 20 → กรอก 20",
    ISA_StockAdjustmentExampleDecrease: "ตัวอย่าง: นำสินค้าออก 5 → กรอก −5",
    ISA_StockAdjustmentNegativeTip: "พิมพ์ − ได้ทุกตำแหน่ง หรือกดปุ่ม ± หน้าช่องจำนวน เพื่อเปลี่ยนเป็นค่าติดลบ",
    ISA_StockAdjustmentReadOnlyHint: "เอกสารนี้อนุมัติหรือไม่อนุมัติแล้ว จึงแก้ไขจำนวนไม่ได้",
    ISA_StockAdjustmentEnterDecrease: "ระบุจำนวนที่ต้องการลด",
    ISA_StockAdjustmentQuantityRequired: "กรุณาระบุจำนวน (ไม่ปรับให้กรอก 0)",
    ISA_StockAdjustmentWholeNumberOnly: "กรอกได้เฉพาะจำนวนเต็ม",
    ISA_StockAdjustmentInvalidQuantity: "จำนวนไม่ถูกต้อง",
    ISA_StockAdjustmentMustBePositive: "ต้องเป็นจำนวนบวก",
    ISA_StockAdjustmentMustBeNegative: "ต้องเป็นจำนวนติดลบ",
    ISA_StockAdjustmentToggleSign: "สลับเพิ่ม/ลดสต็อก (+/−)",
    ISA_StockAdjustmentFixQuantities: "กรุณาแก้ไขจำนวนก่อนบันทึก",
    ISA_Theory: "ทฤษฏี",
    ISA_Title_AverageSellingPrice: "ราคาขายเฉลี่ยรายเดือนรายสินค้า",
    ISA_Title_BestSellingProduct: "สินค้าขายดีมากที่สุด",
    ISA_Title_CompareProduct: "สินค้าใหม่เทียบสินค้าเดิม",
    ISA_Title_CompareSales: "ยอดขายเปรียบเทียบเดือนปัจจุบันกับเดือนก่อน",
    ISA_Title_LowestSellingProduct: "สินค้ายอดขายต่ำที่สุด",
    ISA_Title_MonthlyBestSeller: "สินค้าขายดีประจำเดือน",
    ISA_Title_OurtstandingBalance: "ยอดสินค้าค้างส่ง",
    ISA_Title_ReturnAmount: "คืนสินค้า (Credit Note)",
    ISA_Title_ReturnData: "ข้อมูลยอดคืนสินค้า",
    ISA_Title_ReturnReason: "แจ้งคืนสินค้า (Good Return Note)",
    ISA_Title_SalesProportion: "สัดส่วนยอดขายสินค้า",
    ISA_Total: "รวม",
    ISA_YTD: "YTD",
    ISA_TotalDistance: "ระยะทางรวม",
    ISA_ViewDetail: "ดูรายละเอียด",
    ISA_ViewDocAttachFile: "ดูไฟล์แนบ",
    ISA_ViewDocImage: "ดูภาพถ่าย",
    ISA_ViewVisitPlan: "ดูแผนการเข้าเยี่ยม",
    ISA_Visit: "การเข้าเยี่ยม",
    ISA_VisitedMemo: "บันทึกการเข้าเยี่ยม",
    ISA_VisitContactName: "ชื่อผู้ติดต่อ",
    ISA_Username: "ชื่อผู้ใช้",
    ISA_VisitDate: "วันที่เข้าเยี่ยม",
    ISA_VisitDistanceKm: "ระยะห่างระหว่างจุด Check In (กิโลเมตร)",
    ISA_VisitDistanceKmInDay: "ระยะห่างระหว่างจุด Check In (กิโลเมตร) รายวัน",
    ISA_VisitMemoSubject: "ประเภทของข้อความ",
    ISA_VisitPlan: "แผนการเข้าเยี่ยม",
    ISA_VisitPlanData: "ข้อมูลการเข้าเยี่ยม",
    ISA_VisitPlanDate: "วันที่ตามแผน",
    ISA_VisitPlanName: "ชื่อแผนการเข้าเยี่ยม",
    ISA_VisitPlanReport_Title: "รายงานการทำงานตามแผน",
    ISA_VisitPlan_CompareCheckIn: "Detail",
    ISA_VisitPlan_PastDue: "เลยกำหนด ไม่มีการเข้าเยี่ยม",
    ISA_VisitPlan_ToDoListDo: "Todo List ที่ทำ",
    ISA_VisitPlan_ToDoListNotDo: "Todo List ที่ไม่ได้ทำ",
    ISA_VisitPlan_VisitInPlan: "เข้าเยี่ยมตามแผน",
    ISA_VisitPlan_VisitNotInPlan: "เข้าเยี่ยมนอกแผน",
    ISA_VisitTimeEnd: "เข้าเยี่ยม(ถึง)",
    ISA_VisitTimeStart: "เข้าเยี่ยม(ตั้งแต่)",
    ISA_VisitType: "การเยี่ยม",
    ISA_Visit_EndDate: "สิ้นสุดการเข้าเยี่ยม",
    ISA_Visit_ShowDetail: "ตารางแสดงรายละเอียดการ Check In และ To Do List",
    ISA_Visit_ShowMap: "แสดงแผนที่",
    ISA_Visit_ShowRouteCheckIn: "แสดงเส้นทาง Check In",
    ISA_Visit_ShowRouteMap: "แสดงเส้นทางตามแผน",
    ISA_Visit_StartDate: "เริ่มเข้าเยี่ยม",
    ISA_VistitInPlan: "เข้าจริงตามแผน",
    ISA_VistitOutPlan: "เข้าจริงนอกแผน",
    ISA_Warehouse: "คลังสินค้า",
    ISA_FromWarehouse: "จากคลังสินค้า",
    ISA_FromLocation: "จากตำแหน่ง",
    ISA_ToWarehouse: "ไปคลังสินค้า",
    ISA_ToLocation: "ไปตำแหน่ง",
    ISA_prospectCreditTerm: "จำนวนวันเครดิต",
    "ISA_ImportCustomer/ProductData": "นำเข้า ข้อมูล ลูกค้า / สินค้า",
    ISA_InCompleteData: "ข้อมูลไม่ครบถ้วน / ข้อมูลไม่ถูกต้อง!",
    ISA_Invalid: "ไม่ถูกต้อง",
    ISA_ItemNumber: "ลำดับรายการ",
    ISA_ItemRemark: "หมายเหตุรายการ",
    ISA_Items: "รายการ",
    ISA_ItemTitle: "หมายเหตุท้ายบิล",
    ISA_AddProductItems: "เพิ่มรายการสินค้า",
    ISA_EditItems: "แก้ไขรายการ",
    ISA_EditDocInfo: "แก้ไขข้อมูลเอกสาร",
    ISA_ItemCategory: "หมวดสินค้า",
    ISA_ProductGroup: "กลุ่มสินค้า",
    ISA_ProductBrand: "ยี่ห้อ",
    ISA_NotUsed: "ไม่ได้ใช้งาน",
    ISA_ProductType: "ประเภทสินค้า",
    ISA_ProductVatType: "ประเภทสินค้าVat",
    ISA_SelectedItems: "รายการที่เลือก",
    ISA_SelectQuantityForAll: "เลือกจำนวนทั้งหมด:",
    ISA_NoItemsSelected: "ยังไม่มีรายการที่เลือก",
    ISA_SelectProductFromLeft: "เลือกสินค้าจากรายการด้านซ้าย",
    ISA_StockRemaining: "สต็อกคงเหลือ:",
    ISA_CannotLoadDocument: "ไม่สามารถโหลดข้อมูลเอกสารได้",
    ISA_CannotLoadFormData: "ไม่สามารถโหลดข้อมูลลงฟอร์มได้",
    ISA_CannotOpenForm: "ไม่สามารถเปิดฟอร์มได้",
    ISA_Error500ServerInternal:
      "เกิดข้อผิดพลาดที่ Server (500 Internal Server Error)\n\nกรุณาติดต่อผู้ดูแลระบบหรือลองใหม่อีกครั้ง",
    ISA_Error404NotFound:
      "ไม่พบ API endpoint\n\nกรุณาตรวจสอบว่า API endpoint ถูกต้องหรือไม่",
    ISA_NoProductYet: "ยังไม่มีรายการสินค้า",
    ISA_ClickAddItemToStart: 'กดปุ่ม "เพิ่มรายการ" เพื่อเริ่มเพิ่มสินค้า',
    ISA_SavingData: "กำลังบันทึกข้อมูล...",
    ISA_Error: "ข้อผิดพลาด",
    ISA_Warning: "คำเตือน",
    ISA_SalesmanNotAssigned: "กรุณาเลือกพนักงานขายผู้ดูแลลูกค้า ก่อนทำการบันทึกพิกัด",
    ISA_SaveDraftButton: "บันทึกฉบับร่าง",
    ISA_CreateDocButton: "สร้างเอกสาร",
    ISA_LastMonth: "เดือนก่อน",
    ISA_LastPurchaseDate: "วันที่ซื้อล่าสุด",
    ISA_Latitude: "ละติจูด",
    ISA_LocationName: "ชื่อสถานที่",
    ISA_Logoff: "ออกจากระบบ",
    ISA_LogonText: "เข้าสู่ระบบ",
    ISA_Longtitude: "ลองติจูด",
    ISA_Lot: "วันหมดอายุ",
    ISA_MKTEvents: "กิจกรรมการตลาด",
    "ISA_Manage Events": "จัดการ กิจกรรมการตลาด",
    ISA_Map: "แผนที่",
    ISA_MasTfrLine23: "ครั้ง",
    ISA_MasTfrLine94: "ดำเนินการ...",
    "ISA_Meeting Agenda": "Visiting Information",
    ISA_Meters: "เมตร",
    ISA_Minutes: "นาที",
    ISA_Hours: "ชั่วโมง",
    ISA_NCFAddress: "ที่อยู่",
    ISA_NCFNo: "ไม่",
    ISA_Name: "ชื่อ*",
    ISA_Net: "ยอดสุทธิ",
    ISA_NetAmount: "จำนวนเงินสุทธิ",
    ISA_NoDiscount: "ยังไม่มีรายการส่วนลด",
    ISA_NoUse: "ไม่ใช้งาน",
    ISA_NotPrint: "ไม่พิมพ์",
    ISA_Number: "เลขที่",
    ISA_OK: "OK",
    ISA_OrderDocOther1: "Plant",
    ISA_OrderStatus_H6: "วันที่ SO",
    ISA_OrderStatus_H7: "วันที่ DO",
    ISA_OrderStatus_H8: "วันที่ BILL",
    ISA_Original: "ต้นฉบับ",
    ISA_Other: "ทั่วไป",
    ISA_PODate: "วันที่สั่ง",
    ISA_PODate1: "วันที่ใบสั่งซื้อ",
    ISA_PONo: "เลขที่ใบสั่งซื้อลูกค้า",
    ISA_PONo1: "เลขที่ใบสั่งซื้อ",
    ISA_Page: "Page",
    ISA_Password: "รหัสผ่าน",
    ISA_PasswordExpired_Title: "รหัสผ่านหมดอายุ",
    ISA_PasswordExpired_Message:
      "รหัสผ่านของคุณหมดอายุแล้ว กรุณาเปลี่ยนรหัสผ่านก่อนเข้าสู่ระบบ",
    ISA_PasswordExpired_SignedInMessage:
      "รหัสผ่านของคุณหมดอายุแล้ว ระบบได้ออกจากระบบให้อัตโนมัติ กรุณาเปลี่ยนรหัสผ่านก่อนเข้าสู่ระบบอีกครั้ง",
    ISA_PasswordExpired_ResetLink: "คลิกที่นี่เพื่อเปลี่ยนรหัสผ่าน",
    ISA_License_ExpiredLogin_Title: "License หมดอายุ",
    ISA_License_ExpiredLogin_Message:
      "License ของบริษัทหมดอายุแล้ว ไม่สามารถเข้าสู่ระบบได้ กรุณาติดต่อฝ่ายขายเพื่อต่ออายุการใช้งาน",
    ISA_License_Chip_Remaining: "เหลือ {days} วัน",
    ISA_License_Chip_LastDay: "หมดอายุวันนี้",
    ISA_License_Chip_Expired: "หมดอายุแล้ว",
    ISA_License_Chip_Requested: "ส่งคำขอต่ออายุแล้ว",
    ISA_License_Title_Info: "แจ้งเตือนการต่ออายุ License",
    ISA_License_Title_Warning: "License ใกล้หมดอายุ",
    ISA_License_Title_Danger: "License ใกล้หมดอายุมาก",
    ISA_License_Title_Tomorrow: "License จะหมดอายุพรุ่งนี้",
    ISA_License_Title_LastDay: "License หมดอายุวันนี้",
    ISA_License_Title_Expired: "License หมดอายุแล้ว",
    ISA_License_Message_Info:
      "ระบบยังใช้งานได้ตามปกติ แจ้งต่ออายุไว้ล่วงหน้า เพื่อให้ทีมของคุณใช้งานต่อได้ไม่สะดุด",
    ISA_License_Message_Warning:
      "ระบบยังใช้งานได้ตามปกติ แนะนำให้แจ้งต่ออายุตอนนี้ เพื่อให้ทีมงานดำเนินการได้ทันก่อนวันหมดอายุ",
    ISA_License_Message_Danger:
      "กรุณาแจ้งต่ออายุโดยเร็ว เมื่อ License หมดอายุแล้วจะไม่สามารถเข้าสู่ระบบได้",
    ISA_License_Message_Expired:
      "License ของบริษัทหมดอายุแล้ว ผู้ใช้จะเข้าสู่ระบบใหม่ไม่ได้จนกว่าจะต่ออายุ กรุณาแจ้งต่ออายุเพื่อใช้งานต่อ",
    ISA_License_RemainingLabel: "เหลือเวลาอีก",
    ISA_License_Days: "วัน",
    ISA_License_ExpireOn: "หมดอายุวันที่ {date}",
    ISA_License_Later: "ไว้ภายหลัง",
    ISA_License_Request: "แจ้งขอต่ออายุ",
    ISA_License_RequestFailed: "ส่งคำขอไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    ISA_License_Sent_Title: "ส่งคำขอต่ออายุแล้ว",
    ISA_License_Sent_Message: "ทีมงานได้รับคำขอของบริษัทคุณแล้ว และจะติดต่อกลับเพื่อดำเนินการต่ออายุ",
    ISA_License_Sent_Info: "ส่งเมื่อ {date} · โดย {name}",
    ISA_License_Sent_Shared: "ผู้ใช้คนอื่นในบริษัทจะเห็นสถานะนี้ ไม่ต้องส่งซ้ำ",
    ISA_License_Close: "ปิด",
    ISA_ConfirmPassword: "ยืนยันรหัสผ่าน",
    ISA_FirstName: "ชื่อจริง",
    ISA_PhoneNumber: "เบอร์โทรศัพท์",
    ISA_CompanyOrOrganization: "บริษัท/องค์กร",
    ISA_PersonalInfo: "ข้อมูลส่วนตัว",
    ISA_PayBy: "ชำระโดย",
    ISA_Payment2: "การชำระเงิน",
    ISA_PaymentTerm: "ระยะเวลาการชำระเงิน",
    ISA_AP_NoDataFromPrevPage:
      "ไม่พบข้อมูลจากหน้าก่อนหน้า กรุณาเลือกรายการจากหน้า AP Transaction",
    ISA_AP_CannotSelectMoreThanOneSupplier:
      "ห้ามเลือกมากกว่า 1 Supplier ต่อการชำระเงิน",
    ISA_AP_CannotSelectMoreThanOneSupplierReceipt:
      "ห้ามเลือกมากกว่า 1 Supplier Receipt Number ต่อการชำระเงิน",
    ISA_AP_PleaseSelectItemsToPay: "กรุณาเลือกรายการที่ต้องชำระเงิน",
    ISA_Percent: "เปอร์เซ็นต์",
    ISA_PercentTarget: "%เป้า",
    ISA_PercentLastMonth: "%เดือนก่อน",
    ISA_Period: "ช่วงวันที่",
    ISA_Picture: "ภาพถ่าย",
    ISA_PleaseCheck: "กรุณาตรวจสอบข้อมูล",
    ISA_PleaseCheckEmployeeStatus:
      "กรุณาตรวจสอบว่ารหัสพนักงานนี้มี สถานะ เปิดระบบ",
    ISA_PleaseSelect: "กรุณาเลือก",
    "ISA_PrepareSales,Returned,StockTransaction":
      "จัดเตรียม รายการ ซื้อ คืน สต็อค อื่นๆ",
    ISA_Price: "ราคา",
    ISA_PricePerUnit: "ราคา / หน่วย",
    ISA_Print: "พิมพ์",
    ISA_PrintBillMsg1: "ยอดค้างชำระต้องไม่เกิน",
    ISA_ProductCode: "รหัสสินค้า",
    ISA_ProductCustomName: "คำอธิบาย",
    ISA_ProductEvent: "สินค้าร่วมรายการ",
    ISA_ProductInformation: "ข้อมูลสินค้า / ราคา และส่วนลด",
    ISA_ProductName: "ชื่อสินค้า",
    ISA_ProductUnitQty1: "QTY 1",
    ISA_productUnitQty2: "QTY 2",
    ISA_productUnitQty3: "QTY 3",
    ISA_productUnitQty4: "QTY 4",
    ISA_productPricePerUnit1: "ราคา/หน่วย 1",
    ISA_productPricePerUnit2: "ราคา/หน่วย 2",
    ISA_productPricePerUnit3: "ราคา/หน่วย 3",
    ISA_productPricePerUnit4: "ราคา/หน่วย 4",
    ISA_productPrice1: "กรุณากรอก",
    ISA_productPrice2: "กรุณากรอก",
    ISA_productPrice3: "กรุณากรอก",
    ISA_productPrice4: "กรุณากรอก",
    ISA_ProductItemCount: "จำนวนรายการสินค้า",
    ISA_ProductQuantity: "จำนวนสินค้า",
    ISA_ProductQuantityFree: "จำนวนสินค้าแถม",
    ISA_ProductRemark: "หมายเหตุ สินค้า",
    ISA_Location_Type: "ตำแหน่ง",
    "ISA_QN1-1": "เข้าเยี่ยมสม่ำเสมอ",
    "ISA_QN1-2": "ความรู้ในผลิตภัณท์และการนำเสนอ",
    "ISA_QN1-3": "การให้บริการลูกค้า",
    "ISA_QN1-4": "ความเหมาะสมในการแต่งการและการพูดจา",
    "ISA_QN1-5": "ความสามารถและความรวดเร็วในการแก้ปัญหาให้แก่ลูกค้า",
    "ISA_QN2-1": "ความถูกต้องของสินค้าที่สั่ง",
    "ISA_QN2-2": "ความรวดเร็วในการส่งสินค้า",
    "ISA_QN2-3": "สภาพหีบห่อสินค้าที่ได้รับ",
    "ISA_QN3-1": "คุณภาพและประสิทธิภาพของผลิตภัณท์",
    "ISA_QN3-2": "ความสะดวกในการใช้งาน",
    "ISA_QN3-3": "ขนาดบรรจุและคู่มือการใช้งาน",
    "ISA_QN4-1": "ความรวดเร็วในการให้บริการ",
    "ISA_QN4-2": "ประสิทธิภาพการให้บริการหรือซ่อมบำรุง",
    "ISA_QN4-3": "การติดต่อสื่อสารกับลูกค้าและความสุภาพ",
    ISA_QTYPending: "ค้างรับ",
    ISA_QTYReceive: "จำนวนรับ",
    ISA_QuoPrice: "ราคาต่อหน่วย",
    ISA_QuteDocType: "ประเภทเอกสาร",
    ISA_Reason: "เหตุผลในการคืน",
    "ISA_ReceivedDate(LT": "วันที่รับสินค้า (ปกติ",
    "ISA_Recurrence(Monthly)": "นัดวันเข้าเยี่ยม (เดือน)",
    "ISA_Recurrence(Weekly)": "นัดวันเข้าเยี่ยม (สัปดาห์)",
    ISA_RefInvoice: "อ้างถึงใบกำกับภาษี",
    ISA_RefQuote: "อ้างอิงใบเสนอราคา",
    ISA_Remain: "คงเหลือ",
    ISA_Remaining: "เหลือ",
    ISA_RepresentativeName: "ชื่อพนักงานขาย",
    ISA_Required: "ต้องระบุ",
    ISA_ReturnDate: "วันกำหนดรับสินค้า",
    ISA_ReturnReason: "ประเภทปัญหา",
    ISA_SVCreditTerm: "เครดิต",
    "ISA_SalesAnalysisbyCustomer/Product":
      "รายงาน วิเคราะห์ขาย ลูกค้า / สินค้า -1",
    "ISA_SalesAnalysisbyProduct/Customer":
      "รายงาน วิเคราะห์ขาย สินค้า / ลูกค้า -1",
    ISA_SalesHistory: "ประวัติการสั่งซื้อ",
    ISA_SalesOrg: "องค์กรขาย",
    ISA_SelectReason: "เลือกเหตุผล",
    ISA_SelectStatusToChange: "เลือกสถานะที่ต้องการเปลี่ยนเป็น",
    ISA_SalesTarget: "เป้าขาย",
    ISA_SalesmanProcessStatusData: "สถานะพนักงานขาย",
    ISA_Save: "บันทึก",
    ISA_Save1: "บันทึกข้อมูล",
    ISA_SaveData: "ต้องการบันทึกข้อมูล?",
    ISA_SaveDraftHeader: "ต้องการ บันทึกร่างข้อมูล…",
    ISA_SaveItemSuccess: "บันทึกรายการเรียบร้อยแล้ว",
    ISA_Search: "ค้นหา",
    ISA_SelectCustomerShort: "เลือกลูกค้า",
    ISA_SelectDate: "เลือกวันที่",
    ISA_SelectPdfType: "เลือกประเภท PDF",
    ISA_SelectProduct: "เลือกสินค้า",
    ISA_SelectTime: "เลือกเวลา",
    ISA_Sell: "ขายสินค้า",
    ISA_Sent: "ส่งแล้ว",
    ISA_ShipToAddress: "ชื่อสถานที่ส่งจริง",
    ISA_ShipToDate: "วันที่ส่งสินค้า",
    ISA_StartDate: "วันที่เริ่ม",
    ISA_StatusLabel: "สถานะ (Status)",
    ISA_Stock: "สินค้าคงเหลือ",
    ISA_StockCount: "นับสต็อค",
    ISA_StockCountDate: "วันที่นับจริง",
    ISA_StockCountItems: "รายการสินค้านับสต็อก",
    ISA_StockMessage03:
      "ต้องการ บันทึกร่าง\\nรายการนับสต๊อกสินค้า\\nใช่หรือไม่ ?",
    ISA_StockMessage04: "ต้องการ บันทึก\\nรายการนับสต๊อกสินค้า\\nใช่หรือไม่ ?",
    ISA_SubmitWarning: "การยืนยันจะทำให้เอกสารถูกส่งและเปลี่ยนสถานะ",
    ISA_Surname: "นามสกุล",
    ISA_Target: "เป้าการขาย",
    ISA_TitleCancelPendingDelivery: "ยกเลิกสถานะค้างส่ง",
    ISA_ValidPeriod: "กำหนดยืนราคา",
    ISA_VAT: "VAT",
    // ISA_TaxId: "เลขประจำตัวผู้เสียภาษี", // REMOVED: Use ISA_TaxID instead
    ISA_TaxInvoiceDate: "วันที่ใบกำกับภาษี",
    ISA_TaxNumber: "Tax ID",
    ISA_Tel: "โทร.",
    ISA_TelephoneNumber: "เบอร์ติดต่อ",
    ISA_Time: "เวลา",
    ISA_To: "ถึง",
    ISA_ToDate: "ถึงวันที่",
    ISA_ToPlant: "คลังรับ",
    ISA_ToastMsg10: "ไม่สามารถ คัดลอก(Copy) ข้อมูลจนเสร็จสิ้น",
    ISA_ToastMsg73: "กรุณาลองใหม่อีกครั้ง",
    ISA_Total2: "ยอดรวม",
    ISA_TotalAmount: "รวมเงิน",
    ISA_TotalBeforeVAT: "ยอดก่อนรวมVAT",
    ISA_TotalDiscount: "รวมส่วนลด",
    ISA_TotalPayment: "รวมชำระ",
    ISA_TotalPrice: "รวมราคา",
    ISA_TransferDate: "วันที่โอนข้อมูล",
    ISA_Type: "ประเภท",
    ISA_Unapproved: "ไม่อนุมัติ",
    ISA_Unit: "หน่วย",
    ISA_UnitPiece: "ชิ้น",
    ISA_UnitBox: "กล่อง",
    ISA_UnitCrate: "ลัง",
    ISA_UnitTray: "แผง",
    ISA_UnitPack: "แพ็ค",
    ISA_UpdateItemSuccess: "อัพเดทรายการเรียบร้อยแล้ว",
    ISA_DeleteAllUnitsOfProduct: "ลบสินค้านี้ (ทุกหน่วย)",
    ISA_Qty: "จำนวน",
    ISA_Unit2: "Unit2",
    ISA_User: "พนักงาน",
    ISA_UserAccount: "ผู้ใช้งาน",
    ISA_Userid: "รหัสพนักงาน",
    "ISA_VRPField1.0.1": "ผู้ติดต่อเพิ่มเติม 1",
    "ISA_VRPField1.0.2": "ผู้ติดต่อเพิ่มเติม 2",
    "ISA_VRPField1.0.3": "วัตถุประสงค์การเข้าพบ*",
    "ISA_VRPField1.0.4": "สถานะการเข้าพบ*",
    "ISA_VRPField1.1-1": "Pipeline Stage",
    "ISA_VRPField1.1-2": "ลูกค้ามีโครงการ",
    "ISA_VRPField1.1-3": "จบออเดอร์ เดือน",
    "ISA_VRPField1.1.1": "แจ้ง Promotion",
    "ISA_VRPField1.1.1-R1C2": "Model",
    "ISA_VRPField1.1.1-R1C4": "โอกาสจบ",
    "ISA_VRPField1.1.1-R5C1": "ประเภท Other",
    "ISA_VRPField1.1.2": "คืนของ",
    "ISA_VRPField1.1.3": "ตกแต่ง Shelf",
    "ISA_VRPField1.2.1": "เช็ค Stock",
    "ISA_VRPField1.2.2": "เปิดร้านใหม่",
    "ISA_VRPField2.1-1": "ผลิตภัณฑ์ใหม่",
    "ISA_VRPField2.1-2": "โครงสร้าง",
    "ISA_VRPField2.1-3": "อุปกรณ์",
    "ISA_VRPField2.1-6": "บริการ",
    "ISA_VRPField2.1-7": "กิจกรรมอื่นๆ",
    "ISA_VRPField2.1.1": "กลุ่มประกัน",
    "ISA_VRPField2.1.2": "ตามสวัสดิการพนักงานองค์กร",
    "ISA_VRPField2.1.3": "ตามประเภท",
    "ISA_VRPField2.2.1": "เป้าหมายชีวิต",
    "ISA_VRPField2.2.1-1": "การตัดสินใจ",
    "ISA_VRPField2.2.2": "ช่วงอายุ",
    "ISA_VRPField2.2.2-1": "ชื่อคู่แข่ง",
    "ISA_VRPSection2.1": "ข้อเสนอแนะจากลูกค้า",
    "ISA_VRPSection2.2": "ความเห็นจากเจ้าหน้าที่ขาย",
    "ISA_VRPSection2.2.1": "ความต้องการของลูกค้า",
    "ISA_VRPSection2.3": "ข้อเสนอแนะผู้จัดการส่วนขาย",
    ISA_Value: "ค่าสินค้า",
    ISA_Waiting: "กำลังรอ",
    ISA_WarehouseShort: "คลัง",
    ISA_YesOrNo: "ใช่หรือไม่ ?",
    ISA_ZipCode: "รหัสไปรษณีย์",
    "ISA_selection1.1": "CRQ NO.",
    // RequisitionApprove.js - Keys for approval workflow
    ISA_RejectReasonOptional: "เหตุผลไม่อนุมัติ (ไม่บังคับ)",
    ISA_EnterRejectReason: "กรอกเหตุผลไม่อนุมัติ... (ถ้ามี)",
    // index.js - Additional keys for main list
    ISA_NoDataFound: "ไม่พบข้อมูล",
    ISA_PleaseSelectSearchCondition: "กรุณาเลือกเงื่อนไขการค้นหาและกดปุ่มค้นหา",

    // Additional hardcoded text fixes
    ISA_CannotAddProduct: "ไม่สามารถเพิ่มสินค้า",
    ISA_ErrorAddingProduct: "เกิดข้อผิดพลาดในการเพิ่มสินค้า",
    ISA_AddProductSuccess: "เพิ่มสินค้าสำเร็จ",
    ISA_AddDataSuccess: "เพิ่มข้อมูลสำเร็จ",
    ISA_DeleteProject: "ลบโครงการ",
    ISA_OperationSuccessDoc: "ดำเนินการสำเร็จ เอกสาร",
    ISA_SystemWillReturnToList: "ระบบกำลังนำคุณกลับไปยังหน้ารายการเอกสาร",
    ISA_ConfirmApproveDoc: "ยืนยันการอนุมัติเอกสาร",
    ISA_WantToApproveDoc: "คุณต้องการอนุมัติเอกสารเบิกสินค้า",
    ISA_SystemWillTransferStock:
      "ระบบจะทำการโอนย้ายสินค้าจากคลังจ่ายไปยังคลังรับ",
    ISA_CannotEditAfterApprove: "ไม่สามารถแก้ไขหรือยกเลิกได้หลังจากอนุมัติ",
    ISA_NoProductList: "ไม่พบรายการสินค้า",
    ISA_NoProductForThisDoc: "ไม่มีรายการสินค้าสำหรับเอกสารนี้",

    // RequisitionApprove.js - Reject dialog and additional keys
    ISA_ConfirmApprove: "ยืนยันอนุมัติ",
    ISA_RejectDoc: "ไม่อนุมัติเอกสาร",
    ISA_WantToRejectDoc: "คุณต้องการไม่อนุมัติเอกสารเบิกสินค้า",
    ISA_ConfirmReject: "ยืนยันไม่อนุมัติ",
    ISA_CancelProject: "ยกเลิกโครงการ",

    // RequisitionItem.js & RequisitionItemNew.js
    ISA_WantToDeleteProduct: "ต้องการลบสินค้า",
    ISA_ShowOnlyNonERP  : "แสดงเฉพาะลูกค้าที่ยังไม่ได้อัพเดทรหัสลูกค้า (ERP)",
    ISA_ERPBatch_Pending: "เลือกรหัสลูกค้า (ERP) ไว้ยังไม่บันทึก",
    ISA_ERPBatch_Items: "รายการ",
    ISA_ERPBatch_ClearAll: "ล้างที่เลือก",
    ISA_ERPBatch_ConfirmTitle: "ยืนยันอัพเดทรหัสลูกค้า (ERP)",
    ISA_ERPBatch_DuplicateWarn: "มีรหัสลูกค้า (ERP) ซ้ำกันในรายการ",
    ISA_ERPBatch_Saving: "กำลังบันทึก",
    ISA_ERPBatch_ResultTitle: "ผลการบันทึก",
    ISA_ERPBatch_Success: "สำเร็จ",
    ISA_ERPBatch_Failed: "ไม่สำเร็จ",

    // CloseDate validation messages (from I18n.js.backup)
    ISA_CloseDate: "วันที่สิ้นสุดโครงการ",
    ISA_CloseDate_Required: "กรุณาเลือกวันที่ปิดโครงการ",
    ISA_CloseDate_Past_Error: "คำแนะนำ: วันปิดโครงการไม่ควรเป็นวันที่ในอดีต",
    ISA_CloseDate_Too_Old_Error:
      "วันที่เก่าเกินไป กรุณาเลือกวันที่ที่เหมาะสมสำหรับโครงการ",
    ISA_CloseDate_Before_Start_Error: "วันปิดโครงการต้องมาหลังวันเริ่มโครงการ",
    ISA_CloseDate_Too_Far_Error:
      "วันที่ไกลเกินไป กรุณาเลือกวันที่ภายใน 10 ปีข้างหน้า",
    ISA_CloseDate_Aria_Label: "เลือกวันที่ปิดโครงการ",
    ISA_CloseDate_Placeholder: "เลือกวันที่...",
    ISA_CloseDate_Valid: "วันที่ถูกต้อง",
    ISA_CloseDate_Selected: "วันที่เลือก",
    ISA_CloseDate_Days_From_Today: "จำนวนวันจากวันนี้",
    ISA_CloseDate_Duration: "ระยะเวลาโครงการ",

    // Project related (from I18n.js.backup)
    ISA_Probabilty: "ความน่าจะเป็น",
    ISA_ProjectActive: "โครงการที่ Active",
    ISA_ProjectInactive: "โครงการที่ Inactive",
    ISA_CreateProject: "สร้างโครงการ",

    // Filter related (from I18n.js.backup)
    ISA_FilterProductType: "ประเภทสินค้า",
    ISA_FilterCustomerRY: "นับจากเดือนสุดท้ายของตาราง",

    // OrderImport columns (from I18n.js.backup)
    ISA_OrderImport_Column1: "เลขที่PO",
    ISA_POItem: "PO Item",
    ISA_SupplierProductName: "ชื่อสินค้าผู้จำหน่าย",
    ISA_OrderQuantity: "จำนวนสั่ง",
    ISA_GlobalProductCode: "รหัสสินค้าGlobal",
    ISA_OrderImport_Column8: "วันที่ PO",
    ISA_PriceNonVat: "ราคา (non VAT)",

    // OrderLog columns (from I18n.js.backup)
    ISA_ISA_OrderLog_Column1: "Status",
    ISA_ISA_OrderLog_Column2: "Datetime",
    ISA_ISA_OrderLog_Column3: "ModifyDatetime",
    ISA_ISA_OrderLog_Column4: "Modifyby",
    ISA_ISA_OrderLog_Column6: "Branch",
    ISA_ISA_OrderLog_Column7: "PODate",
    ISA_ISA_OrderLog_Column8: "ErrorMessage",
    ISA_ISA_OrderLog_Column9: "DocNumber",

    // Return Transaction - Dialog Discount Forms
    ISA_ActualDiscount: "ส่วนลดจริง",
    ISA_AddNewDiscount: "เพิ่มส่วนลดใหม่",
    ISA_AllDiscountTypesUsed: "ประเภทส่วนลดถูกใช้หมดแล้ว",
    ISA_CalculatedDiscount: "ยอดส่วนลดที่คำนวณได้",
    ISA_ConfirmDeleteDiscount: "คุณต้องการลบส่วนลดนี้หรือไม่?",
    ISA_DeleteDiscountSuccess: "ลบส่วนลดเรียบร้อยแล้ว",
    ISA_DeleteSuccess: "ลบสำเร็จ!",
    ISA_DiscountExceedsTotal: "ส่วนลดไม่สามารถเกินยอดรวมที่เหลือได้",
    ISA_DiscountMethodLabel: "วิธีคำนวณส่วนลด",
    ISA_DiscountPercent: "เปอร์เซ็นต์ (%)",
    ISA_DiscountPercentMax100: "ส่วนลดเปอร์เซ็นต์ต้องไม่เกิน 100%",
    ISA_DiscountTypeAlreadyUsed: "ประเภทส่วนลดนี้ถูกใช้งานแล้ว",
    ISA_EditDiscount: "แก้ไขส่วนลด",
    ISA_FillDataBeforeSave: "กรุณากรอกข้อมูลให้ครบถ้วนก่อนบันทึก",
    ISA_ManageTH: "จัดการ",
    ISA_NoDiscountType: "ไม่มีประเภทส่วนลด",
    ISA_PleaseEnterDiscountAmount: "กรุณาระบุจำนวนส่วนลด",
    ISA_PleaseSelectDiscountMethod: "กรุณาเลือกวิธีคำนวณส่วนลด",
    ISA_PleaseSelectDiscountType: "กรุณาเลือกประเภทส่วนลด",
    ISA_PleaseSelectUnit: "กรุณาเลือกหน่วยนับ",
    ISA_SaveEdit: "บันทึกการแก้ไข",
    ISA_SelectDiscountMethod: "เลือกวิธีคำนวณ",
    ISA_SelectUnit: "เลือกหน่วยนับ",
    ISA_SpecialDiscount: "ส่วนลดท้ายบิลพิเศษ",
    ISA_TotalAfterDiscount: "ยอดหลังหักส่วนลด",
    ISA_TotalBeforeDiscount: "ยอดรวมก่อนส่วนลด",
    ISA_TotalHeadDiscount: "ยอดรวมส่วนลดท้ายบิล",
    ISA_YesDelete: "ใช่, ลบเลย!",

    // Return Transaction - Dialog Create Credit Note
    ISA_CannotCreateCreditNote: "ไม่สามารถสร้างใบลดหนี้ได้",
    ISA_ConfirmCreateCreditNote: "ยืนยันการสร้างใบลดหนี้",
    ISA_ConfirmCreateCreditNoteBtn: "ยืนยัน สร้างใบลดหนี้",
    ISA_ConfirmCreateCreditNoteQuestion: "คุณต้องการสร้างใบลดหนี้นี้หรือไม่?",
    ISA_CreateCreditNoteFromSalesNote: "สร้างใบลดหนี้จากใบ SalesNote",
    ISA_CreateCreditNoteSuccess: "สร้างใบลดหนี้สำเร็จ",
    ISA_CreateSuccess: "สร้างสำเร็จ",
    ISA_CreatingCreditNote: "กำลังสร้างใบลดหนี้...",
    ISA_DataIncomplete: "ข้อมูลไม่ครบถ้วน",
    ISA_DoNotCloseWindow: "กรุณาอย่าปิดหน้าต่างนี้",
    ISA_EnterRemarkPlaceholder: "ระบุหมายเหตุเพิ่มเติม...",
    ISA_ProductPriceDiscountInfo: "ข้อมูลสินค้า / ราคาและส่วนลด",
    ISA_ErrorCreatingCreditNote: "เกิดข้อผิดพลาดในการสร้างใบลดหนี้",
    ISA_ErrorLoadingData: "เกิดข้อผิดพลาดในการโหลดข้อมูล",
    ISA_ErrorPreparingInvoiceData: "เกิดข้อผิดพลาดในการเตรียมข้อมูลใบแจ้งหนี้",
    ISA_ErrorCreatingInvoice: "เกิดข้อผิดพลาดในการสร้างใบแจ้งหนี้",
    ISA_CannotCreateInvoice: "ไม่สามารถสร้างใบแจ้งหนี้ได้",
    ISA_CreateInvoiceSuccess: "สร้างใบแจ้งหนี้สำเร็จ",
    ISA_CreateInvoiceFromSalesNote: "สร้างใบแจ้งหนี้จากใบ SalesNote",
    ISA_ItemCount: "จำนวนรายการ",
    ISA_LineDiscount: "ส่วนลดรายการ",
    ISA_OperationFailed: "การดำเนินการไม่สำเร็จ",
    ISA_PleaseCheckAndTryAgain: "กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง",
    ISA_PleaseRetryOrContactAdmin: "กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ",
    ISA_PleaseSpecifyProductQty: "กรุณาระบุจำนวนสินค้าที่ต้องการออกใบแจ้งหนี้",
    ISA_ProductPriceTotal: "ราคา/หน่วย",
    ISA_Success: "สำเร็จ",
    ISA_ShowOnlyLastRef: "แสดงเฉพาะการอ้างอิงล่าสุด",
    ISA_VATType: "ประเภท VAT",
    ISA_TotalItemDiscount: "รวมส่วนลดรายการ",
    ISA_EditQtyForInvoice:
      "แก้ไขจำนวนสินค้าที่ต้องการออกใบแจ้งหนี้ (ไม่สามารถแก้ไขราคาได้)",

    // Product Filter keys
    ISA_FocusGroup: "กลุ่มสินค้าโฟกัส",
    ISA_FocusLine: "หมวดสินค้าโฟกัส",
    ISA_FocusType: "ประเภทสินค้าโฟกัส",
    ISA_VATType_With: "มี VAT",
    ISA_VATType_Without: "ไม่มี VAT",

    // ==================== NEW KEYS FOR SUPPLIER TRANSACTIONS ====================
    // Warning & Confirmation
    ISA_Warning: "แจ้งเตือน",

    // Supplier PO Transaction
    ISA_PleaseSelectSupplierBeforeAddProduct:
      "กรุณาเลือกซัพพลายเออร์ก่อนเพิ่มรายการสินค้า",
    ISA_PleaseSelectWarehouseBeforeAddProduct:
      "กรุณาเลือกคลังสินค้าก่อนเพิ่มรายการสินค้า",
    ISA_PleaseSelectLocationBeforeAddProduct:
      "กรุณาเลือกตำแหน่งเก็บสินค้าก่อนเพิ่มรายการสินค้า",
    ISA_DocumentRemarkTitle: "หมายเหตุท้ายบิล",
    ISA_DocumentSummaryTitle: "สรุปท้ายบิล",
    ISA_DocumentHeaderTitle: "หัวเอกสาร",
    ISA_DocRefQT: "อ้างอิงเลขที่ใบเสนอราคา",

    // Supplier related
    ISA_Supplier: "ซัพพลายเออร์",
    ISA_SupplierCode: "รหัสซัพพลายเออร์",
    ISA_ChangeSupplier: "เปลี่ยนซัพพลายเออร์",
    ISA_DocumentSupplierTitle: "ข้อมูลซัพพลายเออร์",

    // Document & Form
    ISA_DocumentSalesmanTitle: "ข้อมูลพนักงานขาย",
    ISA_DocumentShipToTitle: "ข้อมูลสถานที่จัดส่ง",
    ISA_DocumentSaleAgreementTitle: "ข้อตกลงการขาย",
    ISA_ButtonSelectDefaultShipTo: "เลือกสถานที่จัดส่งเริ่มต้น",

    // Invoice & Date
    ISA_InvoiceNumber: "เลขที่ใบแจ้งหนี้",
    ISA_InvoiceDate: "วันที่ใบแจ้งหนี้",
    ISA_InvoiceRef: "อ้างถึงใบกำกับภาษี",
    ISA_InvNumber: "เลขที่ Invoice",
    ISA_InvDate: "วันที่ Invoice",
    ISA_InvalidDocDate: "รูปแบบวันที่เอกสารไม่ถูกต้อง",
    ISA_InvalidInvDate: "รูปแบบวันที่ Invoice ไม่ถูกต้อง",
    ISA_InvalidDeliveryDate: "รูปแบบวันที่จัดส่งไม่ถูกต้อง",
    ISA_InvalidShipToDate: "รูปแบบวันที่ส่งไม่ถูกต้อง",
    ISA_PONumber: "เลขที่ PO",

    // Warehouse & Location
    ISA_WarehouseLocation: "ตำแหน่งเก็บสินค้า",
    ISA_WhsLocation: "ตำแหน่งคลัง",

    // Product related
    ISA_ProductImage: "รูปสินค้า",
    ISA_ProductFree: "แถม",
    ISA_ProductQtyPerUnit: "จำนวน/หน่วย",
    ISA_ProductDeleted: "ลบสินค้าเรียบร้อย",

    // Discount related
    ISA_DiscountDetail: "รายละเอียดส่วนลด",
    ISA_DiscountType: "ประเภทส่วนลด",
    ISA_DiscountAmount: "จำนวนส่วนลด",

    // Summary related
    ISA_HeadDiscount: "ส่วนลดท้ายบิล",
    ISA_TotalBeforeVat: "ยอดรวมก่อน VAT",
    ISA_TotalSumDiscount: "ยอดรวมส่วนลด",
    ISA_TotalVat: "ยอด VAT",

    // Actions & Buttons
    ISA_Back: "ย้อนกลับ",
    ISA_Confirm: "ยืนยัน",
    ISA_ConfirmEdit: "ยืนยันการแก้ไข",
    ISA_Button_SubmitForm: "ส่งแบบฟอร์ม",

    // Confirm & Delete
    ISA_ConfirmDeleteText: "คุณต้องการลบ",
    ISA_OrNot: "ใช่หรือไม่?",
    ISA_ConfirmCopyDocument: "คุณต้องการคัดลอกเอกสารนี้ใช่หรือไม่?",
    ISA_OldValue: "ค่าเดิม",
    ISA_NewValue: "ค่าใหม่",
    ISA_Deleting: "กำลังลบ...",
    ISA_Copying: "กำลังคัดลอก...",
    ISA_AreYouSure: "คุณแน่ใจหรือไม่?",
    ISA_CannotRecoverAfterDelete: "การลบนี้ไม่สามารถกู้คืนได้",
    ISA_Deleted: "ลบแล้ว!",
    ISA_Failed: "ผิดพลาด!",
    ISA_NoDetailDataToExport: "ไม่มีข้อมูลรายละเอียดให้ส่งออก",
    ISA_ReceiveFromSupplier: "ใบรับสินค้าจากผู้จำหน่าย",
    ISA_NoPermission_Export: "คุณไม่มีสิทธิ์ Export Excel (EX)",

    // Status
    ISA_DocStatus_Pending: "รอดำเนินการ",
    ISA_DocStatus_Completed: "เสร็จสมบูรณ์",

    // Document fields
    ISA_DocCreateTime: "เวลาสร้างเอกสาร",
    ISA_DocFilename: "ชื่อไฟล์",
    ISA_DocSEC: "เลขที่ SEC",
    ISA_DocSIV: "เลขที่ SIV",

    // Approve related
    ISA_ApproveReason: "เหตุผลการอนุมัติ",
    ISA_AUDIT_LOG: "ประวัติการแก้ไข",
    ISA_LOG_FILE: "Log File - ประวัติการแก้ไขเอกสาร",
    ISA_TIME_STAMP: "Time Stamp",
    ISA_Modifier: "ผู้แก้ไข",

    // Supplier Receive
    ISA_AddProductRefPO: "อ้างอิง PO",
    ISA_AddProductRefPR: "อ้างอิง PR",
    ISA_AUTO_GENERATED: "(ระบบสร้างอัตโนมัติ)",
    ISA_TitleChangeStatus: "เปลี่ยนสถานะ",
    ISA_HeaderMessageChangeStatus: "คุณต้องการเปลี่ยนสถานะเอกสารนี้ใช่หรือไม่?",
    ISA_SearchData: "ค้นหาข้อมูล",
    ISA_ReportSupplierReceiveTransaction: "รายงานรับสินค้าจากซัพพลายเออร์",

    // Supplier Return
    ISA_SUP_INVOICE: "เลขที่ Invoice ผู้ขาย",
    ISA_SupplierReceiveRef: "อ้างอิงใบรับสินค้า",
    ISA_SUPPLIER_RETURN: "คืนสินค้าให้ซัพพลายเออร์",
    ISA_ReportSupplierReturn: "ใบคืนสินค้าให้ผู้จำหน่าย",
    ISA_WITHDRAWTRANSACTION: "ใบเบิกสินค้า",
    ISA_ReportSupplierReturnDetail: "ใบคืนสินค้าให้ผู้จำหน่าย (รายละเอียด)",
    ISA_SRECNumber: "เลขที่ SREC",
    ISA_RefSRECNumber: "อ้างอิง เลขที่ SREC",
    ISA_ReceivedQty: "จำนวนรับแล้ว",
    ISA_PendingReturn: "ค้างคืน",
    ISA_SupplierName: "ผู้จำหน่าย",
    ISA_ChangeCustomer: "เปลี่ยนลูกค้า",
    ISA_ModeOfDelivery: "วิธีการจัดส่ง",
    ISA_ShipToPrint: "พิมพ์ที่อยู่จัดส่ง",
    ISA_VAT_7_PERCENT: "VAT 7%",

    // Dialog & Remark
    ISA_SelectOrderRemark: "เลือกหมายเหตุ",
    ISA_SearchOrderRemark: "ค้นหาหมายเหตุ",
    ISA_ProductRefPOTitle: "รายการสินค้า อ้างอิงเอกสารใบสั่งซื้อ",
    ISA_ProductRefSRECTitle: "รายการสินค้า อ้างอิงเอกสารใบรับสินค้า",
    ISA_PleaseSelectPOAtLeast1: "กรุณาเลือกใบสั่งซื้ออย่างน้อย 1 รายการ",
    ISA_PleaseSelectSRECAtLeast1: "กรุณาเลือกใบรับสินค้าอย่างน้อย 1 รายการ",
    ISA_CanSelectOnly1SREC: "สามารถเลือกได้เพียง 1 ใบรับสินค้าเท่านั้น",
    ISA_CanSelectOnly1SRECPleaseCancel:
      "สามารถเลือกได้เพียง 1 ใบรับสินค้าเท่านั้น กรุณายกเลิกรายการเดิมก่อน",
    ISA_DOCUMENT_1: "เอกสาร 1",
    ISA_DOCUMENT_2: "เอกสาร 2",
    ISA_DOCUMENT_3: "เอกสาร 3",
    ISA_Download: "ดาวน์โหลด",
    ISA_LOADING: "กำลังโหลด...",

    // UI Elements Tooltips
    ISA_TooltipViewData: "ดูข้อมูล",
    ISA_TooltipAttechFile: "แนบไฟล์",
    ISA_TooltipCopy: "คัดลอก",
    ISA_TooltipPDF: "PDF",
    ISA_TooltipLog: "ประวัติ",

    // Web User Group
    ISA_Group_Code: "รหัสกลุ่ม",
    ISA_Button_Permission: "สิทธิ์การใช้งาน",
    ISA_Button_CreateWebUserGroup: "สร้างกลุ่มผู้ใช้",

    // ==================== ADDITIONAL KEYS FOR FORM VALIDATION ====================
    ISA_InvalidDate: "รูปแบบวันที่ไม่ถูกต้อง",
    ISA_PleaseEnterShipToDate: "กรุณาระบุวันที่จัดส่ง",
    ISA_PleaseEnterDocNo: "กรุณาระบุเลขที่เอกสาร",
    ISA_PleaseSelectDocType: "กรุณาเลือกประเภทเอกสาร",
    ISA_PleaseSelectDepartment: "กรุณาเลือกแผนก",
    ISA_PleaseEnterCustomerPONo: "กรุณากรอกเลขที่ใบสั่งซื้อลูกค้า",
    ISA_PleaseSelectCurrency: "กรุณาเลือกสกุลเงิน",
    ISA_PleaseSelectShipToPrint: "กรุณาเลือกพิมพ์สถานที่ส่งในบิล",
    ISA_PleaseSelectSupplier: "กรุณาเลือกซัพพลายเออร์",
    ISA_PleaseSelectCustomer: "กรุณาเลือกลูกค้า",
    ISA_PleaseAddAtLeastOneProduct: "กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ",
    ISA_UpdatingData: "กำลังอัพเดทข้อมูล...",
    ISA_UpdateSuccess: "อัพเดทสำเร็จ!",
    ISA_SaveSuccess: "บันทึกสำเร็จ!",
    ISA_RemarkCode: "รหัสวัตถุประสงค์",
    ISA_DynamicFormRemarkTitle: "วัตถุประสงค์การเข้าเยี่ยมที่เปิดฟอร์มนี้",
    ISA_DynamicFormRemarkHint: "เลือกได้ 1 วัตถุประสงค์ต่อ 1 ฟอร์ม — ฟอร์มนี้จะแสดงบนแอปเมื่อ{salesman}เลือกวัตถุประสงค์นี้",
    ISA_DynamicFormRemarkUsedBy: "ผูกกับฟอร์มอื่นแล้ว",
    ISA_DynamicFormRemarkEmpty: "ยังไม่ผูกวัตถุประสงค์ — ฟอร์มนี้จะไม่แสดงบนแอป",
    ISA_DynamicFormNoRemarkMaster: "บริษัทนี้ยังไม่มีข้อมูลวัตถุประสงค์การเข้าเยี่ยม — Import ที่เมนูข้อมูลหัวข้อการเข้าเยี่ยมลูกค้าก่อน",
    ISA_DynamicFormSystemReadOnly: "ฟอร์มระบบ — แก้ไขได้เฉพาะการผูกวัตถุประสงค์การเข้าเยี่ยม (ด้านล่าง)",
    ISA_DynamicFormHiddenOnApp: "ไม่แสดงบนแอป",
    ISA_ImportRemarkColumns: "ไม่สามารถ Import ได้ — ไฟล์ต้องมี 4 คอลัมน์ RemarkCode, SortOrder, RemarkText, LangId (ดาวน์โหลด Template ใหม่)",
    ISA_ImportRemovedMappings: "ถอดการผูก Dynamic Form ของวัตถุประสงค์ที่ถูกลบ",
    ISA_SaveDataSuccess: "บันทึกข้อมูลสำเร็จ",
    ISA_CannotSaveData: "ไม่สามารถบันทึกข้อมูลได้:",
    ISA_UnknownError: "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ",
    ISA_ConfirmDeleteTitle: "ยืนยันการลบ",
    ISA_ConfirmDeleteProductMsg: "คุณต้องการลบสินค้านี้ออกจากรายการหรือไม่?",
    ISA_DeleteProductSuccess: "ลบสินค้าออกจากรายการเรียบร้อยแล้ว",
    ISA_PleaseSelectCustomerFirst: "กรุณาเลือกลูกค้าก่อน",
    ISA_PleaseSelectCustomerBeforeShipTo:
      "กรุณาเลือกลูกค้า ก่อนเลือกสถานที่จัดส่ง",
    ISA_PleaseSelectBillToFirst: "กรุณาเลือกลูกค้า (Bill To) ก่อน",
    ISA_PleaseSelectBillToBeforeShipTo:
      "กรุณาเลือกลูกค้า (Bill To) ก่อนเลือกสถานที่จัดส่ง",
    ISA_PleaseSelectSupplierBeforePR: "กรุณาเลือกซัพพลายเออร์ก่อนอ้างอิง PR",
    ISA_PleaseSelectWarehouseBeforePR: "กรุณาเลือกคลังสินค้าก่อนอ้างอิง PR",
    ISA_SupplierPRRef: "อ้างอิง PR จากซัพพลายเออร์",
    ISA_AmountSummary: "สรุปยอดเงิน",
    ISA_SelectAttachFile: "เลือกไฟล์แนบ",
    ISA_PleaseEnterCustomerPODate: "กรุณากรอกวันที่ใบสั่งซื้อลูกค้า",
    ISA_PleaseEnterDeliveryDate: "กรุณากรอกวันที่ส่งสินค้า",

    // SupplierReceiveTransaction keys
    ISA_ConfirmSubmitDoc: "ยืนยันการส่งเอกสาร",
    ISA_ConfirmSubmitDocMsg: "คุณต้องการยืนยันและส่งเอกสารหรือไม่?",
    ISA_ProductCount: "จำนวนรายการสินค้า",
    ISA_ConfirmWillChangeStatus: "การยืนยันจะทำให้เอกสารถูกส่งและเปลี่ยนสถานะ",
    ISA_PleaseCheckAndFix: "กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้:",
    ISA_PleaseSelectWarehouseLocation: "กรุณาเลือกตำแหน่งคลังสินค้า",
    ISA_PleaseEnterInvNumber: "กรุณาระบุเลขที่ Invoice",
    ISA_PleaseEnterInvDate: "กรุณาระบุวันที่ Invoice",
    ISA_ConfirmAndSubmit: "ยืนยันและส่งเอกสาร",
    ISA_SaveItem: "บันทึกรายการ",
    ISA_FillDataBeforeRefSREC: "กรุณากรอกข้อมูลให้ครบถ้วนก่อนอ้างอิงใบ SREC",

    // ==================== HARDCODED TEXT REPLACEMENTS ====================
    ISA_PreparingPDF: "กำลังเตรียมข้อมูลสำหรับสร้าง PDF...",
    ISA_NoDataForExportPDF: "ไม่มีข้อมูลสำหรับ Export PDF",
    ISA_ErrorExportPDF: "เกิดข้อผิดพลาดในการ Export PDF",
    ISA_NoDataForExportExcel: "ไม่มีข้อมูลสำหรับ Export Excel",
    ISA_ErrorExportExcel: "เกิดข้อผิดพลาดในการ Export Excel",
    ISA_CannotLoadStockCard: "ไม่สามารถโหลดข้อมูล Stock Card ได้",
    ISA_CannotExportExcel: "ไม่สามารถ Export Excel ได้",
    ISA_SalesAmountTHB: "ยอดขาย (THB)",
    ISA_Email_2: "Email:",

    ISA_DeleteEvent: "ลบกิจกรรม",
    ISA_About: "เกี่ยวกับ",

    ISA_ViewMap: "ดูแผนที่",

    ISA_NoData: "ไม่มีข้อมูล",

    ISA_LOADING: "กำลังโหลด...",

    ISA_IncVat: "Inc.VAT",

    ISA_ExcVat: "Exc.VAT",

    ISA_GoogleMap: "Google Map",
    ISA_GoogleMaps: "Google Maps",
    ISA_Previous: "ก่อนหน้า",

    ISA_Next: "ถัดไป",

    ISA_TotalConfirmDocumentRobiticOrderApproval:
      "ภาพรวมการยืนยันเอกสารผ่าน Robitic Order Approval",

    ISA_BlockDocSale: "สรุปสาเหตุการ Block ใบสั่งขาย",

    ISA_ProductLine_2: "สร้างสินค้าไปยัง Line",
    ISA_LoginWithMicrosoft: "เข้าสู่ระบบด้วย Microsoft",

    ISA_ISmartAI: "iSmart AI ผู้ช่วย",

    ISA_CustomerAI: "ลูกค้าที่ AI แนะนำ",

    ISA_AI_2: "การวิเคราะห์จาก AI",

    ISA_Back: "ย้อนกลับ",

    ISA_Today: "วันนี้",

    ISA_Month: "เดือน",

    ISA_Week: "สัปดาห์",

    ISA_Agenda: "กำหนดการ",

    ISA_CannotPlanPleaseSettingEmailnbspnbsp:
      "ไม่สามารถสร้างแผนเข้าเยี่ยมได้ กรุณาทำการตั้งค่าอีเมล์และปฏิทิน",

    ISA_Customernbsp: "ลูกค้าใกล้เคียง",

    ISA_CustomerFilter: "กรองลูกค้า",

    ISA_MarketplaceFilter: "กรองพื้นที่ขาย",

    ISA_PipelineAnalytics: "วิเคราะห์ Pipeline",

    ISA_Retry: "ลองใหม่",

    ISA_GetLocation_2: "รับตำแหน่ง",

    ISA_Activity: "ตรวจสอบพบกิจกรรม",

    ISA_YourCurrentLocation: "ตำแหน่งปัจจุบันของคุณ",
    ISA_GoToGallery: "ไปที่แกลเลอรี่",

    ISA_LOADING: "กำลังโหลด...",

    ISA_HelloWorld: "สวัสดี",

    ISA_OpenEmspEmspSale: "เปิด   การขาย",

    ISA_NotAccess: "ไม่มีสิทธิ์เข้าถึง",

    ISA_Save_2: "บันทึก",

    ISA_Onsite: "ผู้ใช้งาน Onsite",

    ISA_Remote: "ผู้ใช้งาน Remote",

    ISA_StockCard: "Stock Card",

    ISA_Stock_2: "สต็อก",

    ISA_SellIn: "Sell In",

    ISA_SellOut: "Sell Out",

    // ===== Hardcoded Alert Messages =====
    ISA_Msg_SendProductToLine: "คุณต้องการส่งสินค้าไปยัง Line ใช่หรือไม่?",
    ISA_Msg_QuantityMustBeGreaterThanZero:
      "ไม่สามารถใส่จำนวนน้อยกว่าหรือเท่ากับ 0 ได้",

    // Invoice / Supplier Messages
    ISA_Msg_SelectCustomerFirst:
      "กรุณาเลือกลูกค้า (Bill To) ก่อนเลือกสถานที่จัดส่ง",
    ISA_Msg_SupInvoiceUpdated: "เลขที่ SUP INVOICE ถูกแก้ไขแล้ว",
    ISA_Msg_CannotLoadSREC: "ไม่สามารถโหลดข้อมูล SREC ได้",
    ISA_Msg_SRECNotFound: "ไม่พบเลขที่ SREC",

    // Delete / Permission Messages
    ISA_Msg_BatchNo: "เลขที่ชุด",

    // Export Messages
    ISA_Msg_ExportExcelFailed: "ไม่สามารถส่งออกไฟล์ Excel ได้",
    ISA_Msg_PDFError: "เกิดข้อผิดพลาดในการสร้างไฟล์ PDF",
    ISA_Msg_NoExpenseDetailFound: "ไม่พบรายการค่าใช้จ่ายสำหรับเอกสารนี้",
    // Stock Card Messages
    ISA_Msg_NoStockCardData: "ไม่พบข้อมูล Stock Card สำหรับลูกค้านี้",
    ISA_OrderConfirmTitle: "ยืนยันการสั่งซื้อ",
    ISA_SelectedProductsList: "รายการสินค้าที่เลือก",
    ISA_NewOrder: "สั่งใหม่",
    ISA_ClickConfirmToCreateOrder: "กดยืนยันเพื่อสร้างใบสั่งซื้อ",
    ISA_APIError: "API Error",
    ISA_PleaseCheckApiFormattedDataLogic:
      "กรุณาตรวจสอบว่า API ได้ uncomment logic ใน formattedData.map() แล้วหรือยัง",
    ISA_PleaseOpenConsoleForDetails:
      "กรุณาเปิด Console (F12) เพื่อดูรายละเอียด",
    ISA_CannotGenerateDocumentNumber: "ไม่สามารถสร้างเลขที่เอกสารได้",
    ISA_ErrorGeneratingDocumentNumber: "เกิดข้อผิดพลาดในการสร้างเลขที่เอกสาร",
    ISA_StockCardOrderNewOrderRemark: "Stock Card Order - สั่งใหม่: ",
    ISA_NoSearchResultsTryAgainOrReset:
      "ไม่พบข้อมูลที่ตรงกับเงื่อนไขการค้นหา กรุณาลองค้นหาใหม่หรือกด Reset",
    ISA_SelectProductQuantity: "เลือกจำนวนสินค้า",
    ISA_SelectedQuantity: "จำนวนที่เลือก",
    ISA_NotSelectedYet: "ยังไม่ได้เลือก",
    ISA_StockCount_ProductInfoEditItem: "ข้อมูลสินค้า (แก้ไขรายการที่ 1)",
    ISA_StockCount_ShowSelectedPriority: "แสดงตามสำคัญที่เลือก",
    ISA_FailedToFetchStockData:
      "ไม่สามารถดึงข้อมูลสต็อกได้ กรุณาลองใหม่ภายหลัง",
    ISA_LoadingStockData: "กำลังโหลดข้อมูลสต็อก...",
    ISA_StockHistory: "ประวัติสต๊อก",
    ISA_ProductInfo: "ข้อมูลสินค้า",
    ISA_ProductNameNotSpecified: "ไม่ระบุชื่อสินค้า",
    ISA_NoData: "ไม่มีข้อมูล",
    ISA_NoAdditionalDetails: "ไม่พบรายละเอียดเพิ่มเติม",
    ISA_ShortDetails: "รายละเอียดสั้น",
    ISA_CheckConsoleForDetails: "ตรวจสอบ Console สำหรับรายละเอียดเพิ่มเติม",
    ISA_OrderCreateSuccessWithNumber: "สร้างใบสั่งซื้อสำเร็จ! เลขที่: ",
    ISA_ErrorCreatingDocument: "เกิดข้อผิดพลาดในการสร้างเอกสาร",
    ISA_ErrorCreatingOrder: "เกิดข้อผิดพลาดในการสร้างใบสั่งซื้อ",
    ISA_FromTotalItems: "จากทั้งหมด",
    ISA_SelectProductGroup: "เลือกกลุ่มสินค้า",
    ISA_SelectProductType: "เลือกประเภทสินค้า",
    ISA_ProductLine: "ไลน์สินค้า",
    ISA_SelectProductLine: "เลือกไลน์สินค้า",
    ISA_SelectItemGroup: "เลือกหมวดสินค้า",
    ISA_OrderButton: "สั่งซื้อ",
    ISA_BroughtForward: "ยกมา",
    ISA_Buy: "ซื้อ",
    ISA_SellShort: "ขาย",
    ISA_Summary: "สรุป",
    ISA_Count: "นับ",
    ISA_CustomerStockLabel: "สต๊อกลูกค้า",
    ISA_Recommend: "แนะนำ",

    // Stock Count Excel Export Labels
    ISA_MfgDate: "วันที่ผลิต",
    ISA_CountMethod: "วิธีการนับ",
    ISA_NoDataToExport: "ไม่มีข้อมูลสำหรับส่งออก",
    ISA_CopyingDocument: "กำลังคัดลอกเอกสาร...",

    // Chart Labels
    ISA_Label_ApiUsageSelected: "การเรียกใช้ API (เดือน/ไตรมาส/ปี ที่เลือก)",

    // Swal Titles
    ISA_Title_EditSuccess: "แก้ไขสำเร็จ",
    ISA_Title_Error: "เกิดข้อผิดพลาด",

    // Additional keys for Return Qty
    ISA_Msg_PleaseEnterReturnQty: "กรุณาระบุจำนวนคืนสำหรับสินค้าที่เลือก",

    // Additional keys for Product-master
    ISA_Yes: "ใช่",
    // APTransaction keys
    ISA_PrintCount: "จำนวนการพิมพ์",
    ISA_ShortOver: "ขาด/เกิน",
    ISA_BillCount: "จำนวนบิล (ใบ)",
    ISA_TotalSales: "รวมบิลขาย",
    ISA_TotalReturn: "รวมบิลคืน",
    ISA_TotalCancel: "รวมบิลยกเลิก",
    ISA_NetBillAmount: "ยอดบิลสุทธิ",
    ISA_PaymentDetails: "รายละเอียดการชำระเงิน",
    ISA_TotalCash: "ยอดรวมชำระ เงินสด",
    ISA_TotalCreditNote: "ยอดรวมชำระ ใบลดหนี้",
    ISA_TotalCollected: "รวมเงินเก็บ (ขาด/เกิน)",
    ISA_YearMonthDay: "วันเดือนปี",
    ISA_HasDiscount: "มีส่วนลด",
    ISA_NetByCurrency: "สุทธิ(ตามสกุลเงิน)",

    // Config messages
    ISA_Msg_CannotSaveData: "ไม่สามารถบันทึกข้อมูลได้",
    ISA_Msg_CannotEditData: "ไม่สามารถแก้ไขข้อมูลได้",

    // OrderDetailModal keys
    ISA_OrderDetail: "รายละเอียดใบสั่งซื้อ",
    ISA_Loading_Data: "กำลังโหลดข้อมูล...",
    ISA_GeneralInfo: "ข้อมูลทั่วไป",
    ISA_PurchaseOrder: "ใบสั่งซื้อ",
    ISA_ReferenceNo: "เลขที่อ้างอิง",
    ISA_CustomerReceiveDate: "วันที่ลูกค้ารับสินค้า",
    ISA_UnitName: "หน่วยนับ",
    ISA_OrderQty: "สั่ง จำนวน",
    ISA_OrderAmount: "สั่ง จำนวนเงิน",
    ISA_DeliverQty: "ส่ง จำนวน",
    ISA_DeliverAmount: "ส่ง จำนวนเงิน",
    ISA_PendingQty: "ค้างส่ง จำนวน",
    ISA_PendingAmount: "ค้างส่ง จำนวนเงิน",
    ISA_CancelNote: "หมายเหตุ ยกเลิก",
    ISA_CannotLoadData: "ไม่สามารถโหลดข้อมูลได้",
    ISA_NoDataMatchSearch: "ไม่พบข้อมูลที่ตรงกับเงื่อนไขการค้นหา",
    ISA_TryAdjustSearchOrClearFilter:
      "ลองปรับเปลี่ยนเงื่อนไขการค้นหาหรือล้างตัวกรอง",
    ISA_DocumentStatusReport: "รายงานสถานะเอกสาร",
    ISA_PendingDelivery: "ค้างส่ง",
    ISA_NoDataYet: "ยังไม่มีข้อมูล",
    ISA_WaitingData: "รอข้อมูลจากระบบ",

    // PackageServices keys
    ISA_StartLoadingData: "เริ่มโหลดข้อมูล...",
    ISA_LoadComplete: "โหลดเสร็จ",
    ISA_LoadFailed: "โหลดข้อมูลล้มเหลว",

    // Customer_Account keys
    ISA_Msg_EditSuccess: "แก้ไขข้อมูลสำเร็จ",
    ISA_DeleteSalesman: "ลบพนักงาน",

    // APPayment / APReceipt keys
    ISA_TotalToPay: "ยอดที่ต้องชำระ",
    ISA_ChequeBank: "เช็คธนาคาร",
    ISA_PayInBank: "โอนเข้าบัญชีธนาคาร",
    ISA_PayInDate: "วันที่โอน",
    ISA_TotalToPayByCurrency: "เงินค้างชำระตามสกุลเงิน",
    ISA_TotalPaid: "ยอดชำระ",

    // Expense module keys
    ISA_SearchCustomer: "ค้นหาลูกค้า...",
    ISA_SelectSupplier: "เลือกซัพพลายเออร์",
    ISA_TryOtherKeyword: "ลองค้นหาด้วยคำค้นอื่น",
    ISA_NoSupplierFound: "ไม่พบซัพพลายเออร์ที่ค้นหา",
    ISA_NoSupplierData: "ไม่มีข้อมูลซัพพลายเออร์",
    ISA_NoCustomerFound: "ไม่พบลูกค้าที่ค้นหา",
    ISA_NoCustomerData: "ไม่มีข้อมูลลูกค้า",

    // Receipt/StockCount keys
    ISA_DailyStock: "ยอดระบาย (รายครั้ง)",
    ISA_MonthlyStock: "ยอดระบาย (รายเดือน)",

    // News Table keys
    ISA_CurrentStock: "สต็อค (ปัจจุบัน)",
    ISA_Shortage: "ขาดอีก",
    ISA_ForecastCustomerOrder: "คาดการณ์ลูกค้าที่จะสั่งสินค้า",
    ISA_StockMayNotEnough: "รายการสต็อคที่น่าจะไม่พอขาย",
    ISA_ProductNewProduct: "สินค้า (สินค้าใหม่)",
    ISA_TotalValue: "มูลค่า",
    ISA_ExportDataEN: "Export ข้อมูล",
    ISA_CrossSellingBySalesman: "Cross Selling By Salesman",
    ISA_CrossSellingByCustomer: "Cross Selling By Customer",
    ISA_CrossSellingByProduct: "Cross Selling By Product",
    ISA_PercentForecast: "%Forecast",
    ISA_Variance: "Variance",

    // SupplierPOTransaction Form keys
    ISA_ConfirmUpdate: "ยืนยันการอัพเดท",
    ISA_ConfirmSave: "ยืนยันการบันทึก",
    ISA_ConfirmUpdateMsg: "คุณต้องการอัพเดทเอกสารนี้ใช่หรือไม่?",
    ISA_ConfirmSaveMsg: "คุณต้องการบันทึกเอกสารนี้ใช่หรือไม่?",
    ISA_ConfirmUpdateBtn: "ยืนยันอัพเดท",
    ISA_ConfirmSaveBtn: "ยืนยันบันทึก",
    ISA_UnsavedChangesEdit: "คุณมีการแก้ไขข้อมูลที่ยังไม่ได้บันทึก",
    ISA_UnsavedChanges: "คุณมีข้อมูลที่ยังไม่ได้บันทึก",
    ISA_ConfirmCancelAndExit: "ต้องการยกเลิกและออกจากหน้านี้หรือไม่?",
    ISA_ConfirmCancelMsg: "ต้องการยกเลิกและกลับไปหน้าแรกใช่หรือไม่?",
    ISA_ChangesWillBeLost: "ข้อมูลทั้งหมดจะถูกยกเลิกและไม่สามารถกู้คืนได้",
    ISA_YesCancel: "ใช่, ยกเลิกเลย",
    ISA_BackToEdit: "กลับไปแก้ไข",
    ISA_Updating: "กำลังอัพเดท...",
    ISA_CannotChangeCustomerHasProducts: "ไม่สามารถเปลี่ยนลูกค้าได้เนื่องจากมีสินค้าในรายการ กรุณาลบสินค้าออกก่อน",
    ISA_EditProductSuccess: "แก้ไขสินค้าเรียบร้อย",
    ISA_SaveProductSuccess: "บันทึกรายการสินค้าเรียบร้อย",
    ISA_ConnectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์",
    ISA_ConfirmCancel: "ยืนยันการยกเลิก",
    ISA_AllChangesWillBeLost: "การแก้ไขทั้งหมดจะถูกยกเลิกและไม่สามารถกู้คืนได้",
    ISA_SupInvoiceDate: "วันที่ Sup Invoice",
    ISA_SaveDraftSuccess: "บันทึกฉบับร่างเรียบร้อยแล้ว",
    ISA_PleaseEnterCustPODate: "กรุณาระบุวันที่ใบสั่งซื้อลูกค้า",
    ISA_PleaseSelectShipTo: "กรุณาเลือกสถานที่จัดส่ง",
    ISA_PleaseEnterSupInvoice: "กรุณากรอกอ้างอิง เลขที่ SUP INVOICE",
    ISA_DiscountTypeUsed: "ประเภทที่ใช้งานแล้ว",
    ISA_PreparingData: "กำลังเตรียมข้อมูล...",
    ISA_PrepareExportData: "เตรียมข้อมูล Export",
    ISA_Bangkok: "กรุงเทพมหานคร",

    // Document Form Keys
    ISA_Create_DocSeqNo: "ลำดับเอกสาร",
    ISA_LABELKEY: "ป้ายชื่อ",
    ISA_ProductNo: "ลำดับสินค้า",
    ISA_SearchSupplier: "ค้นหาซัพพลายเออร์",
    ISA_ServerConnectionError: "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้",
    ISA_SHOWVAT: "แสดง VAT",

    // CustomerList Pareto Analysis Keys
    ISA_CustomerDataCSV: "ข้อมูลลูกค้า.csv",
    ISA_TotalAll: "ยอดรวมทั้งหมด",
    ISA_OrangeHighlight: "ไฮไลท์สีส้ม",
    ISA_ParetoKeyAccountDesc: "= ยอดเปอร์เซ็นสะสม ≤ 80% (ลูกค้า Key Account)",

    // Dashboard Map Keys
    ISA_PreviousPeriod: "ช่วงเวลาก่อนหน้า",
    ISA_SamePeriod: "ช่วงเวลาเดียวกัน",
    ISA_SameMonthOfYear: "เดือนเดียวกันปี",
    ISA_SameQuarterOfYear: "ไตรมาสเดียวกันปี",
    ISA_SLIDE_SHOW: "สไลด์โชว์",
    ISA_TYPE_COMMENTS: "พิมพ์ความคิดเห็น",

    // ImportMaster Keys (277 keys added)
    ISA_Amount1: "Amount1",
    ISA_Amount2: "Amount2",
    ISA_AvaiQty: "AvaiQty",
    ISA_Bill: "Bill",
    ISA_CancelRemark: "CancelRemark",
    ISA_Char_S1_1: "Char_S1_1",
    ISA_Char_S1_10: "Char_S1_10",
    ISA_Char_S1_11: "Char_S1_11",
    ISA_Char_S1_12: "Char_S1_12",
    ISA_Char_S1_13: "Char_S1_13",
    ISA_Char_S1_14: "Char_S1_14",
    ISA_Char_S1_15: "Char_S1_15",
    ISA_Char_S1_16: "Char_S1_16",
    ISA_Char_S1_17: "Char_S1_17",
    ISA_Char_S1_18: "Char_S1_18",
    ISA_Char_S1_19: "Char_S1_19",
    ISA_Char_S1_2: "Char_S1_2",
    ISA_Char_S1_20: "Char_S1_20",
    ISA_Char_S1_21: "Char_S1_21",
    ISA_Char_S1_22: "Char_S1_22",
    ISA_Char_S1_23: "Char_S1_23",
    ISA_Char_S1_24: "Char_S1_24",
    ISA_Char_S1_25: "Char_S1_25",
    ISA_Char_S1_3: "Char_S1_3",
    ISA_Char_S1_4: "Char_S1_4",
    ISA_Char_S1_5: "Char_S1_5",
    ISA_Char_S1_6: "Char_S1_6",
    ISA_Char_S1_7: "Char_S1_7",
    ISA_Char_S1_8: "Char_S1_8",
    ISA_Char_S1_9: "Char_S1_9",
    ISA_Char_S2_Other10: "Char_S2_Other10",
    ISA_Char_S2_Other11: "Char_S2_Other11",
    ISA_Char_S2_Other12: "Char_S2_Other12",
    ISA_Char_S2_Other13: "Char_S2_Other13",
    ISA_Char_S2_Other9: "Char_S2_Other9",
    ISA_ChequeAmount: "ChequeAmount",
    ISA_ChequeBranch: "ChequeBranch",
    ISA_ChequeNumber: "ChequeNumber",
    ISA_ChequeStatus: "ChequeStatus",
    ISA_CreditLimitOutstanding: "CreditLimitOutstanding",
    ISA_CreditLimitUsed: "CreditLimitUsed",
    ISA_CreditTerm: "CreditTerm",
    ISA_CustomerTypeDescription: "CustomerTypeDescription",
    ISA_DATA_CUSTOMER_STEP_PRICING_XLSX: "/data/CustomerStepPricing.xlsx",
    ISA_DATA_GROUP_STEP_PRICING_XLSX: "/data/GroupstepPricing.xlsx",
    ISA_DATA_ISB_AR_OUTSTANDING_XLSX:
      "/data/ISB-ข้อมูลรายงานบิลค้างชำระ(AR Outstanding).xlsx",
    ISA_DATA_ISB_AVAILABLE_STOCK_XLSX:
      "/data/ISB-ข้อมูลสต๊อกสินค้า(AvailableStock).xlsx",
    ISA_DATA_ISB_BOUNCE_CHEQUE_XLSX:
      "/data/ISB-ข้อมูลคืนเช็คลูกค้า(Bounce Cheque).xlsx",
    ISA_DATA_ISB_CLIENT_VISIT_MEMO_REMARK_XLSX:
      "/data/ISB-ข้อมูลหมายเหตุการเยี่ยม(ClientVisitMemo Remark).xlsx",
    ISA_DATA_ISB_CRM_XLSX: "/data/ISB-ข้อมูลCRM.xlsx",
    ISA_DATA_ISB_CURRENCY_MASTER_XLSX:
      "/data/ISB-ข้อมูลสกุลเงิน(Currency Master).xlsx",
    ISA_DATA_ISB_CUSTOMER_MAPPING_XLSX: "/data/ISB-CustomerMapping.xlsx",
    ISA_DATA_ISB_CUSTOMER_MASTER_SALEMAN_XLSX:
      "/data/ISB-ข้อมูลพนักงานขายผูกลูกค้า(CustomerMasterSaleman).xlsx",
    ISA_DATA_ISB_CUSTOMER_MASTER_XLSX:
      "/data/ISB-ข้อมูลลูกค้าหน้าบัญชี(CustomerMaster).xlsx",
    ISA_DATA_ISB_CUSTOMER_PRICING_XLSX:
      "/data/ISB-ข้อมูลราคาขายรายลูกค้า(Customer Pricing).xlsx",
    ISA_DATA_ISB_CUSTOMER_PRODUCT_XLSX:
      "/data/ISB-อนุญาตการขาย (CustomerProduct).xlsx",
    ISA_DATA_ISB_DAILY_SALES_XLSX:
      "/data/ISB-ข้อมูลรายงานยอดขาย(SalesTransaction).xlsx",
    ISA_DATA_ISB_DISCOUNT_TYPE_XLSX:
      "/data/ISB-ข้อมูลส่วนลด(DiscountType Master).xlsx",
    ISA_DATA_ISB_GROUP_PRICING_XLSX:
      "/data/ISB-ข้อมูลราคาขายรายกลุ่มลูกค้า(Group Pricing).xlsx",
    ISA_DATA_ISB_KPI_XLSX: "/data/ISB-ข้อมูลตัวชี้วัด (KPI).xlsx",
    ISA_DATA_ISB_LOOKUP_MASTER_XLSX:
      "/data/ISB-ข้อมูลLookup(Lookup Master).xlsx",
    ISA_DATA_ISB_MARKET_PLACE_XLSX:
      "/data/ISB-ข้อมูลพื้นที่ขายลูกค้า(Market Place).xlsx",
    ISA_DATA_ISB_NEW_PRODUCT_XLSX:
      "/data/ISB-ข้อมูลสินค้าใหม่(New_Product).xlsx",
    ISA_DATA_ISB_ORDER_REMARK_XLSX:
      "/data/ISB-ข้อมูลหมายเหตุท้ายบิล(Order Remark).xlsx",
    ISA_DATA_ISB_ORDER_STATUS_REPORT_XLSX:
      "/data/ISB-รายงานติดตามออเดอร์ (Order Status Report).xlsx",
    ISA_DATA_ISB_PLANTSALESMAN_MASTER_XLSX:
      "/data/ISB-ข้อมูลคลังพนักงานขาย (PlantSalesman Master).xlsx",
    ISA_DATA_ISB_PRODUCT_CUSTOMER_MAPPING_XLSX:
      "/data/ISB-ProductCustomerMapping.xlsx",
    ISA_DATA_ISB_PRODUCT_MAPPING_XLSX: "/data/ISB-ProductMapping.xlsx",
    ISA_DATA_ISB_PRODUCT_MASTER_XLSX:
      "/data/ISB-ข้อมูลสินค้า(ProductMaster).xlsx",
    ISA_DATA_ISB_PRODUCT_PRICING_XLSX:
      "/data/ISB-ข้อมูลราคาขายมาตราฐาน(Standard Pricing).xlsx",
    ISA_DATA_ISB_PRODUCT_TARGET_XLSX:
      "/data/ISB-ข้อมูลเป้าการขายเซลล์ตามสินค้า (Target By Salesman By Product).xlsx",
    ISA_DATA_ISB_PROVINCE_MASTER_XLSX:
      "/data/ISB-ข้อมูลจังหวัด(Province Master).xlsx",
    ISA_DATA_ISB_QUESTIONNAIRE_MASTER_XLSX:
      "/data/ISB-ข้อมูลแบบสอบถาม(Questionnaire Master).xlsx",
    ISA_DATA_ISB_RETURN_REASON_XLSX:
      "/data/ISB-ข้อมูลเหตุผลในการคืน(Return Reason).xlsx",
    ISA_DATA_ISB_SALES_TARGET_XLSX:
      "/data/ISB-ข้อมูลเป้าการขายเซลล์ (Target By Salesman).xlsx",
    ISA_DATA_ISB_SALESMAN_MASTER_XLSX:
      "/data/ISB-ข้อมูลพนักงานขาย (Salesman Master).xlsx",
    ISA_DATA_ISB_UNIT_MAPPING_XLSX: "/data/ISB-UnitMapping.xlsx",
    ISA_DATA_PRODUCT_STEP_PRICING_XLSX: "/data/ProductStepPricing.xlsx",
    ISA_DATA_STOCK_FULLFILL_TEMPLATE_XLSX: "/data/StockFullFillTemplete.xlsx",
    ISA_DDPDate: "DDPDate",
    ISA_DiscountLevel: "DiscountLevel",
    ISA_DisplayDecimal: "DisplayDecimal",
    ISA_DO: "DO",
    ISA_DocumentCategory: "DocumentCategory",
    ISA_DODate: "DODate",
    ISA_EXPDate: "EXPDate",
    ISA_ExternalCustomerCode: "ExternalCustomerCode",
    ISA_ExternalProductCode: "ExternalProductCode",
    ISA_ExternalUnit: "ExternalUnit",
    ISA_FloorPrice1: "FloorPrice1",
    ISA_FloorPrice2: "FloorPrice2",
    ISA_FloorPrice3: "FloorPrice3",
    ISA_FloorPrice4: "FloorPrice4",
    ISA_FullfillQty: "FullfillQty",
    ISA_GroupCode: "GroupCode",
    ISA_IMPORT_DOCUMENT: "นำเข้าเอกสาร",
    ISA_IMPORT_STOCKFULLFILLMENT: "Import StockFullFillMent",
    ISA_ImportARReportSuccess: "Import ARReport สำเร็จ",
    ISA_ImportAvailableStockTransactionSuccess:
      "Import AvailableStockTransaction สำเร็จ",
    ISA_ImportClientVisitMemoRemarkSuccess:
      "Import หัวข้อการเข้าเยี่ยมลูกค้า สำเร็จ",
    ISA_ImportCRMSuccess: "Import CRM สำเร็จ",
    ISA_ImportCurrencySuccess: "Import Currency สำเร็จ",
    ISA_ImportCustomerChequeReturnSuccess: "Import CustomerChequeReturn สำเร็จ",
    ISA_ImportCustomerMappingSuccess: "Import CustomerMapping สำเร็จ",
    ISA_ImportCustomerPricingSuccess: "Import CustomerPricing สำเร็จ",
    ISA_ImportCustomerProductSuccess: "Import CustomerProduct สำเร็จ",
    ISA_ImportCustomerSalemanSuccess: "Import CustomerSaleman สำเร็จ",
    ISA_ImportCustomerStepPricingSuccess: "Import CustomerStepPricing สำเร็จ",
    ISA_ImportCustomerSuccess: "Import Customer สำเร็จ",
    ISA_ImportDailySalesSuccess: "Import ReportDailySalesSummaries สำเร็จ",
    ISA_ImportDiscountTypeSuccess: "Import ส่วนลด สำเร็จ",
    ISA_ImportGroupPricingSuccess: "Import GroupPricing สำเร็จ",
    ISA_ImportGroupStepPricingSuccess: "Import GroupStepPricing สำเร็จ",
    ISA_ImportKPISuccess: "Import KPI สำเร็จ",
    ISA_ImportLookupSuccess: "Import Lookup สำเร็จ",
    ISA_ImportMarketPlaceSuccess: "Import MarketPlace สำเร็จ",
    ISA_ImportMasterDocumentImportTransactionSuccess:
      "Import MasterDocumentImportTransaction สำเร็จ",
    ISA_ImportNewProductSuccess: "Import New Product สำเร็จ",
    ISA_ImportOrderRemarkSuccess: "Import หมายเหตุท้ายบิล สำเร็จ",
    ISA_ImportOrderStatusReportSuccess: "Import OrderStatusReport สำเร็จ",
    ISA_ImportPlantSalesmanSuccess: "Import PlantSalesman สำเร็จ",
    ISA_ImportProductCustomerMappingSuccess:
      "Import ProductCustomerMapping สำเร็จ",
    ISA_ImportProductMappingSuccess: "Import ProductMapping สำเร็จ",
    ISA_ImportProductPricingSuccess: "Import ProductPricing สำเร็จ",
    ISA_ImportProductStepPricingSuccess: "Import ProductStepPricing สำเร็จ",
    ISA_ImportProductSuccess: "Import Product สำเร็จ",
    ISA_ImportProductTargetSuccess: "Import ProductTarget สำเร็จ",
    ISA_ImportProvinceSuccess: "Import Province สำเร็จ",
    ISA_ImportQuestionAirSuccess: "Import แบบสอบถามสำเร็จ",
    ISA_ImportReturnReasonSuccess: "Import เหตุผลในการคืน สำเร็จ",
    ISA_ImportSalesTargetSuccess: "Import SalesTarget สำเร็จ",
    ISA_ImportUnitMappingSuccess: "Import UnitMapping สำเร็จ",
    ISA_int_S2_Other1: "int_S2_Other1",
    ISA_int_S2_Other2: "int_S2_Other2",
    ISA_int_S2_Other3: "int_S2_Other3",
    ISA_int_S2_Other4: "int_S2_Other4",
    ISA_int_S2_Other5: "int_S2_Other5",
    ISA_int_S2_Other6: "int_S2_Other6",
    ISA_int_S2_Other7: "int_S2_Other7",
    ISA_int_S2_Other8: "int_S2_Other8",
    ISA_int_S2_Total_Other: "int_S2_Total_Other",
    ISA_ItemGroupDescription: "ItemGroupDescription",
    ISA_KPISeq: "KPISeq",
    ISA_LabelKey: "LabelKey",
    ISA_LabelLang: "LabelLang",
    ISA_LabelValue: "LabelValue",
    ISA_LeftAmount: "LeftAmount",
    ISA_LeftQty: "LeftQty",
    ISA_LookupCode: "LookupCode",
    ISA_LookupType: "LookupType",
    ISA_LotNo: "LotNo",
    ISA_MarketPlaceCode: "MarketPlaceCode",
    ISA_MarketPlaceDescription: "MarketPlaceDescription",
    ISA_Menu_ImportAllowCustomerProduct: "ข้อมูลอนุญาตการขาย",
    ISA_Menu_ImportClientVisitMemoRemark: "ข้อมูลหมายเหตุการเยี่ยม",
    ISA_Menu_ImportCurrencyMaster: "ข้อมูลสกุลเงิน",
    ISA_Menu_ImportCustomerMapping: "CustomerMapping",
    ISA_Menu_ImportPlantSalesmanMaster: "ข้อมูลคลังพนักงานขาย",
    ISA_Menu_ImportProductCustomerMapping: "ProductCustomerMapping",
    ISA_Menu_ImportProductMappingMaster: "ข้อมูล Product Mapping",
    ISA_Menu_ImportUnitMapping: "UnitMapping",
    ISA_MFGDate: "MFGDate",
    ISA_OrderImport_DH_Column11: "วันที่ส่งมอบ",
    ISA_OrderImport_DH_Column8: "ชื่อหน่วย",
    ISA_OrderImport_HP_Column10: "ราคารวม",
    ISA_OrderImport_HP_Column2: "เลขใบ PO",
    ISA_OrderImport_HP_Column7: "วันที่นัดส่ง",
    ISA_OrderImport_LZD_Column3: "เลขที่ใบ PO",
    ISA_OrderImport_LZD_Column4: "ราคาสินค้า",
    ISA_OrderImport_LZD_Column6: "รายได้ค่าขนส่ง",
    ISA_OrderImport_SP_Column1: "หมายเลขคำสั่งซื้อ",
    ISA_OrderImport_SP_Column10: "ค่าจัดส่งที่ชำระโดยผู้ซื้อ",
    ISA_OrderImport_SP_Column2: "สถานะการสั่งซื้อ",
    ISA_OrderImport_SP_Column3: "วันที่ทำการสั่งซื้อ",
    ISA_OrderImport_SP_Column4: "เลขอ้างอิง Parent SKU",
    ISA_OrderImport_SP_Column6: "ราคาขาย",
    ISA_OrderImport_SP_Column8: "โค้ดส่วนลดชำระโดยผู้ขาย",
    ISA_OrderImport_SP_Column9: "โค้ดส่วนลดชำระโดย Shopee",
    ISA_OrderImport_TT_Column1: "Order ID",
    ISA_OrderImport_TT_Column2: "Order Status",
    ISA_OrderImport_TT_Column3: "Seller SKU",
    ISA_OrderImport_TT_Column4: "Product Name",
    ISA_OrderImport_TT_Column6: "SKU Unit Original Price",
    ISA_OrderImport_TT_Column7: "SKU Seller Discount",
    ISA_OrderImport_TT_Column8: "Shipping Fee Platform Discount",
    ISA_OrderImport_TT_Column9: "Created Time",
    ISA_OrderLog_Column5: "PO",
    ISA_OrderLog_Column9: "ERPCustomer",
    ISA_OrderUnit: "OrderUnit",
    ISA_Packsize1: "Packsize1",
    ISA_Packsize2: "Packsize2",
    ISA_Packsize3: "Packsize3",
    ISA_Packsize4: "Packsize4",
    ISA_ParentCustomerCode: "ParentCustomerCode",
    ISA_ParentLookupCode: "ParentLookupCode",
    ISA_ParentLookupType: "ParentLookupType",
    ISA_PeriodType: "PeriodType",
    ISA_PlantName: "PlantName",
    ISA_PlantNo: "PlantNo",
    ISA_PORef: "PORef",
    ISA_PostDateCheque: "PostDateCheque",
    ISA_PostDateChequeAmount: "PostDateChequeAmount",
    ISA_PostDateChequeDate: "PostDateChequeDate",
    ISA_productPrice5: "ราคา 5",
    ISA_ProductSetCode: "ProductSetCode",
    ISA_ProvinceCode: "ProvinceCode",
    ISA_ProvinceDescription: "ProvinceDescription",
    ISA_ReasonCode: "ReasonCode",
    ISA_ReasonDescription: "ReasonDescription",
    ISA_RecordType: "RecordType",
    ISA_RemarkText: "RemarkText",
    ISA_SalesQuantity: "SalesQuantity",
    ISA_Section1: "Section1",
    ISA_Section2: "Section2",
    ISA_ShipAmount: "ShipAmount",
    ISA_ShipQty: "ShipQty",
    ISA_SO: "SO",
    ISA_SODate: "SODate",
    ISA_SOItemNo: "SOItemNo",
    ISA_SortOrder: "SortOrder",
    ISA_TargetAmount: "TargetAmount",
    ISA_TargetAmt: "TargetAmt",
    ISA_TargetMonth: "TargetMonth",
    ISA_TargetQty: "TargetQty",
    ISA_TargetQuan: "TargetQuan",
    ISA_TargetType: "TargetType",
    ISA_TargetYear: "TargetYear",
    ISA_TaxInvNo: "TaxInvNo",
    ISA_TypeCode: "TypeCode",
    ISA_Unit1: "Unit1",
    ISA_Unit3: "Unit3",
    ISA_Unit4: "Unit4",
    ISA_VatRate: "VatRate",
    ISA_Warning_EffectiveTomorrow: "ข้อมูลจะเริ่มมีผล ตั้งแต่วันพรุ่งนี้",

    // ===== AP Transaction / AP Receipt / AppNotification / AdjustStock =====
    ISA_AdjStockDocRefNumber: "DocRefNumber",
    ISA_APTransaction: "ใบสำคัญรับเงิน",
    ISA_BillStatus: "BillStatus",
    ISA_FailMessageAddPurchase:
      "ไม่สามารถทำรายการได้ เนื่องจากท่านได้ทำการเลือกชำระเงินครบตามจำนวนที่ต้องชำระแล้ว สามารถทำรายการนี้ได้ ก็ต่อเมื่อยอดคงเหลือเกิน",
    ISA_Inv_Date: "Inv Date",
    ISA_Inv_No: "Inv No",
    ISA_Just_now: "เมื่อสักครู่",
    ISA_Pay_Confirm: "ยืนยันการชำระเงิน (AP)",
    ISA_Ref_Doc: "Ref Doc",
    ISA_Title_ConfirmCreateReceipt: "ยืนยันการชำระเงิน",

    // ===== Calendar365 =====
    ISA_Calendar_Events: "กิจกรรมปฏิทิน",
    ISA_USERS_CALENDARS: "ปฏิทินของผู้ใช้",
    ISA_Create_Event: "สร้างกิจกรรมปฏิทิน",
    ISA_add_Event: "เพิ่มกิจกรรม",

    // ===== DialogSelectProducFromSupplierSREC =====
    ISA_MaxPrefix: "สูงสุด",

    // ===== Permission / Product-master / ProductSelector / Prospect Keys =====
    ISA_Cost: "ต้นทุน",
    ISA_Cost1: "ต้นทุน 1",
    ISA_Cost2: "ต้นทุน 2",
    ISA_Cost3: "ต้นทุน 3",
    ISA_Cost4: "ต้นทุน 4",
    ISA_Actions: "การจัดการ",
    ISA_ConfirmDeleteProduct: "คุณแน่ใจหรือไม่ที่จะลบสินค้านี้?",
    ISA_SearchPlaceholder: "ค้นหา...",
    ISA_CheckPrice: "เช็คราคา",
    ISA_LoadingProductData: "กำลังโหลดข้อมูลสินค้า...",
    ISA_NewCustAddress2: "ที่อยู่เพิ่มเติม 2",
    ISA_NewCustAddress3: "ที่อยู่เพิ่มเติม 3",
    ISA_NewCustAddress4: "ที่อยู่เพิ่มเติม 4",
    ISA_NewCustAddress5: "ที่อยู่เพิ่มเติม 5",
    // DialogCheckPrice - Tab labels
    ISA_PriceHistory: "ประวัติราคา",
    ISA_PriceLevelTab: "ระดับราคา",
    ISA_QuotationTab: "เสนอราคา",
    ISA_CustomerPriceSetting: "กำหนดราคาลูกค้า",
    ISA_GroupPriceSetting: "กำหนดราคากลุ่ม",
    ISA_GroupCustomerPrice: "ราคาเฉพาะกลุ่มลูกค้า",
    // DialogCheckPrice - Column headers
    ISA_DiscountPerUnit: "ส่วนลด/หน่วย",
    ISA_QuotationNumber: "เลขที่ใบเสนอราคา",
    // DialogProductSelectorForm
    ISA_ProductDetailTitle: "รายละเอียดข้อมูลสินค้า",
    ISA_InvalidShipDate: "วันที่จัดส่งไม่ถูกต้อง",
    ISA_InvalidMFGDate: "วันที่ผลิตไม่ถูกต้อง",
    ISA_InvalidEXPDate: "วันหมดอายุไม่ถูกต้อง",
    // Unit labels
    // Additional keys for production
    ISA_WarehouseGood: "คลังดี",
    ISA_WarehouseBad: "คลังเสีย",
    ISA_ShowingFirst200: "(แสดง 200 รายการแรก)",
    ISA_DiscountItemStep: "ส่วนลดรายการ ขั้นที่",
    ISA_SupInvNumber: "เลขที่ Sup Invoice",
    ISA_PleaseSelectProduct: "กรุณาเลือกสินค้าก่อน",
    // New keys for i18n support
    ISA_APPayment: "การชำระเงิน (AP)",
    // Confirmation dialogs
    ISA_Cancelled: "ยกเลิกแล้ว",
    ISA_UnsavedDataDiscarded: "ข้อมูลที่ยังไม่ได้บันทึกจะถูกยกเลิก",
    // === Auto-generated keys (2026-01-28) ===
    ISA_FilterMarketPlace: "พื้นที่ขาย",
    ISA_Filter_AllCustomerTypes: "ทั้งหมด (ลูกค้าหน้าบัญชี + ผู้มุ่งหวัง)",
    ISA_APIConnectionError: "เกิดข้อผิดพลาดในการเชื่อมต่อ API",
    ISA_ChangeDate: "เปลี่ยนวันที่",
    ISA_KILEYBROWNEXAMPLECOM: "kiley.brown@example.com",
    ISA_WebPage: "เว็บไซต์",
    ISA_EXAMPLECOM: "example.com",
    ISA_AddDeliveryLocation: "เพิ่มสถานที่จัดส่ง",
    ISA_LocationCode: "รหัสสถานที่",
    ISA_Coordinates: "ตำแหน่งพิกัด",
    ISA_Longitude: "ลองจิจูด",
    ISA_Button_Save: "บันทึก",
    ISA_EditDeliveryLocation: "แก้ไขสถานที่จัดส่ง",
    ISA_Button_AddLocation: "เพิ่มสถานที่",
    ISA_Button_Retry: "ลองใหม่",
    ISA_Order: "ใบสั่งซื้อ",
    ISA_ByOrder: "รายครั้ง",
    ISA_DeliveryCycle: "รอบการส่ง",
    ISA_StockMultiplier: "จำนวนเท่าสต๊อค",
    ISA_CustomerAccountCustomerType: "ประเภทลูกค้า",
    ISA_CustomerAccountCreditLimit: "วงเงินเครดิต",
    ISA_EditAdjustStock: "แก้ไขปรับปรุงสต็อก",
    ISA_AUTO_WELCOME: "ยินดีต้อนรับ",
    ISA_AUTO_HAVE_A_NICE_DAY: "ขอให้เป็นวันที่ดี",
    ISA_AUTO_PLAN: "แผน",
    ISA_AUTO_ACTUAL: "จริง",
    ISA_AUTO_REMAINING: "คงเหลือ",
    ISA_Msg_PleaseProvideReason: "กรุณาระบุเหตุผลในการไม่อนุมัติ",
    ISA_Msg_ConfirmApprove: "ต้องการอนุมัติรายการนี้ ใช่หรือไม่?",
    ISA_ExpenseSummaryReport: "รายงานสรุปค่าใช้จ่าย",
    /** คอลัมน์ยอดใน PDF รายงานสรุปค่าใช้จ่าย — ตามแบบ ICM ต้นฉบับ */
    ISA_ExpenseSummaryPdfAmountColumn: "จำนวนเงิน",
    ISA_TotalExpenseItems: "จำนวนค่าใช้จ่ายทั้งหมด",
    ISA_Reason_IncompleteDoc: "เอกสารไม่ครบถ้วน",
    ISA_Reason_IncorrectAmount: "จำนวนเงินไม่ถูกต้อง",
    ISA_Reason_NotInPolicy: "ไม่อยู่ในนโยบายบริษัท",
    ISA_Reason_UnclearInfo: "ข้อมูลไม่ชัดเจน",
    ISA_CopiedFrom: "คัดลอกจาก",
    ISA_Msg_ConfirmCopyDocument: "ต้องการคัดลอกเอกสาร รายการนี้ ใช่หรือไม่ ?",
    ISA_DeleteDocument: "ลบข้อมูลเอกสาร",
    ISA_Msg_ConfirmDeleteWarning: "หากคุณยืนยันลบเอกสารแล้ว",
    ISA_Msg_PleaseSelectExpenseType: "กรุณาเลือกค่าใช้จ่ายก่อนดำเนินการ",
    ISA_UpdateDataSuccess: "อัปเดตข้อมูลสำเร็จ!",
    ISA_CannotFetchDocNumber: "ไม่สามารถดึงเลขที่เอกสารได้ กรุณาลองอีกครั้ง",
    ISA_PleaseEnterCompleteInfo: "กรุณากรอกข้อมูลให้ครบถ้วน",
    ISA_PleaseSelectAtLeastOneExpense: "กรุณาเลือกค่าใช้จ่ายอย่างน้อย 1 รายการ",
    ISA_SaveFailed: "บันทึกไม่สำเร็จ",
    ISA_AddExpenseSummary: "เพิ่มรายการ สรุปค่าใช้จ่าย",
    ISA_LoadingDocNumber: "กำลังโหลดเลขที่เอกสาร...",
    ISA_PleaseSelectDateRange: "กรุณาเลือกช่วงวันที่เพื่อแสดงกิจกรรม",
    ISA_PleaseSelectDateRangeForExpense:
      "กรุณาเลือกช่วงวันที่เพื่อแสดงข้อมูลค่าใช้จ่าย",
    ISA_Msg_StatusUpdateSuccess: "อัปเดตสถานะสำเร็จ",
    ISA_Msg_StatusUpdateError: "เกิดข้อผิดพลาดในการอัปเดตสถานะ",
    ISA_Msg_PleaseSelectItemsToChangeStatus:
      "กรุณาเลือกรายการที่ต้องการเปลี่ยนสถานะ",
    ISA_Msg_PleaseEnterRejectReason: "กรุณาระบุเหตุผลในการไม่อนุมัติ:",
    ISA_Msg_ConfirmChangeStatus: "คุณต้องการเปลี่ยนสถานะเป็น",
    ISA_For: "สำหรับ",
    ISA_Msg_CopyDocSuccess: "คัดลอกเอกสารสำเร็จ!",
    ISA_NewDocNumber: "เลขที่เอกสารใหม่",
    ISA_CopiedExpenseItems: "คัดลอกรายการค่าใช้จ่าย",
    ISA_Msg_CopyDocFailed: "ไม่สามารถคัดลอกเอกสารได้ กรุณาลองใหม่อีกครั้ง",
    ISA_ExpenseReport: "รายงานค่าใช้จ่าย",
    ISA_Selected: "เลือกแล้ว",
    ISA_Msg_NoExpenseData: "ไม่มีข้อมูลค่าใช้จ่ายให้แสดง",
    ISA_Msg_PleaseEnterRemark: "กรุณาระบุหมายเหตุ",
    ISA_Msg_NoAttachment: "ไม่มีไฟล์แนบ",
    ISA_Msg_ApprovalError: "เกิดข้อผิดพลาดในการอนุมัติ",
    ISA_Files: "ไฟล์",
    ISA_TotalVisit: "รายการ เข้าเยี่ยมทั้งหมด",
    ISA_TotalMemo: "รายการ บันทึกเข้าเยี่ยมทั้งหมด",
    ISA_SelectStatus: "เลือกสถานะ...",
    ISA_SelectExpenseType: "เลือกประเภทค่าใช้จ่าย...",
    ISA_AUTO_BODY_TEXT: "เนื้อหาข้อความ",
    ISA_Please_Select_PostCode: "กรุณาเลือกหรือกรอกรหัสไปรษณีย์",
    ISA_Please_Select_Customer_Type: "กรุณาเลือกประเภทลูกค้า",
    ISA_Please_Select_MarketPlace: "กรุณาเลือก MarketPlace",
    ISA_Please_Select_Country: "กรุณาเลือกประเทศ",
    ISA_ProspectCountry: "ประเทศ",
    ISA_Please_Select_Province: "กรุณาเลือกจังหวัด",
    ISA_Please_Select_District: "กรุณาเลือกอำเภอ/เขต",
    ISA_UpdateProspect: "อัพเดทข้อมูลลูกค้าใหม่",
    ISA_ErrorNoDocumentToUpdate: "ไม่มีเอกสารที่ต้องอัปเดตสถานะ",
    ISA_ErrorUpdateDocumentFailed: "อัปเดตเอกสารไม่สำเร็จ",
    ISA_SuccessUpdateDocument: "อัปเดตเอกสารสำเร็จ",
    ISA_PickingList: "Picking List",
    ISA_PickListSelectedCannotExport: "เอกสารที่เลือกไว้ Export Picking List ไม่ได้",
    ISA_PickListSkippedDocuments: "เอกสารที่ไม่ได้ Export Picking List",
    ISA_PickListReasonNotWaiting: "ไม่ใช่สถานะรอจัดของ",
    ISA_PickListReasonNoItems: "ไม่มีรายการสินค้าในเอกสาร จึงไม่มีอะไรให้จัด",
    ISA_PickListReasonChanged: "สถานะเปลี่ยนไปแล้ว หรือไม่อยู่ในเงื่อนไขค้นหาปัจจุบัน กรุณาค้นหาใหม่",
    ISA_SelectedDocumentsNotFound: "เอกสารที่เลือกไว้ไม่อยู่ในผลการค้นหาแล้ว กรุณาค้นหาใหม่แล้วเลือกอีกครั้ง",
    ISA_MultipleApprove: "อนุมัติหลายรายการ",
    ISA_DocEditOrder: "แก้ไขใบขาย",
    ISA_ConfirmApproveMessage: "คุณต้องการอนุมัติเอกสารที่เลือกหรือไม่?",
    ISA_TotalDocuments: "จำนวนเอกสาร",
    ISA_TitlePickingList: "การอนุมัติรอจัดของ",
    ISA_ApprovalPickingList: "รอจัดของ",
    ISA_ReportType_AllPlant: "รวมคลัง",
    ISA_ReportType_ByPlant: "แยกคลัง",
    ISA_ReportMovementType_In: "Stock In",
    ISA_ReportMovementType_Return: "Stock Return",
    ISA_ReportMovementType_Adjust: "Stock Adjust",
    ISA_ReportType_UnitSmall: "หน่วยเล็ก",
    ISA_ReportType_UnitLarge: "หน่วยใหญ่",
    ISA_StockAgingSummary: "สรุปอายุสต๊อกสินค้า",
    ISA_ClickEyeToFilter: "คลิกปุ่มตาเพื่อกรองข้อมูล",
    ISA_Within30Days: "ไม่เกิน 30 วัน",
    ISA_Within60Days: "ไม่เกิน 60 วัน",
    ISA_Over60Days: "เกิน 60 วัน",
    ISA_StockAgingDetail: "รายละเอียดอายุสินค้าคงคลัง",
    ISA_DownloadCSV: "ดาวน์โหลด CSV",
    ISA_ConfirmQuestion: "หรือไม่",
    ISA_ReqDocCreateTime: "DocCreateTime",
    ISA_WEEKLY_SALES: "ยอดขายรายสัปดาห์",
    ISA_TEAM_SALE: "ทีมขาย",
    ISA_QTD: "QTD",
    ISA_MTD: "MTD",
    ISA_AVG: "ค่าเฉลี่ย",
    ISA_Msg_PleaseApproveAgain: "กรุณาอนุมัติแผนใหม่อีกครั้ง",
    ISA_Msg_CannotAccessCalendar: "ไม่สามารถเข้าถึงข้อมูลปฏิทินได้",
    ISA_Msg_OutlookCalendarFailed: "พบแผนที่เพิ่มลง Outlook Calendar ไม่สำเร็จ",
    ISA_Msg_GoogleCalendarFailed: "พบแผนที่เพิ่มลง Google Calendar ไม่สำเร็จ",
    ISA_MAP_CANNOT_BE_LOADED_RIGHT_NOW_SORRY:
      "ไม่สามารถโหลดแผนที่ได้ในขณะนี้ ขออภัย",
    ISA_YouHaveConfiguredEmail: "คุณได้ตั้งค่าอีเมล์",
    ISA_DoYouWantToUpdateTo: "ไว้แล้ว ต้องการอัพเดทเป็น",
    ISA_DoYouWantToUpdateGmail: "คุณต้องการอัพเดต Gmail ในระบบ จาก",
    ISA_DoYouWantToUpdateCalendar: "คุณต้องการอัพเดต Calendar ในระบบ จาก",
    ISA_LoginCancelled: "การเข้าสู่ระบบถูกยกเลิก",
    ISA_CannotOpenLoginPopup:
      "ไม่สามารถเปิดหน้าต่างเข้าสู่ระบบได้ กรุณาอนุญาต popup",
    ISA_CannotLogin: "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง",
    ISA_CannotGetPermission:
      "ไม่สามารถรับสิทธิ์การใช้งานได้ กรุณาเข้าสู่ระบบอีกครั้ง",
    ISA_CannotAccessCalendar:
      "ไม่สามารถเข้าถึงข้อมูลปฏิทินได้ กรุณาเข้าสู่ระบบใหม่",
    ISA_NoCalendarPermission: "ไม่มีสิทธิ์เข้าถึงปฏิทิน กรุณาติดต่อผู้ดูแลระบบ",
    ISA_CannotLoadCalendar: "ไม่สามารถโหลดข้อมูลปฏิทินได้ กรุณาลองใหม่อีกครั้ง",
    ISA_DataLoadError: "เกิดข้อผิดพลาดในการโหลดข้อมูล กรุณาลองใหม่อีกครั้ง",
    ISA_PleaseSpecifyEmail: "กรุณาระบุอีเมล์",
    ISA_INVALID_EMAIL_FORMAT: "รูปแบบอีเมลไม่ถูกต้อง",
    ISA_ConfigEmailAndCalendarSuccess: "ตั้งค่าอีเมล์และปฏิทินเรียบร้อยแล้ว",
    ISA_Customer_ShipTo: "Ship To",
    ISA_AllContacts: "ผู้ติดต่อทั้งหมด",
    ISA_SelectProject: "เลือกโครงการ",
    ISA_SelectContact: "เลือกผู้ติดต่อ",
    ISA_NoLatLongData: "ไม่มีข้อมูล lat/long",
    ISA_PleaseFillTodoListOfCustomer: "กรุณากรอก TodoList ของลูกค้า",
    ISA_PleaseCheckAndApprove: "กรุณาตรวจสอบและอนุมัติด้วย",
    ISA_CannotLoadRecommendedCustomers:
      "ไม่สามารถโหลดข้อมูลลูกค้าแนะนำได้ กรุณาลองใหม่อีกครั้ง",
    ISA_NoCustomerWithCoordinates: "ไม่พบลูกค้าที่มีพิกัดในแผนที่เลือกแล้ว",
    ISA_AIRecommendSystem: "ระบบแนะนำลูกค้าเพื่อวางแผนการเยี่ยม",
    ISA_Plan: "แผน",
    ISA_HideRecommendedMap: "ซ่อนแผนที่แนะนำ",
    ISA_RecommendedMap: "แผนที่แนะนำ",
    ISA_AISelecting: "AI กำลังเลือก...",
    ISA_AIHelpSelect: "AI ช่วยเลือก",
    ISA_AvgAmount: "ยอดเฉลี่ย",
    ISA_LastVisit: "เยี่ยมล่าสุด",
    ISA_NoRecommendedCustomer: "ไม่พบข้อมูลลูกค้าที่แนะนำ",
    ISA_LoadingFromCache: "กำลังโหลดข้อมูลจาก cache...",
    ISA_WaitCycle: "รอรอบ",
    ISA_ShowPerPage: "แสดงต่อหน้า",
    ISA_FirstPage: "หน้าแรก",
    ISA_PreviousPage: "หน้าก่อนหน้า",
    ISA_NextPage: "หน้าถัดไป",
    ISA_LastPage: "หน้าสุดท้าย",
    ISA_SelectedCustomers: "ลูกค้าที่เลือกแล้ว",
    ISA_NoSelectedCustomer: "ไม่มีลูกค้าที่เลือก",
    ISA_HideSelectedMap: "ซ่อนแผนที่เลือก",
    ISA_SelectedMap: "แผนที่เลือก",
    ISA_PleaseSelectCustomerFromLeft: "กรุณาเลือกลูกค้าจากรายการแนะนำด้านซ้าย",
    ISA_CustomerInPlanAlready: "ลูกค้าที่มีในแผนเข้าเยี่ยมแล้ว",
    ISA_AlreadyInPlan: "มีในแผนแล้ว",
    ISA_SelectedAmount: "ยอดที่เลือก",
    ISA_RecommendedCustomerMap: "แผนที่ลูกค้าที่แนะนำ",
    ISA_NotYetSelected: "ยังไม่เลือก",
    ISA_Confirmed: "ยืนยันแล้ว",
    ISA_OrderCycleReached: "ถึงรอบในการสั่งซื้อตามรอบเฉลี่ยแล้ว",
    ISA_NoRecommendedProductData: "ไม่มีข้อมูลสินค้าที่แนะนำ",
    ISA_Row: "แถวที่",
    ISA_PleaseSelectVisitDate: "กรุณาเลือกวันที่เยี่ยม",
    ISA_PleaseSelectStartTime: "กรุณาเลือกเวลาเริ่มต้น",
    ISA_PleaseSelectEndTime: "กรุณาเลือกเวลาสิ้นสุด",
    ISA_ConfirmSaveData: "ยืนยันการบันทึกข้อมูล",
    ISA_DoYouWantToSaveVisitPlan: "คุณต้องการบันทึกแผนการเยี่ยมลูกค้า",
    ISA_UnspecifiedItem: "รายการที่ยังไม่ได้ระบุชื่อ",
    ISA_AddVisitPlan: "เพิ่มแผนการเยี่ยม",
    ISA_FillVisitDetailsForSelectedCustomers:
      "กรอกรายละเอียดการเยี่ยมสำหรับลูกค้าที่เลือก",
    ISA_VisitPlanInfo: "ข้อมูลแผนการเยี่ยม",
    ISA_VisitDateMustBeInRange: "วันที่เข้าเยี่ยมต้องอยู่ในช่วงนี้",
    ISA_CustomerVisitDetails: "รายละเอียดการเยี่ยมลูกค้า",
    ISA_AddNewCustomer: "เพิ่มลูกค้าใหม่",
    ISA_SyncOptions: "ตัวเลือกการซิงค์ข้อมูล",
    ISA_SameDateForAll: "วันเดียวกันทั้งหมด",
    ISA_SameTimeForAll: "เวลาเดียวกันทั้งหมด",
    ISA_SyncDescription:
      "เมื่อเลือกแล้ว การเปลี่ยนวันที่หรือเวลาของลูกค้าคนใดคนหนึ่งจะส่งผลให้ลูกค้าคนอื่น ๆ เปลี่ยนตามด้วย",
    ISA_CannotSelectPastDate: "ไม่สามารถเลือกวันที่ในอดีตได้",
    ISA_PleaseSelectDate: "กรุณาเลือกวันที่",
    ISA_VisitFromTime: "เยี่ยม(ตั้งแต่)",
    ISA_VisitTo: "เยี่ยม(ถึง)",
    ISA_SelectedCustomer: "ลูกค้าที่เลือก",
    ISA_NotYetSelectedCustomer: "ยังไม่ได้เลือกลูกค้า",
    ISA_EnterAdditionalNote: "กรอกหมายเหตุเพิ่มเติม (ถ้ามี)",
    ISA_Saving: "กำลังบันทึก...",
    ISA_CannotCreateBackdatedPlan: "ไม่สามารถสร้างแผนย้อนหลังได้",
    ISA_VisitDateMustBeWithinPlanDate:
      "วันที่เข้าเยี่ยมต้องอยู่ระหว่างวันที่ของแผนการเข้าเยี่ยม",
    ISA_AI: "AI ช่วยในการสร้างแผนเข้าเยี่ยม",
    ISA_ShowAllDaysInPlan: "แสดงทุกวันในช่วงแผน",
    ISA_CustomerWithCoordinates: "ลูกค้าที่มีพิกัด",
    ISA_ShowOnlyCustomerWithCoordinates: "แสดงเฉพาะลูกค้าที่มีพิกัดเท่านั้น",
    ISA_NoCustomerWithCoordinatesInPlan: "ไม่พบลูกค้าที่มีพิกัดในแผน",
    ISA_Msg_CannotImportPlan: "ไม่สามารถ Import แผนได้",
    ISA_SalesManagerAreaSalesman: "หัวหน้าทีมขาย / เขตการขาย / พนักงานขาย",
    ISA_CustomerGroupCodeProvinceType:
      "กลุ่มลูกค้า / รหัสลูกค้า / จังหวัด / ประเภทลูกค้า",
    ISA_ValueBySalesman: "มูลค่าตามพนักงานขาย",
    ISA_ProjectCount: "จำนวนโครงการ",
    ISA_CannotCancelProject: "ไม่สามารถยกเลิกโครงการได้",
    ISA_NoProjectData: "ไม่พบข้อมูลโครงการ",
    ISA_CustomerVisit: "การเยี่ยมลูกค้า",
    ISA_ProjectDetails: "รายละเอียดโครงการ",
    ISA_ContactInfo: "ข้อมูลติดต่อ",
    ISA_Photos: "รูปภาพ",
    ISA_LoadingPipelineData: "กำลังโหลดข้อมูล Pipeline หลัก...",
    ISA_PipelineDataLoaded: "โหลดข้อมูล Pipeline เสร็จแล้ว",
    ISA_LoadingStatsAndCharts: "กำลังโหลดข้อมูลสถิติและกราฟ...",
    ISA_ProcessingChartData: "กำลังประมวลผลข้อมูลกราฟ...",
    ISA_PreparingDisplay: "กำลังจัดเตรียมการแสดงผล...",
    ISA_LoadingComplete: "โหลดข้อมูลเสร็จสมบูรณ์",
    ISA_CreateContact: "สร้างผู้ติดต่อ",
    ISA_Title: "คำนำหน้า",
    ISA_Message_InvalidCloseDate: "วันที่ปิดโครงการไม่ถูกต้อง",
    ISA_EditProject: "แก้ไขโครงการ",
    ISA_GetLocation: "พิกัด",
    ISA_ProductDetail: "รายละเอียดสินค้า",
    ISA_UploadImage: "Upload รูปภาพ",
    ISA_AUTO_RENAME_TITUDE: "ละติจูด:",
    ISA_AUTO_RENAME_GITUDE: "ลองจิจูด:",
    ISA_NoDataContact: "ไม่มีข้อมูลผู้ติดต่อ",
    ISA_SAGNumber: "SAG Number",
    ISA_ROA: "อนุมัติอัตโนมัติ",
    ISA_RESERVED: "จองไว้",
    ISA_ERP: "ERP",
    ISA_AUTO_RENAME_PHOTOS: "รูปถ่าย",
    ISA_ErrorMissingProjectID: "ไม่พบ ProjectID",
    ISA_SendLineNotify: "ส่งข้อความแจ้งเตือน Line",
    ISA_TABLE: "ตาราง",
    ISA_SHOW_LAST_YEAR: "แสดงปีก่อน",
    ISA_Region: "ภาค",
    ISA_Status_Waiting: "รอดำเนินการ",
    ISA_Repeat_N: "No Repeat",
    ISA_Repeat_W: "Week Day ทุกๆ (S,M,T,W,TH,F,S)",
    ISA_Repeat_D: "Date (ทุกๆวันที่)",
    ISA_Message_EmptyStartDate: "กรุณาเลือกวันที่เริ่มเข้าเยี่ยม",
    ISA_Message_EmptyEndDate: "กรุณาเลือกวันที่สิ้นสุดการเข้าเยี่ยม",
    ISA_VisitPlanRepeat: "Repeat",
    ISA_EditVisitPlan: "แก้ไขแผนการเข้าเยี่ยม",
    ISA_IMPORT: "อีเมล์และปฏิทินสำหรับการ import แผน",
    ISA_DEFAULT_TO_DO_LIST: "Default To Do List",
    ISA_NO_IMAGE: "ไม่มีรูปภาพ",
    ISA_CountCheckInActual: "นับ Check-In ตามจริง",
    ISA_CountCheckInOncePerDay: "นับ Check-In ซ้ำต่อวันนับ 1",
    ISA_NoVisitAsPlanned: "ไม่เข้าเยี่ยมตามแผน",
    ISA_NotYetDueVisit: "ยังไม่ถึงกำหนดเข้าเยี่ยม",
    ISA_CalculateDistanceAvoidTolls: "คำนวณระยะทางไม่ขึ้นทางด่วน",
    ISA_VisitMemoDate: "วันที่รายงาน",
    ISA_CustomerContactNameAndPosition: "ชื่อผู้ติดต่อ(ตำแหน่ง)",
    ISA_TodoList: "To Do List",
    ISA_CannotMeasureDistance: "ไม่สามารถวัดระยะทางได้",
    ISA_VisitMemoReport: "รายงานบันทึกเข้าเยี่ยม",
    ISA_Exporting: "กำลังส่งออก...",
    ISA_Sorry: "ขออภัย",
    ISA_Found: "พบ",
    ISA_LoadMore: "โหลดเพิ่มเติม",
    ISA_CustomerNotFound: "ไม่พบลูกค้า",
    ISA_NoCustomerMatchSearch: "ไม่พบลูกค้าที่ตรงกับ",
    ISA_UnknownCustomer: "ไม่ทราบชื่อลูกค้า",
    ISA_SaveDocSuccessButItemsError:
      "บันทึกเอกสารสำเร็จ แต่เกิดข้อผิดพลาดในการบันทึกรายการสินค้า",
    ISA_PleaseCreateDocNumberFirst: "กรุณาสร้างเลขที่เอกสารก่อนแนบไฟล์",
    ISA_CreateStockCount: "สร้างเอกสารนับสต๊อก",
    ISA_EnterWarehouse: "ระบุคลังสินค้า",
    ISA_UserInfo: "ข้อมูลผู้ใช้งาน",
    ISA_UnknownUser: "ไม่ทราบชื่อผู้ใช้",
    ISA_LOT_NO: "Lot No.",
    ISA_ConfirmSaveEditMessage: "ต้องการบันทึกการแก้ไขนี้ใช่หรือไม่ ?",
    ISA_PleaseEnterWarehouse: "กรุณาระบุคลังสินค้า",
    ISA_PleaseHaveDocNumberFirst: "กรุณามีเลขที่เอกสารก่อนแนบไฟล์",
    ISA_CannotLoadProductData: "ไม่สามารถโหลดข้อมูลสินค้าได้",
    ISA_EditStockCountDocument: "แก้ไขเอกสารนับสต๊อก",
    ISA_Saved: "บันทึกแล้ว",
    ISA_ButtonDeleteSelected: "ลบรายการที่เลือก",
    ISA_PleaseEnterLotNo: "กรุณากรอก Lot Number",
    ISA_PleaseSelectMFGDate: "กรุณาเลือกวันที่ผลิต",
    ISA_PleaseSelectEXPDate: "กรุณาเลือกวันหมดอายุ",
    ISA_EditProduct: "แก้ไขสินค้า",
    ISA_ButtonCard: "Card",
    ISA_CannotLoadHistory: "ไม่สามารถดึงข้อมูลประวัติการแก้ไขได้",
    ISA_NoHistoryData: "ไม่มีข้อมูลประวัติ",
    ISA_LogFile: "Log File",
    ISA_DocumentHistory: "ประวัติการแก้ไขเอกสาร",
    ISA_SomeFilesUploadFailed: "บางไฟล์อัปโหลดไม่สำเร็จ",
    ISA_AttachmentFor: "Attachment for",
    // === Auto-generated keys (2026-01-28) ===
    ISA_PleaseEnterFirstName: "กรุณากรอกชื่อจริง",
    ISA_PleaseEnterLastName: "กรุณากรอกนามสกุล",
    ISA_PleaseEnterEmail: "กรุณากรอกอีเมล",
    ISA_InvalidEmailFormat: "รูปแบบอีเมลไม่ถูกต้อง",
    ISA_EmailFormat: "รูปแบบอีเมล",
    ISA_PleaseEnterPassword: "กรุณากรอกรหัสผ่าน",
    ISA_PasswordMinLength: "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    ISA_PasswordLength: "รหัสผ่าน (ความยาว)",
    ISA_PleaseConfirmPassword: "กรุณายืนยันรหัสผ่าน",
    ISA_PasswordNotMatch: "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน",
    ISA_PasswordMismatch: "รหัสผ่านไม่ตรงกัน",
    ISA_PleaseEnterCompany: "กรุณากรอก บริษัท/องค์กร",
    ISA_PleaseEnterPhoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
    ISA_RegisterTrialSuccess: "ลงทะเบียนใช้งาน Trial สำเร็จ",
    ISA_RegisterTrialSuccessMsg:
      "ท่านสามารถเข้าใช้งาน Application iSmartsales CRM ได้ระยะเวลา 14 วัน",
    ISA_RegisterTrialDownloadApp:
      "สามารถคลิ๊ก download app เพื่อเริ่มทดลองการใช้งาน (เราจะส่ง Username และ Password ให้ทางอีเมล์ที่คุณลงทะเบียน)",
    ISA_RegisterTrialSuccessWithNotSendEmail:
      "ลงทะเบียนใช้งาน Trial สำเร็จ แต่ไม่สามารถส่งอีเมลยืนยันได้!",
    ISA_Register: "ลงทะเบียน",
    // === Auto-generated keys with fallback (2026-01-28) ===
    ISA_CustomerGroup: "กลุ่มลูกค้า",
    ISA_Error_TooLong: "ข้อมูลยาวเกินไป",
    ISA_Error_InvalidCompany: "บริษัท/องค์กรไม่ถูกต้อง",
    ISA_SelectFromMap: "เลือกจากแผนที่",
    ISA_AddDeliveryLocationSuccess: "เพิ่มสถานที่จัดส่งสำเร็จ",
    ISA_EditDeliveryLocationSuccess: "แก้ไขสถานที่จัดส่งสำเร็จ",
    ISA_GeolocationError: "เกิดข้อผิดพลาดในการดึงตำแหน่ง",
    ISA_GeolocationNotSupported: "ไม่รองรับการระบุตำแหน่ง",
    ISA_GoogleMapsUrl: "วาง Link จาก Google Maps",
    ISA_InvalidGoogleMapsUrl: "ไม่สามารถอ่านพิกัดจาก URL ได้ กรุณาตรวจสอบ URL",
    ISA_InvalidCoordinates: "พิกัดไม่ถูกต้อง",
    ISA_PleaseEnterLatLong: "กรุณากรอกละติจูดและลองจิจูด",
    ISA_CoordinatesOutOfRange: "พิกัดอยู่นอกช่วงที่ถูกต้อง",
    ISA_InputModeUrl: "URL",
    ISA_ClickMapToSelect: "คลิกแผนที่เพื่อเลือก",
    ISA_SearchBy: "ค้นหาโดย:",
    ISA_SelectedLocation: "ตำแหน่งที่เลือก",
    ISA_GetCurrentLocation: "รับตำแหน่งปัจจุบัน",
    ISA_AddBillToLocation: "เพิ่มพิกัด BillTo",
    ISA_EditBillToLocation: "แก้ไขพิกัด BillTo",
    ISA_Error_DeleteFailed: "ลบข้อมูลล้มเหลว",
    ISA_Alert_DeleteLocation: "ยืนยันการลบสถานที่",
    ISA_DeleteDeliveryLocationSuccess: "ลบสถานที่จัดส่งสำเร็จ",
    ISA_Msg_ConfirmDeleteDocuments: "ต้องการลบเอกสารที่เลือกหรือไม่?",
    ISA_ExpenseSummary: "สรุปค่าใช้จ่าย",
    ISA_ViewOnMap: "ดูบนแผนที่",
    ISA_ReportOrderTransactionPickList: "รายงานรายการสั่งซื้อ (Picking List)",
    ISA_ErrorInvalidDocumentStatus: "สถานะเอกสารไม่ถูกต้อง",
    ISA_ErrorCannotSelectDocument: "ไม่สามารถเลือกเอกสารนี้ได้",
    ISA_PleaseSelectCustomerFor: "กรุณาเลือกลูกค้าสำหรับ",
    ISA_VisitDateMustBeBetween: "วันที่เข้าเยี่ยมต้องอยู่ระหว่าง",
    ISA_PleaseFillTodoListOf: "กรุณากรอก TodoList ของ",
    ISA_DateMustNotExceed: "วันที่ต้องไม่เกิน",
    ISA_0_1: "{0} {1}",
    ISA_GMAIL_0_1: "Gmail: {0} {1}",
    ISA_CALENDAR_0_1: "ปฏิทิน: {0} {1}",
    ISA_Message_Warning: "คำเตือน",
    ISA_SalesmanCode: "รหัสพนักงานขาย",
    ISA_VistitDetail: "รายละเอียดการเข้าเยี่ยม",
    ISA_ClickAddProductToStart: "กดเพิ่มสินค้าเพื่อเริ่มต้น",
    // === Auto-generated keys with fallback (2026-01-28) ===
    ISA_ReceiveQtyExceedLimit: "จำนวนรับเกินกำหนด",
    ISA_Msg_ReceiveQtyCannotExceed: "จำนวนรับไม่สามารถเกิน",
    ISA_PleaseEnterReceiveQty: "กรุณาระบุจำนวนรับสำหรับสินค้าที่เลือก",
    ISA_ReturnQtyExceedLimit: "จำนวนคืนเกินกำหนด",
    ISA_Msg_CannotExceedPendingReturn:
      "ไม่สามารถกรอกจำนวนแจ้งคืน เกินกว่าจำนวนค้างคืนได้",
    ISA_FilterSupplierType: "ประเภทผู้จำหน่าย",
    ISA_Button_Confirm: "สร้างใบแจ้งหนี้",
    ISA_ProductQuan: "จำนวนที่สั่งซื้อ",
    ISA_VAT_7_PERCENT_2: "VAT (7%)",
    ISA_DocNumberInv: "เลขที่ใบกำกับภาษี",
    ISA_CannotChangeCustomer: "ไม่สามารถเปลี่ยนลูกค้าได้",
    ISA_MustDeleteProductsFirst:
      "คุณต้องลบสินค้าทั้งหมดออกจากรายการก่อน จึงจะสามารถเปลี่ยนลูกค้าได้",
    ISA_ProductsInList: "สินค้าในรายการ",
    ISA_AutoGenerated: "ระบบสร้างอัตโนมัติ",
    ISA_VatType: "เลือกประเภท VAT",
    ISA_DocumentProductList: "รายการขายสินค้า",
    ISA_ReportOrderTransactionDetail: "รายละเอียดรายการสั่งซื้อ",
    ISA_SELECTED_ROWS: "เลือกแล้ว:",
    ISA_CheckStock: "ตรวจสอบสต็อก",
    ISA_ManufactureDate: "วันผลิต",
    ISA_NoStockDataFound: "ไม่พบข้อมูลสต็อก",
    ISA_AllProductListTitle: "รายการสินค้าทั้งหมด",
    ISA_SearchProductPlaceholder:
      "ค้นหาสินค้า (ชื่อสินค้า, รหัสสินค้า, กลุ่มสินค้า)",
    ISA_ButtonProductFav: "สินค้าใช้งานบ่อย",
    ISA_AUTO_NEW_SUCCESS: "สำเร็จ!",
    ISA_DocStatus_Rejected: "ถูกปฏิเสธ",
    ISA_ConfirmCopyTitle: "ยืนยันการคัดลอก",
    ISA_ConfirmCopyText: "คุณต้องการคัดลอกเอกสารนี้หรือไม่?",
    ISA_CopySuccess: "คัดลอกเอกสารเรียบร้อยแล้ว",
    ISA_CopyFailed: "ไม่สามารถคัดลอกเอกสารได้",
    ISA_ReportReturnTransaction: "ใบคืนสินค้า",
    ISA_ReportReturnTransactionDetail: "รายละเอียดใบคืนสินค้า",
    ISA_PleaseEnterDocNumber: "กรุณาระบุเลขที่เอกสาร (Update Mode)",
    ISA_Msg_NoDataExport: "ไม่มีข้อมูลสำหรับ Export",
    ISA_Msg_PleaseCompleteDataBeforeRefPO:
      "กรุณากรอกข้อมูลให้ครบถ้วนก่อนอ้างอิงใบ PO",
    ISA_Msg_PleaseCompleteDataBeforeAddProduct:
      "กรุณากรอกข้อมูลให้ครบถ้วนก่อนเพิ่มรายการสินค้า",
    ISA_ConfirmEditSupInvoice: "คุณต้องการแก้ไขเลขที่ SUP INVOICE หรือไม่?",
    ISA_NotApproveDoc: "เอกสารนี้ไม่ได้รับการอนุมัติ",
    ISA_DocsCannotDelete: "เอกสารที่ไม่สามารถลบ",
    ISA_Msg_CannotDeleteDocStatus: "ไม่สามารถลบเอกสารที่มีสถานะนี้ได้",
    // Keys for AI and Import features
    ISA_AIRecommendFailed: "ไม่สามารถรับคำแนะนำจาก AI ได้ กรุณาลองใหม่อีกครั้ง",
    ISA_CannotConnectAIService:
      "ไม่สามารถเชื่อมต่อกับบริการ AI ได้ กรุณาตรวจสอบการเชื่อมต่อเครือข่าย",
    ISA_CannotConnectServiceProvider:
      "ไม่สามารถเชื่อมต่อผู้ให้บริการ เพื่อคำนวนระยะทางได้ในขณะนี้ กรุณาค้นหาใหม่อีกครั้ง",
    ISA_CloseNotification: "ปิดแจ้งเตือน",
    ISA_ErrorFromAIService: "เกิดข้อผิดพลาดจากบริการ AI",
    ISA_ServerReturnedError: "เซิร์ฟเวอร์ส่งกลับข้อผิดพลาด",
    ISA_NoSalesTeamLeaderData: "ไม่มีข้อมูลหัวหน้าทีมขาย",
    ISA_PleaseSearchAgain: "กรุณาค้นหาใหม่อีกครั้ง",
    ISA_VisitDateExceedLimit: "วันที่เข้าเยี่ยมควรไม่เกิน",
    // Keys for Import Visit Plan
    ISA_Import_PlanOfCustomer: "แผนของลูกค้า",
    ISA_Import_NoSequenceNumber: "ไม่ได้ใส่ลำดับที่",
    ISA_Import_PlanSequence: "แผนลำดับที่",
    ISA_Import_InvalidVisitDateFormat: "รูปแบบของวันที่เข้าเยี่ยมไม่ถูกต้อง",
    ISA_Import_InvalidStartTimeFormat:
      "รูปแบบของเวลาเข้าเยี่ยม(ตั้งแต่)ไม่ถูกต้อง",
    ISA_Import_InvalidEndTimeFormat: "รูปแบบของเวลาเข้าเยี่ยม(ถึง)ไม่ถูกต้อง",
    ISA_Import_InvalidLocationType:
      "ประเภทสถานที่ (LocationType) ต้องเป็น P, C, S หรือ B เท่านั้น",
    ISA_TaxInvoiceReceipt: "ใบกำกับภาษี/ใบเสร็จรับเงิน",
    ISA_AsAppropriate: "ตามความเหมาะสม",
    // RegisterTrial page
    ISA_RegisterPageTitle: "สมัครสมาชิกทดลองใช้",
    ISA_FillFormToRegister: "กรอกข้อมูลเพื่อสมัครสมาชิก",
    ISA_PleaseFixErrors: "กรุณาแก้ไขข้อผิดพลาดต่อไปนี้:",
    // === Additional keys for hardcode fixes ===
    ISA_VisitPlanTemplate: "แผนการทำงาน",
    // === DialogCreateInvoice keys ===
    ISA_ConfirmCreateInvoice: "ยืนยันการสร้างใบแจ้งหนี้",
    ISA_CreateInvoice: "สร้างใบแจ้งหนี้",
    ISA_CreatingInvoice: "กำลังสร้างใบแจ้งหนี้",
    // === LineNotification keys ===
    ISA_ApproveRequest: "อนุมัติคำขอ",
    // === DialogSendApprove keys ===
    ISA_LineID: "Line ID",

    // === SupplierReceiveTransaction Keys (unique only) ===
    ISA_ButtonSelectRemark: "ข้อความหมายเหตุ",
    // ISA_Quantity: "จำนวน", // REMOVED: Use ISA_Qty instead

    // === Container Error Messages ===
    ISA_CannotUseFeatureDueToError: "ไม่สามารถใช้งานได้ เนื่องจากเกิดข้อผิดพลาด",

    // === Missing Keys (used in code but not in I18n.js) ===
    ISA_AmountBeforeVAT: "จำนวนเงินก่อน VAT",
    ISA_Phone: "โทรศัพท์",
    ISA_TaxID: "เลขประจำตัวผู้เสียภาษี",
    ISA_PhoneFax: "โทร/แฟกซ์",
    ISA_ShipTo: "สถานที่จัดส่ง",
    ISA_ShipToName: "ชื่อสถานที่จัดส่ง",
    ISA_Status_Completed: "เรียบร้อย",
    ISA_Status_Rejected: "ไม่อนุมัติ",
    ISA_Status_Draft: "ฉบับร่าง",
    ISA_Status_WaitingApproval: "รออนุมัติ",
    ISA_Status_WaitingForDebt: "รอเก็บเงิน",
    ISA_Status_Wating: "รอดำเนินการ",
    ISA_ReceiveNumber: "เลขที่ Receive",
    ISA_SupplierDistributor: "ผู้จัดจำหน่าย",
    ISA_TotalAmount1: "จำนวนเงินรวม",
    ISA_ShowCustomer: "แสดงลูกค้า",
    ISA_DataWillShowWhenAPIReady: "ข้อมูลจะแสดงเมื่อ API พร้อม",
    ISA_DataNotFound: "ไม่พบข้อมูล",
    ISA_PleaseEnterInvoiceNumber: "กรุณากรอกเลขที่ใบแจ้งหนี้",
    ISA_ReceivedDate: "วันที่รับ",
    ISA_Recorder: "ผู้บันทึก",
    ISA_Recurrence: "รอบการทำซ้ำ",
    ISA_Manage: "จัดการ",
    ISA_Meeting: "ประชุม",
    ISA_Contact: "ติดต่อ",
    ISA_Employee: "พนักงาน",
    ISA_DeliveryLocation: "สถานที่จัดส่ง",
    ISA_DocNo: "เลขที่เอกสาร",
    ISA_DocReceiptInvoiceRef: "อ้างอิงใบเสร็จ/ใบแจ้งหนี้",
    ISA_CompanyName: "ชื่อบริษัท",
    ISA_CompanyAddress1: "ที่อยู่บริษัท 1",
    ISA_CompanyAddress2: "ที่อยู่บริษัท 2",
    ISA_AccountantAuthorized: "ผู้มีอำนาจลงนาม",
    ISA_TotalItems: "รวมรายการ",
    ISA_Undefined: "ไม่ระบุ",
    ISA_Unused: "ไม่ได้ใช้งาน",
    ISA_ConfirmDeleteMessage: "คุณต้องการลบรายการนี้หรือไม่?",
    ISA_UnsavedChangesWarning: "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    ISA_NoGoBack: "ไม่สามารถย้อนกลับได้",
    ISA_Msg_NoPermissionExport: "คุณไม่มีสิทธิ์ในการส่งออกข้อมูล",
    ISA_DefaultPosition: "ตำแหน่งเริ่มต้น",
    ISA_SupervisorManager: "หัวหน้า/ผู้จัดการ",
    ISA_VisitCustomer: "เข้าเยี่ยมลูกค้า",
    ISA_VisitMemo: "บันทึกการเข้าเยี่ยม",
    ISA_VisitRecord: "ประวัติการเข้าเยี่ยม",
    ISA_CustomerPODate: "วันที่ใบสั่งซื้อลูกค้า",
    ISA_PrepareSales: "เตรียมขาย",
    ISA_PriceBeforeVAT: "ราคาก่อน VAT",
    ISA_ImportCustomer: "นำเข้าลูกค้า",
    ISA_ExportOrder: "ส่งออกใบสั่งซื้อ",
    ISA_LatLongHint: "กรุณากรอกละติจูดและลองจิจูด",
    ISA_GoogleMapsUrlHintShort: "วาง URL จาก Google Maps",
    ISA_ExpenseType: "ประเภทค่าใช้จ่าย",
    ISA_ExpenseType_Entertainment: "ค่าเลี้ยงรับรอง",
    ISA_ExpenseRange: "ช่วงค่าใช้จ่าย",
    ISA_ExpenseRemarkDefault: "หมายเหตุค่าใช้จ่ายเริ่มต้น",
    ISA_TOTAL_COST: "ค่าใช้จ่ายรวม",
    ISA_ActionCreate: "สร้าง",
    ISA_ActionEdit: "แก้ไข",
    ISA_ActionDelete: "ลบ",
    ISA_ActionProcess: "ดำเนินการ",
    ISA_AnalysisbyCustomer: "วิเคราะห์ตามลูกค้า",
    ISA_AnalysisbyProduct: "วิเคราะห์ตามสินค้า",
    ISA_SalesAnalysisbyCustomer: "วิเคราะห์ยอดขายตามลูกค้า",
    ISA_SalesAnalysisbyProduct: "วิเคราะห์ยอดขายตามสินค้า",
    ISA_ApproveTime: "เวลาอนุมัติ",
    ISA_selection1: "เลือก 1",
    ISA_QN1: "คำถามที่ 1",
    ISA_QN2: "คำถามที่ 2",
    ISA_QN3: "คำถามที่ 3",
    ISA_QN4: "คำถามที่ 4",
    ISA_ReportReadingPeriod: "ช่วงเวลาการอ่านรายงาน",
    ISA_ReportInputTaxTitle: "รายงานภาษีซื้อ",
    ISA_ReportBillingDetailTotalDiscount: "รวมส่วนลดรายการ",
    ISA_ReportStockAgeing_LocationGood: "สินค้าดี",
    ISA_ReportStockAgeing_LocationBad: "สินค้าเสีย",
    ISA_Title_NumberOfProjectBySalesman: "จำนวนโครงการแยกตามพนักงานขาย",
    ISA_Title_ProjectValueBySalesman: "มูลค่าโครงการแยกตามพนักงานขาย",
    ISA_Title_TotalValue: "มูลค่ารวม",
    ISA_VRPField1: "ข้อมูลแผน 1",
    ISA_VRPField2: "ข้อมูลแผน 2",
    ISA_VRPSection2: "ส่วนที่ 2",
    ISA_AUTO_NEW_ERROR: "เกิดข้อผิดพลาดใหม่",
    ISA_BillStatus_Due: "ถึงกำหนด",
    ISA_BillStatus_Checking: "รอตรวจสอบ",
    ISA_BillStatus_Deposit: "มัดจำ",
    ISA_BillStatus_Paid: "ชำระแล้ว",

    // เมนู Salesman Master (พนักงานขาย + เขตการขาย)
    ISA_SalesmanMaster: "พนักงานขาย",
    ISA_SalesmanMasterKeyword: "รหัส / ชื่อพนักงานขาย",
    ISA_SalesmanMasterSelectCompanyFirst:
      "กรุณาเลือกบริษัทในตัวกรองก่อนเพิ่มข้อมูลพนักงานขาย",
    ISA_SalesmanMasterConfirmDeleteRow:
      "ต้องการลบข้อมูลพนักงานขายเฉพาะภาษานี้ใช่หรือไม่?",
    ISA_SalesmanMasterSyncNotice:
      "หัวหน้าทีมขาย / SalesOrg / Channel / เขตการขาย จะถูกปรับให้ตรงกันทุกภาษาของรหัสนี้เมื่อบันทึก",
    ISA_AddSalesman: "เพิ่มพนักงานขาย",
    ISA_EditSalesman: "แก้ไขพนักงานขาย",
    ISA_ViewSalesman: "ดูรายละเอียดพนักงานขาย",
    ISA_ParentSalesman: "หัวหน้าทีมขาย",
    ISA_ManageSalesArea: "จัดการเขตการขาย",
    ISA_AddSalesArea: "เพิ่มเขตการขาย",
    ISA_EditSalesArea: "แก้ไขเขตการขาย",
    ISA_ViewSalesArea: "ดูรายละเอียดเขตการขาย",
    ISA_SalesAreaCode: "รหัสเขตการขาย",
    ISA_SalesAreaName: "ชื่อเขตการขาย",
    ISA_SalesAreaKeyword: "รหัส / ชื่อเขตการขาย",
    ISA_SalesAreaConfirmDeleteRow:
      "ต้องการลบข้อมูลเขตการขายเฉพาะภาษานี้ใช่หรือไม่?",
    ISA_ValPleaseEnterSalesmanCode: "กรุณาระบุรหัสพนักงานขาย",
    ISA_ValPleaseEnterSalesmanName: "กรุณาระบุชื่อพนักงานขาย",
    ISA_ValParentSalesmanIsSelf: "หัวหน้าทีมขายต้องไม่เป็นรหัสเดียวกับตนเอง",
    ISA_ValParentSalesmanLoop: "โครงสร้างหัวหน้าทีมวนกลับมาหาตนเอง (Loop)",
    ISA_ValPleaseSelectSalesOrg: "กรุณาเลือก SalesOrg",
    ISA_ValPleaseSelectChannel: "กรุณาเลือก Channel",
    ISA_ValPleaseSelectSalesArea: "กรุณาเลือกเขตการขาย",
    ISA_ValSalesAreaNotFound: "ไม่พบเขตการขายนี้ในบริษัทที่เลือก",
    ISA_ValPleaseEnterSalesAreaCode: "กรุณาระบุรหัสเขตการขาย",
    ISA_ValPleaseEnterSalesAreaName: "กรุณาระบุชื่อเขตการขาย",
    ISA_ManageData: "การดำเนินการ",
    ISA_Language: "ภาษา",
    ISA_Select: "เลือก",
    ISA_None: "ไม่มี",
    ISA_Close: "ปิด",
    ISA_DateTime: "วันที่-เวลา",
    ISA_NoChange: "ไม่มีการเปลี่ยนแปลง",
    ISA_PleaseSelectCompany: "กรุณาเลือกบริษัท",
    ISA_CannotExportData: "ไม่สามารถ Export ข้อมูลได้",
    // ── หน้าวางแผนเส้นทางเข้าเยี่ยม (Salesman/RoutePlanner) ──────────────────
    ISA_Record: "ราย",
    ISA_RoutePlan_Title: "วางแผนเส้นทางเข้าเยี่ยม",
    ISA_RoutePlan_Salesman: "พนักงานขาย",
    ISA_RoutePlan_SelectSalesman: "เลือกพนักงานขาย",
    ISA_RoutePlan_PlanDate: "วันที่ตามแผน",
    ISA_RoutePlan_StopsInPlan: "ลูกค้าในแผน",
    ISA_RoutePlan_Usable: "พร้อมจัดเส้นทาง",
    ISA_RoutePlan_Skipped: "ยังใช้ไม่ได้",
    ISA_RoutePlan_Optimize: "จัดเส้นทางอัตโนมัติ",
    ISA_RoutePlan_NeedTwo: "ต้องมีลูกค้าที่ระบุพิกัดแล้วอย่างน้อย 2 ราย",
    ISA_RoutePlan_Summary: "ผลการจัดเส้นทาง",
    ISA_RoutePlan_Version: "เวอร์ชัน",
    ISA_RoutePlan_Distance: "ระยะทางรวม",
    ISA_RoutePlan_Duration: "เวลารวมทั้งวัน",
    ISA_RoutePlan_Cost: "ต้นทุนเดินทาง",
    ISA_RoutePlan_SavingPct: "ประหยัดระยะทาง",
    ISA_RoutePlan_SavingMoney: "ลดต้นทุนได้",
    ISA_RoutePlan_DistanceSource: "ที่มาของระยะทาง",
    ISA_RoutePlan_SkippedTitle: "ลูกค้าที่ยังนำเข้าแผนไม่ได้",
    ISA_RoutePlan_SkippedHelp:
      "รายการต่อไปนี้ถูกกันออกจากการคำนวณเส้นทาง เนื่องจากพิกัดไม่พร้อมใช้งาน",
    ISA_RoutePlan_Reason: "สาเหตุ",
    ISA_RoutePlan_Action: "ต้องทำอะไรต่อ",
    ISA_RoutePlan_StopOrder: "ลำดับการเข้าเยี่ยม",
    ISA_RoutePlan_Recalculate: "คำนวณต้นทุนใหม่",
    ISA_RoutePlan_DirtyHint:
      "ลำดับถูกแก้ไขแล้ว กด “คำนวณต้นทุนใหม่” เพื่อดูระยะทางและค่าใช้จ่ายที่อัปเดต",
    ISA_RoutePlan_Seq: "ลำดับ",
    ISA_RoutePlan_Eta: "เวลาโดยประมาณ",
    ISA_RoutePlan_Leg: "ระยะจากจุดก่อน",
    ISA_RoutePlan_Changed: "เทียบแผนเดิม",
    ISA_RoutePlan_DragHint: "ลากเพื่อสลับลำดับ",
    ISA_RoutePlan_Same: "เท่าเดิม",
    ISA_RoutePlan_Was: "เดิมอันดับ",
    ISA_RoutePlan_Map: "แผนที่เส้นทาง",
    ISA_RoutePlan_MapError:
      "โหลดแผนที่ไม่สำเร็จ กรุณาตรวจสอบ Google API Key ของบริษัท",
    ISA_RoutePlan_MapSkippedNote: "ลูกค้าที่พิกัดไม่พร้อมใช้งานจะไม่แสดงบนแผนที่",
    ISA_RoutePlan_LoadError: "โหลดแผนไม่สำเร็จ กรุณาลองใหม่",
    ISA_RoutePlan_OptimizeError: "จัดเส้นทางไม่สำเร็จ กรุณาลองใหม่",
    ISA_RoutePlan_ReorderError: "คำนวณใหม่ไม่สำเร็จ กรุณาลองใหม่",
    ISA_RoutePlan_CannotOptimize: "จัดเส้นทางไม่ได้",

    // จุดเริ่มต้นเส้นทาง + ลิงก์นำทาง
    ISA_RoutePlan_StartPoint: "จุดเริ่มต้นเส้นทาง",
    ISA_RoutePlan_SavedDepot: "จุดที่บันทึกไว้",
    ISA_RoutePlan_SelectDepot: "เลือกจุดเริ่มต้น",
    ISA_RoutePlan_NoDepot: "ยังไม่มีจุดเริ่มต้นที่บันทึกไว้",
    ISA_RoutePlan_OrPasteLink: "หรือวางลิงก์ Google Maps",
    ISA_RoutePlan_UseLink: "ใช้ลิงก์นี้",
    ISA_RoutePlan_PickOnMap: "ปักหมุดบนแผนที่",
    ISA_RoutePlan_PickOnMapActive: "คลิกตำแหน่งบนแผนที่…",
    ISA_RoutePlan_ReturnToStart: "กลับจุดเริ่มต้นเมื่อจบวัน",
    ISA_RoutePlan_SaveAsDepot: "บันทึกจุดนี้ไว้ใช้ครั้งหน้า",
    ISA_RoutePlan_StartUsing: "จะเริ่มจาก",
    ISA_RoutePlan_NoStartWarn:
      "ยังไม่ได้กำหนดจุดเริ่มต้น — ระบบจะเลือกจุดเริ่มที่ดีที่สุดจากลูกค้าในวันนั้นแทน ซึ่งมักประหยัดได้น้อยกว่ามาก",
    ISA_RoutePlan_LinkNoCoord: "อ่านพิกัดจากลิงก์นี้ไม่ได้ กรุณาตรวจสอบลิงก์",
    ISA_RoutePlan_LinkError: "เปิดลิงก์ไม่สำเร็จ กรุณาตรวจสอบลิงก์",
    ISA_RoutePlan_DepotNamePrompt: "ตั้งชื่อจุดเริ่มต้นนี้",
    ISA_RoutePlan_DepotSaveError: "บันทึกจุดเริ่มต้นไม่สำเร็จ",
    ISA_RoutePlan_FromLink: "จุดจากลิงก์ Google Maps",
    ISA_RoutePlan_PinnedOnMap: "จุดที่ปักบนแผนที่",
    ISA_RoutePlan_OpenInMaps: "เปิดใน Google Maps",
    ISA_RoutePlan_CopyLink: "คัดลอกลิงก์ส่งให้พนักงานขาย",
    ISA_RoutePlan_MapsSplitNote:
      "จุดแวะเยอะเกินที่ลิงก์เดียวรองรับ จึงแบ่งเป็นหลายช่วง ช่วงถัดไปเริ่มจากจุดสุดท้ายของช่วงก่อนหน้า",
    ISA_RoutePlan_MapStraightLineNote:
      "เส้นบนแผนที่นี้เป็นเส้นตรงเชื่อมจุด ไม่ใช่เส้นทางถนนจริง — กด “เปิดใน Google Maps” เพื่อดูเส้นทางถนนและนำทาง",

    // === ai-chat (ผู้ช่วย AI วิเคราะห์ยอดขาย + แดชบอร์ดของฉัน) ===
    ISA_AIChat_ErrTooManyRequests: "ถามถี่เกินไป กรุณารอสักครู่แล้วลองใหม่",
    ISA_AIChat_ErrNoPermission: "ไม่มีสิทธิ์ใช้งานฟีเจอร์นี้ — ติดต่อผู้ดูแลระบบ",
    ISA_AIChat_ErrQuotaExhausted:
      "โควตาการใช้งาน AI ของบริษัทหมดแล้ว กรุณาติดต่อผู้ดูแลระบบเพื่อขอเติมโควตา",
    ISA_AIChat_UpgradeEmailSubject: "ขออัปเกรดเป็นแพ็กเกจ Standard - ISB",
    ISA_AIChat_QuoteEmailSubject: "ขอใบเสนอราคา - {name} ({price} บาท / {tokens} token)",
    ISA_AIChat_TopUpDialogTitle: "เลือกแพ็กเกจเติมโควตา AI",
    ISA_AIChat_IncludesBonus: "(รวมโบนัส {pct}%)",
    ISA_AIChat_RequestQuote: "ขอใบเสนอราคา",
    ISA_AIChat_FreeQuotaWarningTitle: "โควตา AI ฟรีใกล้ครบแล้ว",
    ISA_AIChat_FreeQuotaWarningBody:
      "คุณใช้โควตา AI ฟรีใกล้ครบแล้ว! อัปเกรดเป็นแพ็กเกจ Standard เพื่อรับโควตา AI เพิ่มเติมทันที",
    ISA_AIChat_UpgradeToStandard: "อัปเกรดเป็น Standard",
    ISA_AIChat_BonusLowWarningTitle: "โควตา AI ใกล้หมดแล้ว",
    ISA_AIChat_BonusLowWarningBody:
      "โควตา AI ของบริษัทคุณ (รวม token ที่เติมไว้) เหลือน้อยกว่า 20% แล้ว — กรุณาเติมโควตาเพิ่มเพื่อใช้งานต่อเนื่องไม่สะดุด",
    ISA_AIChat_ViewTopUpPackages: "ดูแพ็กเกจเติมโควตา",
    ISA_AIChat_Unlimited: "ไม่จำกัดโควตา",
    ISA_AIChat_UsedSoFar: "ใช้ไปแล้ว",
    ISA_AIChat_ViewHistory: "ดูประวัติย้อนหลัง",
    ISA_AIChat_QuotaExhaustedBanner: "โควตาการใช้งาน AI ของบริษัทหมดแล้ว",
    ISA_AIChat_TopUp: "เติมโควตา",
    ISA_AIChat_UsedThisMonth: "เดือนนี้ใช้ไป",
    ISA_AIChat_BonusRemaining: "bonus คงเหลือ",
    ISA_AIChat_Used: "ใช้ไป",
    ISA_AIChat_NoHistoryYet:
      "ยังไม่มีประวัติเดือนที่ปิดรอบ (แสดงหลังผ่านไป 1 รอบบิลตั้งแต่ตั้งแพ็กเกจ)",
    ISA_AIChat_ChartQuotaLabel: "โควตาเดือนนั้น",
    ISA_AIChat_SaveAsFavourite: "บันทึกเป็น favourite",
    ISA_AIChat_Export: "Export Excel",
    ISA_AIChat_ExportFailed: "Export ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    ISA_AIChat_ExportNoPermission: "ไม่มีสิทธิ์ Export ข้อมูล",
    ISA_AIChat_TableRowCount: "{rows} แถว",
    ISA_AIChat_TableCappedWarn: "แสดง {shown} จาก {total} แถว",
    ISA_AIChat_TableToolLimitWarn:
      "แสดง {rows} แถว (ถึงจำนวนสูงสุดที่ดึงต่อครั้ง) อาจมีข้อมูลเพิ่ม — ระบุจำนวนที่ต้องการในคำถามเพื่อดูเพิ่ม",
    ISA_AIChat_SavedToDashboard: 'บันทึกไว้ใน "แดชบอร์ดของฉัน" แล้ว',
    ISA_AIChat_PromptFavouriteName: "ตั้งชื่อ favourite นี้:",
    ISA_AIChat_SaveFavouriteFailed: "บันทึก favourite ไม่สำเร็จ",
    ISA_AIChat_LoadHistoryFailed: "โหลดประวัติการใช้งานไม่สำเร็จ",
    ISA_AIChat_GenericError: "ขออภัย เกิดข้อผิดพลาด กรุณาลองใหม่",
    ISA_AIChat_PrivacyModeBadge: "โหมดปกป้องข้อมูล",
    ISA_AIChat_PrivacyModeTooltip:
      "ข้อมูลยอดขายของบริษัทไม่ถูกส่งออกไปยังผู้ให้บริการ AI ภายนอก",
    ISA_AIChat_PromptPrivacyNotice:
      "คำถามที่พิมพ์จะถูกส่งไปประมวลผลที่ผู้ให้บริการ AI ภายนอก — กรุณาอย่าพิมพ์ชื่อลูกค้าหรือข้อมูลลับลงในคำถาม",
    ISA_AIChat_PageTitle: "ผู้ช่วย AI วิเคราะห์ยอดขาย",
    ISA_AIChat_PageSubtitle:
      "ถามยอดขายรวม รายเดือน สินค้าขายดี หรือลูกค้ารายใหญ่ของบริษัทคุณได้เลย — ข้อมูลจำกัดเฉพาะเท่าที่บัญชีนี้เห็นในเว็บอยู่แล้ว",
    ISA_AIChat_EmptyStateHint: 'พิมพ์คำถามด้านล่างเพื่อเริ่มคุยกับ AI เช่น "ยอดขายเดือนนี้เท่าไร"',
    ISA_AIChat_Thinking: "กำลังคิดคำตอบ...",
    ISA_AIChat_InputPlaceholderExhausted:
      "โควตาหมดแล้ว — ติดต่อผู้ดูแลระบบเพื่อขอเติมโควตาก่อนถามต่อ",
    ISA_AIChat_InputPlaceholder: "พิมพ์คำถาม แล้วกด Enter เพื่อส่ง (Shift+Enter ขึ้นบรรทัดใหม่)",
    ISA_AIChat_Send: "ส่ง",
    ISA_AIChat_ChartDefaultValue: "ค่า",

    ISA_AIChatDashboard_NoData: "ไม่มีข้อมูลในช่วงที่บันทึกไว้",
    ISA_AIChatDashboard_LastUpdated: "อัปเดตล่าสุด",
    ISA_AIChatDashboard_Refresh: "รีเฟรช",
    ISA_AIChatDashboard_LoadDataFailed: "โหลดข้อมูลไม่สำเร็จ",
    ISA_AIChatDashboard_ConfirmDeleteQuestion: 'ลบ favourite "{name}" ?',
    ISA_AIChatDashboard_DeleteFailed: "ลบไม่สำเร็จ",
    ISA_AIChatDashboard_PageTitle: "แดชบอร์ดของฉัน",
    ISA_AIChatDashboard_PageSubtitle:
      'คำถามที่บันทึกไว้จากหน้า "ผู้ช่วย AI วิเคราะห์ยอดขาย" — กดรีเฟรชเพื่อดูข้อมูลล่าสุดได้ทุกเมื่อ',
    ISA_AIChatDashboard_EmptyState:
      'ยังไม่มี favourite — ไปที่หน้า "ผู้ช่วย AI วิเคราะห์ยอดขาย" แล้วกด "บันทึกเป็น favourite" ใต้คำตอบที่อยากเก็บไว้ดูซ้ำ',
    ISA_AIChatDashboard_LoadFavouritesFailed: "โหลดรายการ favourite ไม่สำเร็จ",
    // หน้าจัดการประเภทข้อความบันทึกเข้าเยี่ยม (ClientVisitMemoRemarkManagement · 2026-10-03)
    ISA_CVMR_TypeCode: "รหัสประเภท",
    ISA_CVMR_TypeText: "ประเภทข้อความ",
    ISA_CVMR_SearchLabel: "รหัส / ประเภทข้อความ",
    ISA_CVMR_ImportColumns: "ไม่สามารถนำเข้าได้ — หัวคอลัมน์ต้องเป็น ลำดับ, รหัส, ข้อความ, รหัสภาษา (ดาวน์โหลด Template ใหม่)",
    ISA_CVMR_ImportSuccess: "นำเข้าประเภทข้อความบันทึกเข้าเยี่ยมสำเร็จ",
    ISA_CVMR_ImportHint: "ไฟล์นำเข้าใช้คอลัมน์ ลำดับ, รหัส, ข้อความ, รหัสภาษา · เพิ่มหรือปรับปรุงตาม Company + รหัสประเภท + รหัสภาษา และเก็บรายการเดิมที่ไม่อยู่ในไฟล์ไว้",
    ISA_CVMR_NoPermissionDelete: "คุณไม่มีสิทธิ์ลบข้อมูล (DE)",
    ISA_CVMR_DeleteAllLinks: "ลบความสัมพันธ์ทั้งหมด",
    ISA_CVMR_DeleteReportNote: "คำอธิบายในรายงานบันทึกเข้าเยี่ยมเดิมอาจไม่แสดงหลังลบ",
    ISA_CVM_ShipToClearedTitle: "เปลี่ยนลูกค้าแล้ว",
    ISA_CVM_ShipToClearedText: "ล้างสถานที่จัดส่งที่เลือกไว้ กรุณาเลือกใหม่",
    ISA_CVMR_SortOrder: "ลำดับแสดงผล",
    ISA_CVMR_FallbackNote: "ใช้ภาษาหลัก (ไม่มีแถว {lang})",
    ISA_CVMR_FillNeedRights: "ต้องมีสิทธิ์ทั้งเพิ่ม (AD) และแก้ไข (ED)",
    ISA_CVMR_FillMissing: "เติมภาษาที่ยังไม่มีด้วยภาษาหลัก ({n} แถว)",
    ISA_CVMR_FillConfirm: "เพิ่มแถวภาษารองที่ยังไม่มี โดยคัดลอกข้อความภาษาหลัก · ไม่แตะคำแปลที่มีอยู่",
    ISA_CVMR_FillDone: "เติมแล้ว {n} แถว",
    ISA_CVMR_LanguageStatus: "สถานะภาษา",
    ISA_CVMR_LangAll: "ทุกสถานะ",
    ISA_CVMR_LangMissing: "ยังไม่มีบางภาษา",
    ISA_CVMR_LangComplete: "มีครบทุกภาษา",
    ISA_CVMR_MissingTitle: "ภาษารองที่ยังไม่มีแถว",
    ISA_CVMR_CodesCount: "{n} รหัส",
    ISA_CVMR_MissingHint: "ผู้ใช้ภาษานั้นจะเห็นภาษาหลักแทน",
    ISA_CVMR_ShowAll: "แสดงทั้งหมด",
    ISA_CVMR_ShowMissingOnly: "ดูเฉพาะรหัสที่ยังไม่ครบ",
    ISA_CVMR_AddTitle: "เพิ่มประเภทข้อความ",
    ISA_CVMR_TextsByLanguage: "ข้อความแต่ละภาษา",
    ISA_CVMR_MainIsSource: "ภาษาหลัก (LangId 1) เป็นต้นฉบับ · รหัสกับลำดับแสดงผลใช้ร่วมทุกภาษา · ติ๊ก \"ใช้ข้อความภาษาหลัก\" = บันทึกข้อความภาษาหลักให้ภาษานั้น",
    ISA_CVMR_MainLanguage: "ภาษาหลัก · ต้นฉบับ",
    ISA_CVMR_RowWillBeAdded: "ยังไม่มีแถว · จะเพิ่มตอนบันทึก",
    ISA_CVMR_RequiredText: "บังคับกรอก",
    ISA_CVMR_NeedAddRight: "ต้องมีสิทธิ์เพิ่ม (AD) เพื่อเพิ่มภาษานี้",
    ISA_CVMR_UseMainText: "ใช้ข้อความภาษาหลัก",
    ISA_CVMR_TypeTranslation: "พิมพ์คำแปล",
    ISA_CVMR_TextRequired: "กรอกข้อความทุกภาษา หรือติ๊ก \"ใช้ข้อความภาษาหลัก\"",
    ISA_CVMR_Reorder: "จัดลำดับการแสดงผล",
    ISA_CVMR_ReorderHint: "ลากจุด ⋮⋮ เพื่อย้าย · บันทึกแล้วเรียงเลข 1 ถึง {n} ใหม่ทุกภาษา",
    ISA_CVMR_SaveOrder: "บันทึกลำดับ",
    ISA_CVMR_OldOrder: "เดิม {n}",
    ISA_CVMR_OrderAuto: "รันต่อจากเดิมอัตโนมัติ",
    ISA_CVMR_ReorderShort: "จัดลำดับ",
    ISA_CVMR_OrderMoveByButton: "ย้ายตำแหน่งที่ปุ่ม \"จัดลำดับ\"",
    ISA_CVMR_OrderPending: "เดิมลำดับ {from} · มีผลเมื่อกด \"บันทึกรายการ\"",
    ISA_CVMR_OrderPendingOthers: "จัดลำดับรหัสอื่นใหม่ · มีผลเมื่อกด \"บันทึกรายการ\"",
    ISA_CVMR_ReorderHintPick: "ลากจุด ⋮⋮ เพื่อย้าย · ลำดับจะบันทึกเมื่อกด \"บันทึกรายการ\" ในหน้าต่างแก้ไข",
    ISA_CVMR_EditingThis: "กำลังแก้ไข",
    ISA_CVMR_SM_ModeAll: "ทุกคนเลือกได้",
    ISA_CVMR_SM_ModeAllSub: "{salesman}ทุกคนของบริษัท",
    ISA_CVMR_SM_ModeSome: "เลือกเฉพาะกลุ่ม",
    ISA_CVMR_SM_ModeSomeSub: "ตามองค์กรขาย และ / หรือ ช่องทาง",
    ISA_CVMR_SM_NoAxes: "ไม่มีข้อมูลองค์กรขาย / ช่องทางของบริษัทนี้ → ได้เฉพาะ \"ทุกคนเลือกได้\"",
    ISA_CVMR_SM_Hint: "ติ๊กช่องที่ต้องการให้เลือกได้ · กด**ชื่อองค์กรขาย**เพื่อเลือกทั้งแถว · กด**ชื่อช่องทาง**เพื่อเลือกทั้งคอลัมน์",
    ISA_CVMR_SM_Corner: "องค์กรขาย ↓ · ช่องทาง →",
    ISA_CVMR_SM_ColTitle: "เลือก / เอาออก ช่องทาง {ch} ทุกองค์กรขาย",
    ISA_CVMR_SM_RowTitle: "เลือก / เอาออก ทั้งองค์กรขาย {org}",
    ISA_CVMR_SM_CellNone: "ไม่มีพนักงานในคู่นี้",
    ISA_CVMR_SM_CellOn: "เลือกแล้ว · กดเพื่อเอาออก",
    ISA_CVMR_SM_CellOff: "กดเพื่อให้ {org} ช่องทาง {ch} เลือกได้",
    ISA_CVMR_SM_People: "{n} คน",
    ISA_CVMR_SM_ViewPeople: "ดูรายชื่อ ›",
    ISA_CVMR_SM_NotChosen: "ยังไม่ได้เลือก — ถ้าบันทึกตอนนี้ **ทุกคนจะเลือกได้**",
    ISA_CVMR_SM_SumTitle: "**คนที่จะเลือกหัวข้อนี้ได้** (อยู่กลุ่มใดกลุ่มหนึ่งก็เลือกได้)",
    ISA_CVMR_SM_WhyRow: "เลือกครบทุกช่องทางของ {org} จึงนับเป็นทั้งองค์กรขาย รวมช่องทางที่จะเพิ่มในอนาคต",
    ISA_CVMR_SM_WhyCol: "เลือกช่องทาง {ch} ครบทุกองค์กรขาย จึงนับเป็นทั้งช่องทาง รวมองค์กรขายที่จะเพิ่มในอนาคต",
    ISA_CVMR_SM_Orphan: "ตอนนี้ยังไม่มีพนักงานในกลุ่มนี้ (เก็บสิทธิ์ไว้ให้)",
    ISA_CVMR_SM_RemoveRule: "เอากลุ่มนี้ออก",
    ISA_CVMR_SM_Total: "รวม **{n}** คน (ไม่นับซ้ำ)",
    ISA_CVMR_SM_DlgTitle: "{salesman}ที่เลือกหัวข้อนี้ได้ · {n} คน",
    ISA_CVMR_SM_DlgSearch: "ค้นหาชื่อ / รหัส / องค์กรขาย / ช่องทาง",
    ISA_CVMR_SM_DlgPhoto: "รูป",
    ISA_CVMR_SM_DlgName: "ชื่อ (รหัส)",
    ISA_CVMR_SM_DlgOrg: "องค์กรขาย",
    ISA_CVMR_SM_DlgCh: "ช่องทาง",
    ISA_CVMR_SM_DlgNote: "หมายเหตุ",
    ISA_CVMR_SM_DlgEmpty: "ไม่พบ",
    ISA_CVMR_SM_DlgFoot: "สิทธิ์ดูจากองค์กรขายและช่องทางของ{salesman}ในใบบันทึก ไม่ใช่ของผู้ที่ล็อกอิน",
    ISA_CVMR_SM_DlgClose: "ปิด",
    ISA_CVMR_SM_RuleEveryone: "ทุกคน",
    ISA_CVMR_SM_RuleOrg: "ทุกคนในองค์กรขาย {org}",
    ISA_CVMR_SM_RuleCh: "ทุกคนในช่องทาง {ch}",
    ISA_CVMR_SM_RulePair: "{org} เฉพาะช่องทาง {ch}",
    ISA_CVMR_WhoCanChoose: "ใครเลือกได้",
    ISA_CVMR_ScopeCellIntro: "พนักงานที่อยู่ในกลุ่มใดกลุ่มหนึ่งต่อไปนี้เลือกหัวข้อนี้ได้",
    ISA_CVMR_ScopeCellFooter: "แก้ได้ที่ปุ่มจัดการสิทธิ์การเข้าถึง",
    ISA_CVMR_ScopeCopy: "คัดลอกสิทธิ์จากหัวข้ออื่น",
    ISA_CVMR_ScopeCopyNone: "— ไม่คัดลอก —",
    ISA_CVMR_ScopeCopied: "คัดลอกแล้ว · ยังไม่บันทึกจนกว่าจะกดบันทึก",
    ISA_CVM_ChooseType: "เลือก{type}",
    ISA_CVM_ChooseTypeFirst: "เลือก{type}ก่อน",
    ISA_CVM_ChangeType: "เปลี่ยน{type}",
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LANG_SUCCESS:
      if (!action.payload || Object.keys(action.payload).length === 0) {
        return initialState;
      }
      return {
        ...state,
        translate: {
          ...initialState.translate,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
